var Ts = Object.defineProperty, Is = Object.defineProperties;
var Ds = Object.getOwnPropertyDescriptors;
var wn = Object.getOwnPropertySymbols;
var ks = Object.prototype.hasOwnProperty, Ms = Object.prototype.propertyIsEnumerable;
var On = (t, n, i) => n in t ? Ts(t, n, { enumerable: !0, configurable: !0, writable: !0, value: i }) : t[n] = i, kt = (t, n) => {
  for (var i in n || (n = {}))
    ks.call(n, i) && On(t, i, n[i]);
  if (wn)
    for (var i of wn(n))
      Ms.call(n, i) && On(t, i, n[i]);
  return t;
}, Gt = (t, n) => Is(t, Ds(n));
var Xi = (t, n, i) => new Promise((r, u) => {
  var c = (f) => {
    try {
      p(i.next(f));
    } catch (v) {
      u(v);
    }
  }, h = (f) => {
    try {
      p(i.throw(f));
    } catch (v) {
      u(v);
    }
  }, p = (f) => f.done ? r(f.value) : Promise.resolve(f.value).then(c, h);
  p((i = i.apply(t, n)).next());
});
import { defineComponent as gn, ref as Ue, computed as cn, watch as qi, shallowRef as As, nextTick as Ls } from "vue";
var Es = function() {
  var t = this, n = t.$createElement, i = t._self._c || n;
  return i("div", {
    staticClass: "ui-toggle"
  }, [i("input", {
    staticClass: "ui-toggle-button",
    attrs: {
      type: "checkbox",
      disabled: t.disabled
    },
    domProps: {
      checked: t.value
    },
    on: {
      change: t.handleChange
    }
  })]);
}, js = [];
function rt(t, n, i, r, u, c, h, p) {
  var f = typeof t == "function" ? t.options : t;
  n && (f.render = n, f.staticRenderFns = i, f._compiled = !0);
  var v;
  if (u && (v = u), v)
    if (f.functional) {
      f._injectStyles = v;
      var P = f.render;
      f.render = function(k, T) {
        return v.call(T), P(k, T);
      };
    } else {
      var x = f.beforeCreate;
      f.beforeCreate = x ? [].concat(x, v) : [v];
    }
  return {
    exports: t,
    options: f
  };
}
const Rs = {
  name: "UIToggle",
  props: {
    value: {
      type: Boolean,
      default: !0
    },
    disabled: {
      type: Boolean,
      default: !1
    }
  },
  emits: ["input"],
  methods: {
    handleChange({ target: t }) {
      this.disabled || this.$emit("input", t.checked);
    }
  }
}, Pn = {};
var Vs = /* @__PURE__ */ rt(
  Rs,
  Es,
  js,
  !1,
  Bs
);
function Bs(t) {
  for (let n in Pn)
    this[n] = Pn[n];
}
const Fs = /* @__PURE__ */ function() {
  return Vs.exports;
}();
var Ns = function() {
  var t = this, n = t.$createElement, i = t._self._c || n;
  return i("svg", t._g({ attrs: { xmlns: "http://www.w3.org/2000/svg", width: "16", height: "10", fill: "none", viewBox: "0 0 16 10" } }, t.$listeners), [i("path", { attrs: { stroke: "#000", "stroke-linecap": "round", "stroke-linejoin": "round", "stroke-width": "2", d: "M14.88 1 7.94 8.27 1 1" } })]);
};
const as = {
  render: Ns
}, Qe = {
  INITIAL: "initial",
  FOCUS: "focus",
  ERROR: "error",
  SUCCESS: "success"
}, yn = {
  props: {
    value: {
      type: [String, Number, Boolean],
      default: () => null
    },
    name: {
      type: String,
      default: () => ""
    },
    label: {
      type: String,
      default: () => ""
    },
    additionalClasses: {
      type: Array,
      default: () => []
    },
    inputClasses: {
      type: Array,
      default: () => []
    },
    labelClasses: {
      type: Array,
      default: () => []
    },
    errorClasses: {
      type: Array,
      default: () => []
    },
    outlined: {
      type: Boolean,
      default: () => !1
    },
    disabled: {
      type: Boolean,
      default: () => !1
    },
    rules: {
      type: [String, Object],
      default: () => ""
    },
    autocomplete: {
      type: String,
      default: () => "off"
    },
    isBlurDisallow: {
      type: Boolean,
      default: () => !1
    },
    uppercase: {
      type: Boolean,
      default: () => !1
    },
    capitalize: {
      type: Boolean,
      default: () => !1
    },
    capitalizeAll: {
      type: Boolean,
      default: () => !1
    },
    maxlength: {
      type: [String, Number],
      default: () => 1e3
    },
    numberInput: {
      type: Boolean,
      default: () => !1
    },
    maskPlaceholder: {
      type: String,
      default: () => ""
    },
    externalLabel: {
      type: Boolean,
      default: () => !1
    },
    inputmode: {
      type: String,
      default: () => "text"
    },
    revalidate: {
      type: Boolean,
      default: () => !1
    },
    errors: {
      type: Array,
      default: () => []
    },
    validationClasses: {
      type: String,
      default: () => ""
    },
    validationPassed: {
      type: Boolean,
      default: () => !1
    },
    validationFailed: {
      type: Boolean,
      default: () => !1
    }
  },
  data() {
    return {
      isFocused: !1,
      fieldState: Qe.INITIAL
    };
  },
  computed: {
    inputValue: {
      get() {
        return this.isBlurDisallow && (this.isFocused = !0), this.value;
      },
      set(t) {
        if (this.isFocused = !!t, typeof t == "boolean") {
          this.$emit("input", t);
          return;
        }
        const n = this.numberInput ? t.replace(/[^0-9]/g, "") : t;
        if (this.uppercase) {
          this.$emit("input", n.toUpperCase());
          return;
        }
        if (this.capitalize) {
          this.$emit("input", this.capitalizeString(n));
          return;
        }
        if (this.capitalizeAll) {
          this.$emit("input", this.capitalizeAllWord(n));
          return;
        }
        this.$emit("input", n);
      }
    },
    isRequiredField() {
      return this.rules ? typeof this.rules == "string" ? this.rules.includes("required") : Object.keys(this.rules).includes("required") : !1;
    }
  },
  watch: {
    value(t) {
      this.isFocused = !!t;
    }
  },
  methods: {
    focusHandler(t) {
      this.fieldState = Qe.FOCUS, this.isFocused = !0, this.$emit("focus", t);
    },
    blurHandler(t) {
      this.fieldState === Qe.FOCUS && (this.fieldState = Qe.INITIAL), this.inputValue || (this.isFocused = !1), this.$emit("blur", t);
    },
    capitalizeString(t) {
      return t.charAt(0).toUpperCase() + t.slice(1);
    },
    capitalizeAllWord(t) {
      return t.trim().toLowerCase().replace(/^([а-яё])|([\s-_|,.=+/\\?~!@#$%^&*()`])+([а-яё])/g, (i) => i.toUpperCase());
    },
    getCurrentFieldState({ passed: t, failed: n }) {
      return t && (this.fieldState = Qe.SUCCESS), n && (this.fieldState = Qe.ERROR), this.fieldState;
    }
  }
};
var Ys = function() {
  var t = this, n = t.$createElement, i = t._self._c || n;
  return i("div", {
    directives: [{
      name: "click-outside",
      rawName: "v-click-outside",
      value: function() {
        return t.isOptionsShown = !1;
      },
      expression: "() => isOptionsShown = false"
    }],
    class: ["ui-select--container", {
      "ui-select--disabled": t.disabled
    }],
    attrs: {
      tabindex: "0"
    },
    on: {
      keypress: function(r) {
        t.isOptionsShown = !0;
      }
    }
  }, [i("div", {
    class: ["ui-select", {
      open: t.isOptionsShown,
      outlined: t.outlined
    }],
    on: {
      keydown: t.onKeydownHandler,
      keyup: t.onKeyupHandler
    }
  }, [i("div", {
    class: ["ui-select-header", t.validationClasses],
    on: {
      click: function(r) {
        t.isOptionsShown = !t.isOptionsShown;
      }
    }
  }, [i("input", {
    directives: [{
      name: "model",
      rawName: "v-model.trim",
      value: t.searchValue,
      expression: "searchValue",
      modifiers: {
        trim: !0
      }
    }],
    class: ["ui-select-input", {
      "ui-select-input--outlined": t.outlined,
      "ui-select-input--focused": t.isOptionsShown,
      "ui-select-input--selected": t.searchValue,
      white: t.white
    }].concat(t.inputClasses, [t.validationClasses]),
    attrs: {
      id: `${t.name}_input`,
      name: t.name,
      type: "text",
      autocomplete: "off",
      readonly: !t.searchable,
      disabled: t.disabled
    },
    domProps: {
      value: t.searchValue
    },
    on: {
      focus: t.focusHandler,
      blur: [t.blurHandler, function(r) {
        return t.$forceUpdate();
      }],
      input: function(r) {
        r.target.composing || (t.searchValue = r.target.value.trim());
      }
    }
  }), t.placeholder ? i("label", {
    class: ["ui-select-placeholder", {
      open: t.isOptionsShown || t.inputValue || t.searchValue
    }],
    attrs: {
      for: `${t.name}_input`
    },
    domProps: {
      innerHTML: t._s(t.placeholder)
    },
    on: {
      click: function(r) {
        t.isOptionsShown = !0;
      }
    }
  }) : t._e(), i("ChevronSvg", {
    staticClass: "ui-select-chevron"
  })], 1), i("transition", {
    attrs: {
      name: "select"
    }
  }, [i("ul", {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: t.isOptionsShown,
      expression: "isOptionsShown"
    }],
    staticClass: "ui-select-options"
  }, t._l(t.filtredOptions, function(r, u) {
    return i("li", {
      key: `option__${u}`,
      ref: "options",
      refInFor: !0,
      class: ["ui-select-options__item", {
        "ui-select-options__item--disable": t.isEmptyOptions,
        "ui-select-options__item--active": u === t.optionIndex
      }],
      attrs: {
        tabindex: "0"
      },
      on: {
        click: function(c) {
          return t.onSelectHandler(r);
        },
        keypress: function(c) {
          return t.onSelectHandler(r);
        }
      }
    }, [i("p", [t._v(t._s(r))])]);
  }), 0)])], 1), i("span", {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: t.errors && t.errors[0],
      expression: "errors && errors[0]"
    }],
    staticClass: "ui-select-error"
  }, [t._v(" " + t._s(t.errors[0]) + " ")])]);
}, Hs = [];
const Us = {
  name: "UISelect",
  components: {
    ChevronSvg: as
  },
  mixins: [yn],
  props: {
    placeholder: {
      type: String,
      default: () => "Тема обращения*"
    },
    white: {
      type: Boolean,
      default: () => !0
    },
    searchable: {
      type: Boolean,
      default: () => !1
    },
    options: {
      type: Array,
      default: () => []
    },
    outlined: {
      type: Boolean,
      default: () => !1
    }
  },
  data() {
    return {
      isOptionsShown: !1,
      searchValue: "",
      optionIndex: 0,
      keyPressTimer: null
    };
  },
  computed: {
    filtredOptions() {
      const t = this.searchValue === this.inputValue ? this.options : this.options.filter((n) => n.toLowerCase().includes(this.searchValue.toLowerCase()));
      return t && t.length ? t : ["Нет совпадений"];
    },
    isEmptyOptions() {
      return this.filtredOptions.includes("Нет совпадений");
    }
  },
  watch: {
    inputValue: {
      immediate: !0,
      handler(t) {
        t !== this.searchValue && (this.searchValue = t);
      }
    },
    isOptionsShown: {
      handler(t) {
        var n;
        t && this.searchValue && (this.optionIndex = (n = this.filtredOptions) == null ? void 0 : n.findIndex((i) => i === this.searchValue), this.$nextTick(() => {
          this.focusOnCurrentOption();
        }));
      }
    }
  },
  mounted() {
    this.inputValue && (this.searchValue = this.inputValue);
  },
  beforeDestroy() {
    this.keyPressTimer && (clearTimeout(this.keyPressTimer), this.keyPressTimer = null);
  },
  methods: {
    onSelectHandler(t) {
      this.isEmptyOptions || (this.inputValue = t, this.searchValue = t, this.isOptionsShown = !1, this.$emit("selected", t));
    },
    onKeydownHandler(t) {
      if (!(!this.isOptionsShown || t.key === "Tab") && (t.preventDefault(), !this.keyPressTimer)) {
        switch (t.key) {
          case "ArrowUp":
            this.setPrevElemActive();
            break;
          case "ArrowDown":
            this.setNextElemActive();
            break;
          case "Enter":
            this.setOptionSelected();
            break;
          case "Escape":
            this.isOptionsShown = !1;
            break;
        }
        this.keyPressTimer = setTimeout(() => {
          this.keyPressTimer = null;
        }, 150);
      }
    },
    onKeyupHandler() {
      this.keyPressTimer && (clearTimeout(this.keyPressTimer), this.keyPressTimer = null);
    },
    setPrevElemActive() {
      this.optionIndex > 0 ? this.optionIndex-- : this.optionIndex = this.$refs.options.length - 1, this.focusOnCurrentOption();
    },
    setNextElemActive() {
      this.optionIndex < this.$refs.options.length - 1 ? this.optionIndex++ : this.optionIndex = 0, this.focusOnCurrentOption();
    },
    setOptionSelected() {
      this.onSelectHandler(this.filtredOptions[this.optionIndex]);
    },
    focusOnCurrentOption() {
      this.$refs.options[this.optionIndex].scrollIntoView({
        block: "nearest"
      });
    }
  }
}, Cn = {};
var zs = /* @__PURE__ */ rt(
  Us,
  Ys,
  Hs,
  !1,
  Ws
);
function Ws(t) {
  for (let n in Cn)
    this[n] = Cn[n];
}
const qs = /* @__PURE__ */ function() {
  return zs.exports;
}();
var Gs = function() {
  var t = this, n = t.$createElement, i = t._self._c || n;
  return i("div", {
    staticClass: "ui-radio"
  }, [t.title ? i("h5", {
    staticClass: "ui-radio__title"
  }, [t._v(" " + t._s(t.title) + " ")]) : t._e(), i("div", {
    class: ["ui-radio__group", {
      "ui-radio__group--horizontal": t.horizontal
    }]
  }, t._l(t.options, function(r, u) {
    return i("label", {
      key: u,
      staticClass: "ui-radio__group__input",
      attrs: {
        for: t.id + r.value
      }
    }, [i("input", {
      attrs: {
        id: t.id + r.value,
        name: t.id + r.value,
        type: "radio"
      },
      domProps: {
        value: r.value,
        checked: r.value === t.value
      },
      on: {
        change: function(c) {
          return t.onChangeHandler(r.value);
        }
      }
    }), i("span", {
      staticClass: "ui-radio__group__input--custom",
      class: {
        selected: r.value === t.value
      }
    }), i("span", [t._v(t._s(r.label))])]);
  }), 0)]);
}, Ks = [];
const Zs = {
  name: "UIRadio",
  props: {
    value: {
      type: [String, Boolean],
      required: !0
    },
    options: {
      type: Array,
      required: !0
    },
    title: {
      type: String,
      default: ""
    },
    id: {
      type: String,
      default: ""
    },
    horizontal: {
      type: Boolean,
      default: () => !1
    }
  },
  methods: {
    onChangeHandler(t) {
      this.$emit("input", t), this.$emit("change", t);
    }
  }
}, Tn = {};
var Xs = /* @__PURE__ */ rt(
  Zs,
  Gs,
  Ks,
  !1,
  Qs
);
function Qs(t) {
  for (let n in Tn)
    this[n] = Tn[n];
}
const Js = /* @__PURE__ */ function() {
  return Xs.exports;
}();
var tr = function() {
  var t = this, n = t.$createElement, i = t._self._c || n;
  return i("div", {
    staticClass: "ui-range-slider"
  }, [i("div", {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: t.show,
      expression: "show"
    }],
    ref: "wrap",
    class: ["vue-slider-component", t.flowDirection, t.disabledClass, t.stateClass, {
      "vue-slider-has-label": t.piecewiseLabel
    }],
    style: t.wrapStyles,
    on: {
      click: t.wrapClick
    }
  }, [i("div", {
    ref: "elem",
    staticClass: "vue-slider",
    style: [t.elemStyles, t.bgStyle],
    attrs: {
      "aria-hidden": "true"
    }
  }, [t.isRange ? [i("div", {
    ref: "dot0",
    class: [t.tooltipStatus, "vue-slider-dot", {
      "vue-slider-dot-focus": t.focusFlag && t.focusSlider === 0
    }],
    style: [t.dotStyles, t.sliderStyles[0], t.focusFlag && t.focusSlider === 0 ? t.focusStyles[0] : null],
    on: {
      mousedown: function(r) {
        return t.moveStart(r, 0);
      },
      touchstart: function(r) {
        return t.moveStart(r, 0);
      }
    }
  }, [i("span", {
    class: ["vue-slider-tooltip-" + t.tooltipDirection[0], "vue-slider-tooltip-wrap"]
  }, [t._t("tooltip", function() {
    return [i("span", {
      staticClass: "vue-slider-tooltip",
      style: t.tooltipStyles[0]
    }, [t._v(" " + t._s(t.formatter ? t.formatting(t.val[0]) : t.val[0]) + " ")])];
  }, {
    value: t.val[0],
    index: 0
  })], 2)]), i("div", {
    ref: "dot1",
    class: [t.tooltipStatus, "vue-slider-dot", {
      "vue-slider-dot-focus": t.focusFlag && t.focusSlider === 1
    }],
    style: [t.dotStyles, t.sliderStyles[1], t.focusFlag && t.focusSlider === 1 ? t.focusStyles[1] : null],
    on: {
      mousedown: function(r) {
        return t.moveStart(r, 1);
      },
      touchstart: function(r) {
        return t.moveStart(r, 1);
      }
    }
  }, [i("span", {
    class: ["vue-slider-tooltip-" + t.tooltipDirection[1], "vue-slider-tooltip-wrap"]
  }, [t._t("tooltip", function() {
    return [i("span", {
      staticClass: "vue-slider-tooltip",
      style: t.tooltipStyles[1]
    }, [t._v(" " + t._s(t.formatter ? t.formatting(t.val[1]) : t.val[1]) + " ")])];
  }, {
    value: t.val[1],
    index: 1
  })], 2)])] : [i("div", {
    ref: "dot",
    class: [t.tooltipStatus, "vue-slider-dot", {
      "vue-slider-dot-focus": t.focusFlag && t.focusSlider === 0
    }],
    style: [t.dotStyles, t.sliderStyles, t.focusFlag && t.focusSlider === 0 ? t.focusStyles : null],
    on: {
      mousedown: t.moveStart,
      touchstart: t.moveStart
    }
  }, [i("span", {
    class: ["vue-slider-tooltip-" + t.tooltipDirection, "vue-slider-tooltip-wrap"]
  }, [t._t("tooltip", function() {
    return [i("span", {
      staticClass: "vue-slider-tooltip",
      style: t.tooltipStyles
    }, [t._v(" " + t._s(t.formatter ? t.formatting(t.val) : t.val) + " ")])];
  }, {
    value: t.val
  })], 2)])], i("ul", {
    staticClass: "vue-slider-piecewise"
  }, t._l(t.piecewiseDotWrap, function(r, u) {
    return i("li", {
      key: u,
      ref: "piecewise-item",
      refInFor: !0,
      class: ["vue-slider-piecewise-item"].concat(r.classes),
      style: [t.piecewiseDotStyle, r.style],
      attrs: {
        "data-index": u
      }
    }, [t.piecewise ? i("span", {
      staticClass: "vue-slider-piecewise-dot",
      style: [t.piecewiseStyle, r.inRange ? t.piecewiseActiveStyle : null]
    }, [t._t("piecewise", null, {
      label: r.label,
      index: u,
      first: u === 0,
      last: u === t.piecewiseDotWrap.length - 1,
      active: r.inRange
    })], 2) : t._e(), t.piecewiseLabel ? i("span", {
      staticClass: "vue-slider-piecewise-label",
      style: [t.labelStyle, r.inRange ? t.labelActiveStyle : null]
    }, [t._t("label", null, {
      label: r.label,
      index: u,
      first: u === 0,
      last: u === t.piecewiseDotWrap.length - 1,
      active: r.inRange
    })], 2) : t._e()]);
  }), 0), i("div", {
    ref: "process",
    class: ["vue-slider-process", {
      "vue-slider-process-dragable": t.isRange && t.processDragable
    }],
    style: t.processStyle,
    on: {
      click: t.processClick,
      mousedown: function(r) {
        return t.moveStart(r, 0, !0);
      },
      touchstart: function(r) {
        return t.moveStart(r, 0, !0);
      }
    }
  })], 2), !t.isRange && !t.data ? i("input", {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: t.val,
      expression: "val"
    }],
    staticClass: "vue-slider-sr-only",
    attrs: {
      type: "range",
      name: t.fieldName,
      min: t.min,
      max: t.max,
      "aria-label": "Текущий прогресс выбора"
    },
    domProps: {
      value: t.val
    },
    on: {
      __r: function(r) {
        t.val = r.target.value;
      }
    }
  }) : t._e()])]);
}, er = [];
const ir = function() {
  const t = typeof window != "undefined" && window.devicePixelRatio || 1;
  return (n) => Math.round(n * t) / t;
}(), nr = {
  name: "UIRangeSlider",
  props: {
    width: {
      type: [Number, String],
      default: () => "auto"
    },
    height: {
      type: [Number, String],
      default: () => 2
    },
    data: {
      type: Array,
      default: () => null
    },
    dotSize: {
      type: Number,
      default: () => 26
    },
    dotWidth: {
      type: Number,
      default: () => 26
    },
    dotHeight: {
      type: Number,
      default: () => 26
    },
    min: {
      type: Number,
      default: () => 0
    },
    max: {
      type: Number,
      default: () => 100
    },
    interval: {
      type: Number,
      default: () => 1
    },
    show: {
      type: Boolean,
      default: () => !0
    },
    disabled: {
      type: Boolean,
      default: () => !1
    },
    piecewise: {
      type: Boolean,
      default: () => !1
    },
    tooltip: {
      type: [String, Boolean],
      default: () => !1
    },
    eventType: {
      type: String,
      default: () => "auto"
    },
    direction: {
      type: String,
      default: () => "horizontal"
    },
    reverse: {
      type: Boolean,
      default: () => !1
    },
    lazy: {
      type: Boolean,
      default: () => !1
    },
    clickable: {
      type: Boolean,
      default: () => !0
    },
    speed: {
      type: Number,
      default: () => 0.5
    },
    realTime: {
      type: Boolean,
      default: () => !1
    },
    stopPropagation: {
      type: Boolean,
      default: () => !1
    },
    value: {
      type: [String, Number, Array, Object],
      default: () => 0
    },
    piecewiseLabel: {
      type: Boolean,
      default: () => !0
    },
    debug: {
      type: Boolean,
      default: () => !0
    },
    fixed: {
      type: Boolean,
      default: () => !1
    },
    processDragable: {
      type: Boolean,
      default: () => !1
    },
    useKeyboard: {
      type: Boolean,
      default: () => !1
    },
    moveLinkByIndex: {
      type: Boolean,
      default: () => !1
    },
    actionsKeyboard: {
      type: Array,
      default() {
        return [(t) => t - 1, (t) => t + 1];
      }
    },
    sliderStyle: {
      type: [Array, Object, Function],
      default: () => null
    },
    focusStyle: {
      type: [Array, Object, Function],
      default: () => null
    },
    tooltipDir: {
      type: [Array, String],
      default: () => null
    },
    formatter: {
      type: [String, Function],
      default: () => ""
    },
    piecewiseStyle: {
      type: Object,
      default: () => null
    },
    piecewiseActiveStyle: {
      type: Object,
      default: () => null
    },
    processStyle: {
      type: Object,
      default: () => null
    },
    bgStyle: {
      type: Object,
      default: () => null
    },
    tooltipStyle: {
      type: [Array, Object, Function],
      default: () => null
    },
    labelStyle: {
      type: Object,
      default: () => null
    },
    labelActiveStyle: {
      type: Object,
      default: () => null
    },
    fieldName: {
      type: String,
      default: ""
    },
    stepSize: {
      type: [String, Number],
      default: () => ""
    }
  },
  data() {
    return {
      flag: !1,
      keydownFlag: null,
      focusFlag: !1,
      processFlag: !1,
      processSign: null,
      size: 0,
      fixedValue: 0,
      focusSlider: 0,
      currentValue: 0,
      currentSlider: 0,
      isComponentExists: !0
    };
  },
  computed: {
    dotWidthVal() {
      return typeof this.dotWidth == "number" ? this.dotWidth : this.dotSize;
    },
    dotHeightVal() {
      return typeof this.dotHeight == "number" ? this.dotHeight : this.dotSize;
    },
    flowDirection() {
      return `vue-slider-${this.direction + (this.reverse ? "-reverse" : "")}`;
    },
    tooltipDirection() {
      const t = this.tooltipDir || (this.direction === "vertical" ? "left" : "top");
      return Array.isArray(t) ? this.isRange ? t : t[1] : this.isRange ? [t, t] : t;
    },
    tooltipStatus() {
      return this.tooltip === "hover" && this.flag ? "vue-slider-always" : this.tooltip ? `vue-slider-${this.tooltip}` : "";
    },
    tooltipClass() {
      return [`vue-slider-tooltip-${this.tooltipDirection}`, "vue-slider-tooltip"];
    },
    isDisabled() {
      return this.eventType === "none" ? !0 : this.disabled;
    },
    disabledClass() {
      return this.disabled ? "vue-slider-disabled" : "";
    },
    stateClass() {
      return {
        "vue-slider-state-process-drag": this.processFlag,
        "vue-slider-state-drag": this.flag && !this.processFlag && !this.keydownFlag,
        "vue-slider-state-focus": this.focusFlag
      };
    },
    isRange() {
      return Array.isArray(this.value);
    },
    slider() {
      return this.isRange ? [this.$refs.dot0, this.$refs.dot1] : this.$refs.dot;
    },
    minimum() {
      return this.data ? 0 : this.min;
    },
    val: {
      get() {
        return this.data ? this.isRange ? [this.data[this.currentValue[0]], this.data[this.currentValue[1]]] : this.data[this.currentValue] : this.currentValue;
      },
      set(t) {
        if (this.data)
          if (this.isRange) {
            const n = this.data.indexOf(t[0]), i = this.data.indexOf(t[1]);
            n > -1 && i > -1 && (this.currentValue = [n, i]);
          } else {
            const n = this.data.indexOf(t);
            n > -1 && (this.currentValue = n);
          }
        else
          this.currentValue = t;
      }
    },
    currentIndex() {
      return this.isRange ? this.data ? this.currentValue : [
        (this.currentValue[0] - this.minimum) / this.spacing,
        (this.currentValue[1] - this.minimum) / this.spacing
      ] : (this.currentValue - this.minimum) / this.spacing;
    },
    indexRange() {
      return this.isRange ? this.currentIndex : [0, this.currentIndex];
    },
    maximum() {
      return this.data ? this.data.length - 1 : this.max;
    },
    multiple() {
      const [, t] = `${this.interval}`.split(".");
      return t ? Math.pow(10, t.length) : 1;
    },
    spacing() {
      return this.data ? 1 : this.interval;
    },
    total() {
      return this.data ? this.data.length - 1 : (Math.floor(
        (this.maximum - this.minimum) * this.multiple
      ) % (this.interval * this.multiple) !== 0 && this.printError("Prop[interval] is illegal, Please make sure that the interval can be divisible"), (this.maximum - this.minimum) / this.interval);
    },
    gap() {
      return this.size / this.total;
    },
    position() {
      return this.isRange ? [
        (this.currentValue[0] - this.minimum) / this.spacing * this.gap,
        (this.currentValue[1] - this.minimum) / this.spacing * this.gap
      ] : (this.currentValue - this.minimum) / this.spacing * this.gap;
    },
    limit() {
      return this.isRange ? this.fixed ? [
        [0, (this.maximum - this.fixedValue * this.spacing) / this.spacing * this.gap],
        [(this.minimum + this.fixedValue * this.spacing) / this.spacing * this.gap, this.size]
      ] : [[0, this.position[1]], [this.position[0], this.size]] : [0, this.size];
    },
    valueLimit() {
      return this.isRange ? this.fixed ? [
        [this.minimum, this.maximum - this.fixedValue * this.spacing],
        [this.minimum + this.fixedValue * this.spacing, this.maximum]
      ] : [[this.minimum, this.currentValue[1]], [this.currentValue[0], this.maximum]] : [this.minimum, this.maximum];
    },
    idleSlider() {
      return this.currentSlider === 0 ? 1 : 0;
    },
    wrapStyles() {
      return this.direction === "vertical" ? {
        height: typeof this.height == "number" ? `${this.height}px` : this.height,
        padding: `${this.dotHeightVal / 2}px 0`
      } : {
        width: typeof this.width == "number" ? `${this.width}px` : this.width,
        padding: `${this.dotHeightVal / 2}px 0`
      };
    },
    sliderStyles() {
      return Array.isArray(this.sliderStyle) ? this.isRange ? this.sliderStyle : this.sliderStyle[1] : typeof this.sliderStyle == "function" ? this.sliderStyle(this.val, this.currentIndex) : this.isRange ? [this.sliderStyle, this.sliderStyle] : this.sliderStyle;
    },
    focusStyles() {
      return Array.isArray(this.focusStyle) ? this.isRange ? this.focusStyle : this.focusStyle[1] : typeof this.focusStyle == "function" ? this.focusStyle(this.val, this.currentIndex) : this.isRange ? [this.focusStyle, this.focusStyle] : this.focusStyle;
    },
    tooltipStyles() {
      return Array.isArray(this.tooltipStyle) ? this.isRange ? this.tooltipStyle : this.tooltipStyle[1] : typeof this.tooltipStyle == "function" ? this.tooltipStyle(this.val, this.currentIndex) : this.isRange ? [this.tooltipStyle, this.tooltipStyle] : this.tooltipStyle;
    },
    elemStyles() {
      return this.direction === "vertical" ? {
        width: `${this.width}px`,
        height: "100%"
      } : {
        height: `${this.height}px`
      };
    },
    dotStyles() {
      return this.direction === "vertical" ? {
        width: `${this.dotWidthVal}px`,
        height: `${this.dotHeightVal}px`,
        left: `${-(this.dotWidthVal - this.width) / 2}px`
      } : {
        width: `${this.dotWidthVal}px`,
        height: `${this.dotHeightVal}px`,
        top: `${-(this.dotHeightVal - this.height) / 2}px`
      };
    },
    piecewiseDotStyle() {
      return this.direction === "vertical" ? {
        width: `${this.width}px`,
        height: `${this.width}px`
      } : {
        width: `${this.height}px`,
        height: `${this.height}px`
      };
    },
    piecewiseDotWrap() {
      if (!this.piecewise && !this.piecewiseLabel)
        return !1;
      const t = [];
      for (let n = 0; n <= this.total; n++) {
        const i = this.direction === "vertical" ? {
          bottom: `${this.gap * n - this.width / 2}px`,
          left: 0
        } : {
          left: `${this.gap * n - this.height / 2}px`,
          top: 0
        }, r = this.reverse ? this.total - n : n, u = this.data ? this.data[r] : this.spacing * r + this.min, c = (r + 1) % this.stepSize === 0 && ["marked"];
        t.push({
          style: i,
          classes: c,
          label: this.formatter ? this.formatting(u) : u,
          inRange: r >= this.indexRange[0] && r <= this.indexRange[1]
        });
      }
      return t;
    }
  },
  watch: {
    value(t) {
      this.flag || this.setValue(t, !0);
    },
    max(t) {
      if (t < this.min)
        return this.printError("The maximum value can not be less than the minimum value.");
      const n = this.limitValue(this.val);
      this.setValue(n), this.refresh();
    },
    min(t) {
      if (t > this.max)
        return this.printError("The minimum value can not be greater than the maximum value.");
      const n = this.limitValue(this.val);
      this.setValue(n), this.refresh();
    },
    show(t) {
      t && !this.size && this.$nextTick(() => {
        this.refresh();
      });
    },
    fixed() {
      this.computedFixedValue();
    }
  },
  mounted() {
    if (this.isComponentExists = !0, this.setExistedLabelClass(), typeof window == "undefined" || typeof document == "undefined")
      return this.printError("window or document is undefined, can not be initialization.");
    this.$nextTick(() => {
      this.isComponentExists && (this.getStaticData(), this.setValue(this.limitValue(this.value < 0 ? 0 : this.value), !0, 0), this.bindEvents());
    });
  },
  beforeDestroy() {
    this.isComponentExists = !1, this.unbindEvents();
  },
  methods: {
    setExistedLabelClass() {
      var n;
      const t = (n = this.$refs["piecewise-item"]) == null ? void 0 : n.reduce((i, r) => {
        var u;
        return (u = r == null ? void 0 : r.textContent) != null && u.trim() && i.push(r), i;
      }, []);
      t.length < 3 || t.forEach((i, r) => {
        ++r % 2 === 0 && i.classList.add("vue-slider-piecewise-item--exist");
      });
    },
    bindEvents() {
      document.addEventListener("touchmove", this.moving, { passive: !1 }), document.addEventListener("touchend", this.moveEnd, { passive: !1 }), document.addEventListener("mousedown", this.blurSlider), document.addEventListener("mousemove", this.moving), document.addEventListener("mouseup", this.moveEnd), document.addEventListener("mouseleave", this.moveEnd), document.addEventListener("keydown", this.handleKeydown), document.addEventListener("keyup", this.handleKeyup), window.addEventListener("resize", this.refresh);
    },
    unbindEvents() {
      document.removeEventListener("touchmove", this.moving), document.removeEventListener("touchend", this.moveEnd), document.removeEventListener("mousedown", this.blurSlider), document.removeEventListener("mousemove", this.moving), document.removeEventListener("mouseup", this.moveEnd), document.removeEventListener("mouseleave", this.moveEnd), document.removeEventListener("keydown", this.handleKeydown), document.removeEventListener("keyup", this.handleKeyup), window.removeEventListener("resize", this.refresh);
    },
    handleKeydown(t) {
      if (!this.useKeyboard || !this.focusFlag)
        return !1;
      switch (t.keyCode) {
        case 37:
        case 40:
          t.preventDefault(), this.keydownFlag = !0, this.flag = !0, this.changeFocusSlider(this.actionsKeyboard[0]);
          break;
        case 38:
        case 39:
          t.preventDefault(), this.keydownFlag = !0, this.flag = !0, this.changeFocusSlider(this.actionsKeyboard[1]);
          break;
      }
    },
    handleKeyup() {
      this.keydownFlag && (this.keydownFlag = !1, this.flag = !1);
    },
    changeFocusSlider(t) {
      if (this.isRange) {
        let n = this.currentIndex.map((i, r) => {
          if (r === this.focusSlider || this.fixed) {
            const u = t(i), c = this.fixed ? this.valueLimit[r] : [this.minimum, this.maximum];
            if (u <= c[1] && u >= c[0])
              return u;
          }
          return i;
        });
        n[0] > n[1] && (this.focusSlider = this.focusSlider === 0 ? 1 : 0, n = n.reverse()), this.setIndex(n);
      } else
        this.setIndex(t(this.currentIndex));
    },
    blurSlider(t) {
      const n = this.isRange ? this.$refs[`dot${this.focusSlider}`] : this.$refs.dot;
      if (!n || n === t.target)
        return !1;
      this.focusFlag = !1;
    },
    formatting(t) {
      return typeof this.formatter == "string" ? this.formatter.replace(/\{value\}/, t) : this.formatter(t);
    },
    getPos(t) {
      return this.realTime && this.getStaticData(), this.direction === "vertical" ? this.reverse ? t.pageY - this.offset : this.size - (t.pageY - this.offset) : this.reverse ? this.size - (t.clientX - this.offset) : t.clientX - this.offset;
    },
    processClick(t) {
      this.fixed && t.stopPropagation();
    },
    wrapClick(t) {
      if (this.isDisabled || !this.clickable || this.processFlag)
        return !1;
      let n = this.getPos(t);
      const i = t.target.parentNode;
      let r;
      t.target.className === "vue-slider-piecewise-label" && (n = parseInt(i.style.left), this.moveLinkByIndex || (r = i.dataset.index)), this.isRange && (this.currentSlider = n > (this.position[1] - this.position[0]) / 2 + this.position[0] ? 1 : 0), this.setValueOnPos(n, !1, r);
    },
    moveStart(t, n = 0, i) {
      if (this.isDisabled)
        return !1;
      if (this.stopPropagation && t.stopPropagation(), this.isRange && (this.currentSlider = n, i)) {
        if (!this.processDragable)
          return !1;
        this.processFlag = !0, this.processSign = {
          pos: this.position,
          start: this.getPos(t.targetTouches && t.targetTouches[0] ? t.targetTouches[0] : t)
        };
      }
      !i && this.useKeyboard && (this.focusFlag = !0, this.focusSlider = n), this.flag = !0, this.$emit("drag-start", this);
    },
    moving(t) {
      if (this.stopPropagation && t.stopPropagation(), !this.flag)
        return !1;
      t.preventDefault(), t.targetTouches && t.targetTouches[0] && ([t] = t.targetTouches), this.processFlag ? (this.currentSlider = 0, this.setValueOnPos(this.processSign.pos[0] + this.getPos(t) - this.processSign.start, !0), this.currentSlider = 1, this.setValueOnPos(this.processSign.pos[1] + this.getPos(t) - this.processSign.start, !0)) : this.setValueOnPos(this.getPos(t), !0);
    },
    moveEnd(t) {
      if (this.stopPropagation && t.stopPropagation(), this.flag)
        this.$emit("drag-end", this), this.lazy && this.isDiff(this.val, this.value) && this.syncValue();
      else
        return !1;
      this.flag = !1, window.setTimeout(() => {
        this.processFlag = !1;
      }, 0), this.setPosition();
    },
    setValueOnPos(t, n, i) {
      const r = this.isRange ? this.limit[this.currentSlider] : this.limit, u = this.isRange ? this.valueLimit[this.currentSlider] : this.valueLimit;
      if (t >= r[0] && t <= r[1]) {
        this.setTransform(t);
        let c = (Math.round(
          t / this.gap
        ) * (this.spacing * this.multiple) + this.minimum * this.multiple) / this.multiple;
        c = i || c, this.setCurrentValue(c, n), this.isRange && this.fixed && (this.setTransform(t + this.fixedValue * this.gap * (this.currentSlider === 0 ? 1 : -1), !0), this.setCurrentValue(
          c + this.fixedValue * this.spacing * (this.currentSlider === 0 ? 1 : -1),
          n,
          !0
        ));
      } else t < r[0] ? (this.setTransform(r[0]), this.setCurrentValue(u[0]), this.isRange && this.fixed ? (this.setTransform(this.limit[this.idleSlider][0], !0), this.setCurrentValue(this.valueLimit[this.idleSlider][0], n, !0)) : !this.fixed && this.currentSlider === 1 && (this.focusSlider = 0, this.currentSlider = 0)) : (this.setTransform(r[1]), this.setCurrentValue(u[1]), this.isRange && this.fixed ? (this.setTransform(this.limit[this.idleSlider][1], !0), this.setCurrentValue(this.valueLimit[this.idleSlider][1], n, !0)) : !this.fixed && this.currentSlider === 0 && (this.focusSlider = 1, this.currentSlider = 1));
    },
    isDiff(t, n) {
      return Object.prototype.toString.call(t) !== Object.prototype.toString.call(n) ? !0 : Array.isArray(t) && t.length === n.length ? t.some((i, r) => i !== n[r]) : t !== n;
    },
    setCurrentValue(t, n, i) {
      const r = i ? this.idleSlider : this.currentSlider;
      if (t < this.minimum || t > this.maximum)
        return !1;
      this.isRange ? this.isDiff(this.currentValue[r], t) && (this.currentValue.splice(r, 1, t), (!this.lazy || !this.flag) && this.syncValue()) : this.isDiff(this.currentValue, t) && (this.currentValue = t, (!this.lazy || !this.flag) && this.syncValue()), n || this.setPosition();
    },
    setIndex(t) {
      if (Array.isArray(t) && this.isRange) {
        let n;
        this.data ? n = [this.data[t[0]], this.data[t[1]]] : n = [this.spacing * t[0] + this.minimum, this.spacing * t[1] + this.minimum], this.setValue(n);
      } else
        t = this.spacing * t + this.minimum, this.isRange && (this.currentSlider = t > (this.currentValue[1] - this.currentValue[0]) / 2 + this.currentValue[0] ? 1 : 0), this.setCurrentValue(t);
    },
    setValue(t, n, i) {
      if (this.isDiff(this.val, t)) {
        const r = this.limitValue(t);
        this.val = this.isRange ? r.concat() : r, this.computedFixedValue(), this.syncValue(n);
      }
      this.$nextTick(() => this.setPosition(i));
    },
    computedFixedValue() {
      if (!this.fixed)
        return this.fixedValue = 0, !1;
      this.fixedValue = this.currentIndex[1] - this.currentIndex[0];
    },
    setPosition(t) {
      this.flag || this.setTransitionTime(t === void 0 ? this.speed : t), this.isRange ? (this.setTransform(this.position[0], this.currentSlider === 1), this.setTransform(this.position[1], this.currentSlider === 0)) : this.setTransform(this.position), this.flag || this.setTransitionTime(0);
    },
    setTransform(t, n) {
      const i = n ? this.idleSlider : this.currentSlider, r = ir(
        (this.direction === "vertical" ? this.dotHeightVal / 2 - t : t - this.dotWidthVal / 2) * (this.reverse ? -1 : 1)
      ), u = this.direction === "vertical" ? `translateY(${r}px)` : `translateX(${r}px)`, c = this.fixed ? `${this.fixedValue * this.gap}px` : `${i === 0 ? this.position[1] - t : t - this.position[0]}px`, h = this.fixed ? `${i === 0 ? t : t - this.fixedValue * this.gap}px` : `${i === 0 ? t : this.position[0]}px`;
      this.isRange ? (this.slider[i].style.transform = u, this.slider[i].style.WebkitTransform = u, this.slider[i].style.msTransform = u, this.direction === "vertical" ? (this.$refs.process.style.height = c, this.$refs.process.style[this.reverse ? "top" : "bottom"] = h) : (this.$refs.process.style.width = c, this.$refs.process.style[this.reverse ? "right" : "left"] = h)) : (this.slider.style.transform = u, this.slider.style.WebkitTransform = u, this.slider.style.msTransform = u, this.direction === "vertical" ? (this.$refs.process.style.height = `${t}px`, this.$refs.process.style[this.reverse ? "top" : "bottom"] = 0) : (this.$refs.process.style.width = `${t}px`, this.$refs.process.style[this.reverse ? "right" : "left"] = 0));
    },
    setTransitionTime(t) {
      if (this.isRange) {
        for (let n = 0; n < this.slider.length; n++)
          this.slider[n].style.transitionDuration = `${t}s`, this.slider[n].style.WebkitTransitionDuration = `${t}s`;
        this.$refs.process.style.transitionDuration = `${t}s`, this.$refs.process.style.WebkitTransitionDuration = `${t}s`;
      } else
        this.slider.style.transitionDuration = `${t}s`, this.slider.style.WebkitTransitionDuration = `${t}s`, this.$refs.process.style.transitionDuration = `${t}s`, this.$refs.process.style.WebkitTransitionDuration = `${t}s`;
    },
    limitValue(t) {
      if (this.data)
        return t;
      const n = (i) => i < this.min ? (this.printError(`
                        The value of the slider is ${t}, the minimum value is ${this.min},
                        the value of this slider can not be less than the minimum value
                    `), this.min) : i > this.max ? (this.printError(`
                        The value of the slider is ${t}, the maximum value is ${this.max},
                        the value of this slider can not be greater than the maximum value
                    `), this.max) : i;
      return this.isRange ? t.map((i) => n(i)) : n(t);
    },
    syncValue(t) {
      const n = this.isRange ? this.val.concat() : this.val;
      this.$emit("input", n), t || this.$emit("callback", n);
    },
    getValue() {
      return this.val;
    },
    getIndex() {
      return this.currentIndex;
    },
    getStaticData() {
      this.$refs.elem && (this.size = this.direction === "vertical" ? this.$refs.elem.offsetHeight : this.$refs.elem.offsetWidth, this.offset = this.direction === "vertical" ? this.$refs.elem.getBoundingClientRect().top + window.pageYOffset || document.documentElement.scrollTop : this.$refs.elem.getBoundingClientRect().left);
    },
    refresh() {
      this.$refs.elem && (this.getStaticData(), this.computedFixedValue(), this.setPosition());
    },
    printError(t) {
      this.debug && console.error(`[VueSlider error]: ${t}`);
    }
  }
}, In = {};
var sr = /* @__PURE__ */ rt(
  nr,
  tr,
  er,
  !1,
  rr
);
function rr(t) {
  for (let n in In)
    this[n] = In[n];
}
const ar = /* @__PURE__ */ function() {
  return sr.exports;
}();
var $e = typeof globalThis != "undefined" ? globalThis : typeof window != "undefined" ? window : typeof global != "undefined" ? global : typeof self != "undefined" ? self : {};
function os(t) {
  return t && t.__esModule && Object.prototype.hasOwnProperty.call(t, "default") ? t.default : t;
}
var or = "Expected a function", Dn = NaN, lr = "[object Symbol]", ur = /^\s+|\s+$/g, cr = /^[-+]0x[0-9a-f]+$/i, dr = /^0b[01]+$/i, pr = /^0o[0-7]+$/i, fr = parseInt, hr = typeof $e == "object" && $e && $e.Object === Object && $e, mr = typeof self == "object" && self && self.Object === Object && self, _r = hr || mr || Function("return this")(), vr = Object.prototype, gr = vr.toString, yr = Math.max, br = Math.min, dn = function() {
  return _r.Date.now();
};
function Sr(t, n, i) {
  var r, u, c, h, p, f, v = 0, P = !1, x = !1, O = !0;
  if (typeof t != "function")
    throw new TypeError(or);
  n = kn(n) || 0, fn(i) && (P = !!i.leading, x = "maxWait" in i, c = x ? yr(kn(i.maxWait) || 0, n) : c, O = "trailing" in i ? !!i.trailing : O);
  function k(R) {
    var N = r, z = u;
    return r = u = void 0, v = R, h = t.apply(z, N), h;
  }
  function T(R) {
    return v = R, p = setTimeout(A, n), P ? k(R) : h;
  }
  function b(R) {
    var N = R - f, z = R - v, Z = n - N;
    return x ? br(Z, c - z) : Z;
  }
  function C(R) {
    var N = R - f, z = R - v;
    return f === void 0 || N >= n || N < 0 || x && z >= c;
  }
  function A() {
    var R = dn();
    if (C(R))
      return y(R);
    p = setTimeout(A, b(R));
  }
  function y(R) {
    return p = void 0, O && r ? k(R) : (r = u = void 0, h);
  }
  function V() {
    p !== void 0 && clearTimeout(p), v = 0, r = f = u = p = void 0;
  }
  function F() {
    return p === void 0 ? h : y(dn());
  }
  function U() {
    var R = dn(), N = C(R);
    if (r = arguments, u = this, f = R, N) {
      if (p === void 0)
        return T(f);
      if (x)
        return p = setTimeout(A, n), k(f);
    }
    return p === void 0 && (p = setTimeout(A, n)), h;
  }
  return U.cancel = V, U.flush = F, U;
}
function fn(t) {
  var n = typeof t;
  return !!t && (n == "object" || n == "function");
}
function xr(t) {
  return !!t && typeof t == "object";
}
function $r(t) {
  return typeof t == "symbol" || xr(t) && gr.call(t) == lr;
}
function kn(t) {
  if (typeof t == "number")
    return t;
  if ($r(t))
    return Dn;
  if (fn(t)) {
    var n = typeof t.valueOf == "function" ? t.valueOf() : t;
    t = fn(n) ? n + "" : n;
  }
  if (typeof t != "string")
    return t === 0 ? t : +t;
  t = t.replace(ur, "");
  var i = dr.test(t);
  return i || pr.test(t) ? fr(t.slice(2), i ? 2 : 8) : cr.test(t) ? Dn : +t;
}
var wr = Sr;
const hn = /* @__PURE__ */ os(wr), ei = (t) => String(t).replace(/\B(?=(\d{3})+(?!\d))/g, " "), mn = (t, n = 0) => String(parseFloat(t.toFixed(n))), Or = ({ object: t = {}, value: n }) => {
  var i;
  return (i = Object.keys(t).find((r) => t[r] === n)) != null ? i : "";
}, Mn = (t) => t.replace(".", ","), Pr = (t = 0) => new Promise((n) => setTimeout(n, t)), _n = ({ word: t = "час|часа|часов", number: n }) => {
  const i = t.split("|");
  return n % 10 === 1 && n % 100 !== 11 ? `${i[0]}` : n % 10 >= 2 && n % 10 <= 4 && (n % 100 < 10 || n % 100 >= 20) ? `${i[1]}` : `${i[2]}`;
};
function Cr({
  tags: t,
  prefixes: n = [],
  postfixes: i = [],
  staticPiecewises: r = !1
}) {
  const u = {
    tags: t,
    prefixes: n,
    postfixes: i
  };
  return r ? Tr(u) : Ir(u);
}
function Tr({
  tags: t,
  prefixes: n,
  postfixes: i
}) {
  const r = [], u = [];
  for (let c = 0; c < t.length; c++) {
    r.push(t[c]);
    const h = n.length ? n[c] : "", p = i.length ? ` ${i[c]}` : "";
    u.push(`${h}${t[c]}${p}`);
  }
  return {
    realValues: r,
    sliderValues: u
  };
}
function Ir({
  tags: t,
  prefixes: n,
  postfixes: i
}) {
  let r = "", u = "";
  const c = [], h = [];
  let p, f, v;
  const P = t.every((x, O, k) => k[O + 1] ? x + 1 === k[O + 1] : !0);
  for (let x = 0; x < t.length; x++) {
    f = t[x];
    const O = t[x];
    i.length || (r = Dr(f)), v = Ln(t[x].toString().length - 1), x === 0 && (f = An(t[x], v / 10, 1));
    let k = Math.abs(t[x + 1] - f);
    const T = Ln(k.toString().length - 1);
    for (k = An(k, T, 0), p = k / 20, c.push(+O.toFixed(0)), u = kr(f.toString()), h.push(`${n.length ? n[x] : ""}${u} ${i[x] || r}`), f += p; f < t[x + 1] && !P; )
      c.push(+Math.floor(f).toFixed(0)), h.push(""), f += p;
  }
  return {
    realValues: c,
    sliderValues: h,
    intervalVal: p
  };
}
function Dr(t) {
  let n = "";
  return t >= 1e3 && t <= 999999 ? n = "тыс" : t >= 1e6 && t <= 999999999 ? n = "млн" : t >= 1e9 && t <= 999999999999 && (n = "млдр"), n;
}
function kr(t) {
  if (t.length === 1)
    return t;
  const n = t.length % 3;
  if (n === 0)
    return t.slice(0, 3);
  if (n === 1) {
    const i = parseInt(t.slice(0, 2)) / 10;
    return i % 10 === 0 ? i.toFixed(1) : i;
  }
  if (n === 2)
    return t.slice(0, 2);
}
function An(t, n, i) {
  return parseInt((parseInt(t) / n).toFixed(i)) * n;
}
function Ln(t) {
  return parseInt(`1${"0".repeat(t)}`);
}
var Mr = function() {
  var t = this, n = t.$createElement, i = t._self._c || n;
  return i("div", {
    staticClass: "input-progress",
    class: {
      "input-progress--disabled": t.disabled
    }
  }, [i("div", {
    staticClass: "input-progress-content"
  }, [i("span", {
    staticClass: "input-progress__label",
    on: {
      click: t.onShowInputHandler
    }
  }, [t._v(" " + t._s(t.options.label) + " ")]), t.isShowInput ? [t.isPercent ? i("input", {
    directives: [{
      name: "model",
      rawName: "v-model.number",
      value: t.fee,
      expression: "fee",
      modifiers: {
        number: !0
      }
    }, {
      name: "click-outside",
      rawName: "v-click-outside",
      value: function() {
        return t.isShowInput = !1;
      },
      expression: "() => isShowInput = false"
    }],
    ref: "progress-input",
    class: ["input-progress__input", {
      "with-slot": t.isSlotExist
    }],
    attrs: {
      id: t.options.name,
      type: "text",
      maxlength: t.getValueLength(t.totalAmount) - 1,
      readonly: t.isReadonly,
      disabled: t.disabled
    },
    domProps: {
      value: t.fee
    },
    on: {
      input: [function(r) {
        r.target.composing || (t.fee = t._n(r.target.value));
      }, t.onChangeFeeHandler],
      keypress: t.onFilterValueHandler,
      blur: function(r) {
        return t.$forceUpdate();
      }
    }
  }) : i("input", {
    directives: [{
      name: "model",
      rawName: "v-model.number",
      value: t.inputValue,
      expression: "inputValue",
      modifiers: {
        number: !0
      }
    }, {
      name: "click-outside",
      rawName: "v-click-outside",
      value: function() {
        return t.isShowInput = !1;
      },
      expression: "() => isShowInput = false"
    }],
    ref: "progress-input",
    class: ["input-progress__input", {
      "with-slot": t.isSlotExist
    }],
    attrs: {
      id: t.options.name,
      type: "text",
      maxlength: t.getValueLength(t.options.max),
      readonly: t.isReadonly || t.disabled,
      disabled: t.disabled
    },
    domProps: {
      value: t.inputValue
    },
    on: {
      keydown: function(r) {
        if (!r.type.indexOf("key") && t._k(r.keyCode, "enter", 13, r.key, "Enter")) return null;
        t.isShowInput = !1;
      },
      keypress: t.onFilterValueHandler,
      input: [function(r) {
        r.target.composing || (t.inputValue = t._n(r.target.value));
      }, t.onInputHandler],
      change: t.onChangeInputValueHandler,
      blur: function(r) {
        return t.$forceUpdate();
      }
    }
  })] : i("label", {
    class: ["input-progress__value", {
      "with-slot": t.isSlotExist
    }],
    style: {
      cursor: t.isReadonly ? "default" : "text"
    },
    attrs: {
      for: t.options.name
    },
    on: {
      click: t.onShowInputHandler
    }
  }, [i("span", [t._v(t._s(t.isPercent ? t.getFormattedValue(t.fee, "₽") : t.getFormattedValue(t.inputValue)))])]), t.isSlotExist ? i("div", {
    staticClass: "input-progress__slot"
  }, [t._t("default")], 2) : t._e()], 2), i("div", {
    staticClass: "input-progress-progressbar"
  }, [i("UIRangeSlider", {
    attrs: {
      value: String(t.labelIndex),
      min: 0,
      max: t.intervals.length - 1,
      "step-size": t.options.stepSize,
      disabled: t.disabled,
      "dot-size": t.dotSize,
      "dot-width": t.dotSize,
      "dot-height": t.dotSize
    },
    on: {
      callback: t.onSliderChangeHandler
    },
    scopedSlots: t._u([t.options.disableRangeLabel ? null : {
      key: "label",
      fn: function(r) {
        var u = r.index;
        return [t.isLabelByIndexShown(u, t.options.stepSize) ? [t._v(" " + t._s(t.getFormattedLabel(t.intervals[u], {
          isTerm: t.options.isTerm,
          isPercent: t.options.isPercent,
          percentStep: t.options.percentStep
        })) + " ")] : t._e()];
      }
    }], null, !0)
  })], 1)]);
}, Ar = [];
const Lr = {
  name: "UIInputWithProgress",
  components: {
    UIRangeSlider: ar
  },
  props: {
    options: {
      type: Object,
      required: !0,
      validator: (t) => {
        const n = ["name", "label", "measure", "min", "max", "tags", "staticPiecewises"];
        return Object.keys(t).some((i) => n.includes(i));
      }
    },
    value: {
      type: [String, Number],
      required: !0
    },
    totalAmount: {
      type: [String, Number],
      default: () => 0
    },
    readonly: {
      type: Boolean,
      default: () => !1
    },
    disabled: {
      type: Boolean,
      default: () => !1
    },
    dotSize: {
      type: Number,
      default: () => 20
    }
  },
  data() {
    return {
      fee: 0,
      progress: 0,
      isShowInput: !1,
      intervals: [],
      realValues: []
    };
  },
  computed: {
    inputValue: {
      get() {
        return this.value;
      },
      set(t) {
        t > this.options.max || t < this.options.min || /\D/gi.test(t) || this.$emit("input", t);
      }
    },
    isSlotExist() {
      return !!this.$slots.default;
    },
    isPercent() {
      var t, n;
      return (n = (t = this.options) == null ? void 0 : t.isPercent) != null ? n : !1;
    },
    labelIndex() {
      const t = Math.min(...this.realValues.filter((n) => n >= this.inputValue));
      return this.realValues.findIndex((n) => n === t);
    },
    isReadonly() {
      var t;
      return this.readonly || ((t = this.options) == null ? void 0 : t.staticPiecewises);
    }
  },
  watch: {
    inputValue(t) {
      this.isPercent && this.totalAmount && (this.fee = this.getAmountOfPercentage({
        percent: this.inputValue,
        amount: this.totalAmount
      })), t <= this.options.max && t >= this.options.min && (this.progress = t);
    },
    progress(t) {
      this.$emit("input", t);
    },
    fee(t) {
      (t < this.options.max || t > this.options.min || !String(t).match(/\D/gi)) && this.$emit("update:fee", t);
    },
    totalAmount: {
      immediate: !0,
      handler(t) {
        this.fee = this.getAmountOfPercentage({
          percent: this.inputValue,
          amount: t
        });
      }
    },
    options: {
      immediate: !0,
      handler: "init"
    }
  },
  methods: {
    init(t) {
      this.inputValue || (this.progress = t.min), this.inputValue > t.max && this.$emit("input", t.max);
      const { realValues: n, sliderValues: i } = Cr({
        tags: t.tags,
        prefixes: t.tagsPrefix,
        postfixes: t.tagsPostfix,
        staticPiecewises: t.staticPiecewises
      });
      if (!t.readonly || t.staticPiecewises) {
        this.intervals = i, this.realValues = n;
        return;
      }
      const r = i.reduce((u, c) => (+c && u.push(c < 1 ? c * 10 : +c), u), []);
      this.intervals = r, this.realValues = r;
    },
    onChangeInputValueHandler({ target: t }) {
      const n = parseFloat(t.value);
      if (n > this.options.max) {
        this.$emit("input", this.options.max);
        return;
      }
      (n < this.options.min || /\D/gi.test(n)) && this.$emit("input", this.options.min);
    },
    onSliderChangeHandler(t) {
      this.progress = this.realValues[t];
    },
    onFilterValueHandler(t) {
      /[a-zA-Zа-яА-Я ]/g.test(t.key) && t.preventDefault();
    },
    onInputHandler({ target: { value: t } }) {
      +t > this.options.max && this.$emit("input", this.options.max);
    },
    getFormattedValue(t, n) {
      const i = ei(t), r = this.options.meashure.includes("|") ? _n({
        word: this.options.meashure,
        number: this.inputValue
      }) : this.options.meashure;
      return `${i} ${n || r}`;
    },
    onShowInputHandler() {
      this.isReadonly || (this.isShowInput = !0, this.$nextTick().then(() => this.$refs["progress-input"].focus()));
    },
    getPercentageOfAmount({ currentSum: t, amount: n }) {
      return Math.round(t * 100 / n);
    },
    getAmountOfPercentage({ percent: t, amount: n }) {
      return n * t / 100;
    },
    getValueLength(t) {
      return String(t).length;
    },
    onChangeFeeHandler: hn(function() {
      let t = this.getPercentageOfAmount({
        currentSum: this.fee,
        amount: this.totalAmount
      });
      t || (t = this.options.min), t >= this.options.max && (t = this.options.max), t <= this.options.min && (t = this.options.min), this.$emit("input", t), this.fee = this.getAmountOfPercentage({
        percent: this.inputValue,
        amount: this.totalAmount
      });
    }, 1e3),
    getFormattedLabel(t, { isTerm: n, isPercent: i, percentStep: r }) {
      if (r)
        return `${t}%`;
      if (!n && !i)
        return t;
      if (i && t)
        return `${t}%`;
      const u = t < 1 ? t * 10 : t;
      if (!u)
        return "";
      if (u <= 17)
        return `${u} мес`;
      const c = u / 12;
      return `${c} ${_n({
        word: "год|года|лет",
        number: c
      })}`;
    },
    isLabelByIndexShown(t, n) {
      return n ? (t + 1) % n === 0 : !0;
    }
  }
}, En = {};
var Er = /* @__PURE__ */ rt(
  Lr,
  Mr,
  Ar,
  !1,
  jr
);
function jr(t) {
  for (let n in En)
    this[n] = En[n];
}
const Rr = /* @__PURE__ */ function() {
  return Er.exports;
}(), ii = {
  XS: "xs",
  S: "s",
  SM: "sm",
  MD: "md",
  LG: "lg",
  XXL: "xxl"
}, ni = {
  GREEN: "green",
  MONOCHROME: "monochrome",
  NEUTRAL: "neutral"
};
var Vr = function() {
  var t = this, n = t.$createElement, i = t._self._c || n;
  return i("button", {
    staticClass: "ui-button",
    class: [t.buttonSize, t.buttonTheme, {
      "icon-left": t.iconPosition === "left",
      disabled: t.disabled || t.isAsync,
      flat: t.flat,
      outlined: t.outlined,
      upper: t.uppercase
    }],
    attrs: {
      type: t.type,
      disabled: t.disabled || t.isAsync
    },
    on: {
      click: function(r) {
        return t.$emit("click", r);
      }
    }
  }, [i("div", {
    staticClass: "ui-button__label",
    class: [t.labelClass, {
      "fetching-progress": t.isAsync
    }]
  }, [t.label ? [i("span", {
    domProps: {
      innerHTML: t._s(t.label)
    }
  })] : [t._t("default")]], 2), i("div", {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: t.hasIconSlot,
      expression: "hasIconSlot"
    }],
    staticClass: "ui-button__icon"
  }, [t._t("icon")], 2), t._t("hint")], 2);
}, Br = [];
const Fr = {
  name: "UIButton",
  props: {
    label: {
      type: String,
      default: () => ""
    },
    size: {
      type: String,
      default: () => ii.MD,
      validator: (t) => Object.values(ii).includes(t)
    },
    disabled: {
      type: Boolean,
      default: () => !1
    },
    outlined: {
      type: Boolean,
      default: () => !1
    },
    flat: {
      type: Boolean,
      default: () => !1
    },
    iconPosition: {
      type: String,
      default: () => "right"
    },
    type: {
      type: String,
      default: () => "button"
    },
    labelClass: {
      type: String,
      default: () => ""
    },
    isAsync: {
      type: Boolean,
      default: () => !1
    },
    theme: {
      type: String,
      default: () => ni.GREEN,
      validator: (t) => Object.values(ni).includes(t)
    },
    uppercase: {
      type: Boolean,
      default: () => !0
    }
  },
  emits: ["click"],
  computed: {
    buttonSize() {
      return this.size !== ii.MD ? `size-${this.size}` : "";
    },
    buttonTheme() {
      return this.theme !== ni.GREEN ? `theme-${this.theme}` : "";
    },
    hasIconSlot() {
      return !!this.$slots.icon;
    }
  }
}, jn = {};
var Nr = /* @__PURE__ */ rt(
  Fr,
  Vr,
  Br,
  !1,
  Yr
);
function Yr(t) {
  for (let n in jn)
    this[n] = jn[n];
}
const ls = /* @__PURE__ */ function() {
  return Nr.exports;
}();
var Hr = function() {
  var t = this, n = t.$createElement, i = t._self._c || n;
  return i("div", {
    staticClass: "ui-link_container"
  }, [i("a", {
    staticClass: "ui-link",
    class: [t.customClasses, {
      "icon-left": t.iconPosition === "left",
      green: t.green
    }],
    style: {
      color: t.linkColor
    },
    attrs: {
      href: t.to || t.href,
      target: t.resultTarget,
      rel: t.resultRel,
      download: t.download
    },
    on: {
      click: t.handleLinkClick
    }
  }, [t.label ? [i("span", {
    domProps: {
      innerHTML: t._s(t.label)
    }
  })] : [t._t("default")], t.hasIconSlot ? i("div", {
    staticClass: "ui-link__icon"
  }, [t._t("icon")], 2) : t._e()], 2)]);
}, Ur = [];
const zr = {
  name: "UILink",
  props: {
    label: {
      type: String,
      default: () => ""
    },
    href: {
      type: String,
      default: () => "#"
    },
    to: {
      type: [String, Object],
      default: () => ""
    },
    linkClass: {
      type: [String, Array],
      default: () => ""
    },
    blank: {
      type: Boolean,
      default: () => !0
    },
    rel: {
      type: Boolean,
      default: () => !0
    },
    iconPosition: {
      type: String,
      default: () => "right"
    },
    green: {
      type: Boolean,
      default: () => !1
    },
    linkColor: {
      type: String,
      default: () => ""
    },
    download: {
      type: Boolean,
      default: () => !1
    }
  },
  emits: ["redirect", "click"],
  computed: {
    customClasses() {
      return typeof this.linkClass == "string" ? this.linkClass : this.linkClass.join(" ");
    },
    hasIconSlot() {
      return !!this.$slots.icon;
    },
    resultTarget() {
      return this.to || !this.blank ? "_self" : "_blank";
    },
    resultRel() {
      return this.to || !this.rel ? "" : "noopener noreferrer";
    }
  },
  methods: {
    handleLinkClick(t) {
      this.$emit("click", t), this.to && (t.preventDefault(), this.$emit("redirect", this.to), typeof this.$router != "undefined" && this.$router.push(this.to));
    }
  }
}, Rn = {};
var Wr = /* @__PURE__ */ rt(
  zr,
  Hr,
  Ur,
  !1,
  qr
);
function qr(t) {
  for (let n in Rn)
    this[n] = Rn[n];
}
const us = /* @__PURE__ */ function() {
  return Wr.exports;
}();
var Gr = function() {
  var t = this, n = t.$createElement, i = t._self._c || n;
  return i("table", {
    staticClass: "ui-table"
  }, [i("thead", {
    staticClass: "ui-table-head"
  }, [i("tr", {
    staticClass: "ui-table-head-row"
  }, t._l(t.tableData.thead, function(r, u) {
    return i("th", {
      key: r + u,
      staticClass: "ui-table-head-row__item",
      attrs: {
        scope: "col"
      }
    }, [i("span", {
      ref: "tableHeadItem",
      refInFor: !0,
      domProps: {
        innerHTML: t._s(r)
      }
    })]);
  }), 0)]), i("tbody", {
    staticClass: "ui-table-body"
  }, t._l(t.tableData.tbody, function(r, u) {
    return i("tr", {
      key: `tr__${u}`,
      class: ["ui-table-body-row", {
        "ui-table-body-row--bordered": r.borderBottom
      }]
    }, [t._l(r.row, function(c, h) {
      var p, f, v, P;
      return [c.td && !((p = c.link) !== null && p !== void 0 && p.href) && !((f = c.link) !== null && f !== void 0 && f.to) ? i("td", {
        key: `td__${h}`,
        class: ["ui-table-body-row__item", {
          bold: c.bold || r.bold,
          semibold: c.semibold || r.semibold,
          normal: c.normal || r.normal,
          green: c.green,
          right: c.rightAlign
        }],
        attrs: {
          "aria-label": t.tableData.thead[h].replace(/(&.+?;)|(<.+?>)/gi, " "),
          rowspan: c.rowspan,
          colspan: c.colspan
        }
      }, [c.rightAlign ? i("span", {
        ref: "rightAlignItem",
        refInFor: !0,
        attrs: {
          "data-index": h
        },
        domProps: {
          innerHTML: t._s(c.td)
        }
      }) : i("span", {
        domProps: {
          innerHTML: t._s(c.td)
        }
      })]) : t._e(), c.td && ((v = c.link) !== null && v !== void 0 && v.href || (P = c.link) !== null && P !== void 0 && P.to) ? i("td", {
        key: `td__${h}`,
        class: ["ui-table-body-row__item", {
          bold: c.bold || r.bold,
          semibold: c.semibold || r.semibold,
          normal: c.normal || r.normal
        }],
        attrs: {
          "aria-label": t.tableData.thead[h].replace(/(&.+?;)|(<.+?>)/gi, " "),
          rowspan: c.rowspan,
          colspan: c.colspan
        }
      }, [c.link.href ? i("UILink", {
        attrs: {
          href: c.link.href,
          green: !c.link.black,
          "icon-position": "left"
        },
        scopedSlots: t._u([{
          key: "default",
          fn: function() {
            return [i("span", {
              domProps: {
                innerHTML: t._s(c.td)
              }
            })];
          },
          proxy: !0
        }, c.link.type ? {
          key: "icon",
          fn: function() {
            return [i("span", {
              class: `${c.link.type}-icon`,
              staticStyle: {
                "margin-right": "8px",
                transform: "translateY(2px)"
              }
            })];
          },
          proxy: !0
        } : null], null, !0)
      }) : t._e(), c.link.to ? i("UILink", {
        attrs: {
          href: c.link.to,
          label: c.td,
          green: ""
        }
      }) : t._e()], 1) : t._e()];
    })], 2);
  }), 0)]);
}, Kr = [];
const Zr = {
  name: "UITable",
  components: {
    UILink: us
  },
  props: {
    tableData: {
      type: Object,
      required: !0
    }
  },
  mounted() {
    this.setSpanWidth();
  },
  updated() {
    this.setSpanWidth();
  },
  methods: {
    setSpanWidth() {
      var t;
      (t = this.$refs.rightAlignItem) != null && t.length && this.$refs.rightAlignItem.forEach((n) => {
        const i = parseInt(n.dataset.index), r = this.$refs.tableHeadItem[i].offsetWidth;
        r && (n.style.width = `${r}px`);
      });
    }
  }
}, Vn = {};
var Xr = /* @__PURE__ */ rt(
  Zr,
  Gr,
  Kr,
  !1,
  Qr
);
function Qr(t) {
  for (let n in Vn)
    this[n] = Vn[n];
}
const Jr = /* @__PURE__ */ function() {
  return Xr.exports;
}();
var ta = function() {
  var t = this, n = t.$createElement, i = t._self._c || n;
  return i("div", {
    ref: "popper",
    class: ["ui-popper", {
      "ui-popper--open": t.isOpen
    }],
    on: {
      click: t.hanleOpen
    }
  }, [t._t("default"), i("div", {
    staticClass: "ui-popper__message",
    style: `transform: translate3d(-${t.xShift}px, ${t.yShift}px, 0);max-width: ${t.maxWidth}px`,
    attrs: {
      "data-position": t.position
    }
  }, [t.isHtml ? i("div", {
    staticClass: "ui-popper__message--container",
    domProps: {
      innerHTML: t._s(t.message)
    }
  }) : i("div", {
    staticClass: "ui-popper__message--container"
  }, [t._v(" " + t._s(t.message) + " ")]), i("span", {
    staticClass: "ui-popper__triangle",
    style: `left: ${t.left}px;`
  })])], 2);
}, ea = [];
const ia = 540, na = {
  name: "UIPopper",
  props: {
    message: {
      type: String,
      default: () => ""
    },
    isHtml: {
      type: Boolean,
      default: () => !1
    },
    position: {
      type: String,
      default: () => "top"
    },
    maxWidth: {
      type: [String, Number],
      default: () => 320
    }
  },
  data() {
    return {
      xShift: 0,
      yShift: 12,
      left: 0,
      isOpen: !1
    };
  },
  computed: {
    isTop() {
      return this.position === "top";
    },
    isMobile() {
      return typeof this.$isMobile != "undefined" ? this.$isMobile : typeof window != "undefined" ? window.innerWidth <= ia : !1;
    }
  },
  mounted() {
    this.setPopperPosition();
  },
  methods: {
    hanleOpen() {
      this.isMobile && (this.isOpen = !this.isOpen);
    },
    setPopperPosition() {
      return Xi(this, null, function* () {
        yield this.$nextTick(), yield Pr(300);
        const { left: t, width: n } = this.$refs.popper.getBoundingClientRect(), i = n / 2 + this.maxWidth, r = t - i > 0;
        if (this.isTop && (this.yShift = -this.yShift), r) {
          this.xShift = this.isMobile ? i - n : i / 2, this.left = this.xShift - (this.isMobile ? 5 : 2);
          return;
        }
        this.xShift = t - n, this.left = this.xShift - 2;
      });
    }
  }
}, Bn = {};
var sa = /* @__PURE__ */ rt(
  na,
  ta,
  ea,
  !1,
  ra
);
function ra(t) {
  for (let n in Bn)
    this[n] = Bn[n];
}
const bn = /* @__PURE__ */ function() {
  return sa.exports;
}();
var aa = function() {
  var t = this, n = t.$createElement, i = t._self._c || n;
  return i("div", {
    staticClass: "calculation-result"
  }, [i("div", {
    staticClass: "calculation-result-main",
    style: {
      backgroundColor: t.backgroundColor
    }
  }, [i("div", {
    staticClass: "crm-scheme"
  }, [t._t("schema")], 2), i("div", {
    staticClass: "crm-btn"
  }, [i("UIButton", {
    attrs: {
      label: t.buttonLabel,
      size: "xxl",
      uppercase: !1
    },
    nativeOn: {
      click: function(r) {
        return t.$emit("result-click");
      }
    }
  })], 1), i("div", {
    staticClass: "calculation-result-info"
  }, [t._t("inner-info")], 2)]), i("div", {
    staticClass: "calculation-result-info"
  }, [t._t("outer-info")], 2)]);
}, oa = [];
const la = {
  name: "CalculationResult",
  components: {
    UIButton: ls
  },
  props: {
    backgroundColor: {
      type: String,
      default: () => "#ffffff"
    },
    buttonLabel: {
      type: String,
      default: () => "Оформить заявку"
    }
  }
}, Fn = {};
var ua = /* @__PURE__ */ rt(
  la,
  aa,
  oa,
  !1,
  ca
);
function ca(t) {
  for (let n in Fn)
    this[n] = Fn[n];
}
const da = /* @__PURE__ */ function() {
  return ua.exports;
}();
var pa = function() {
  var t = this, n = t.$createElement, i = t._self._c || n;
  return i("div", {
    class: ["calculation-out", {
      main: t.main,
      reversed: t.reversed
    }]
  }, [i("p", {
    class: ["calculation-out__title", {
      "calculation-out__title--bold": t.boldTitle
    }]
  }, [t.$slots.title ? t._t("title") : [t._v(" " + t._s(t.title) + " ")], t._t("appendix")], 2), i("strong", {
    class: ["calculation-out__value", t.valueClass]
  }, [t._v(" " + t._s(t.prefix) + " "), i("span", {
    ref: "out-value"
  }, [t._v(t._s(t._f("replaceDotComma")(t.getRenderNumber(t.displayNumber))))]), t._v(" " + t._s(t.meashure) + " ")]), t._t("default")], 2);
}, fa = [];
const ha = {
  name: "CalculationOutput",
  filters: {
    replaceDotComma(t) {
      return t ? String(t).replace(".", ",") : "";
    }
  },
  props: {
    value: {
      type: [String, Number],
      default: () => "0"
    },
    title: {
      type: String,
      default: () => ""
    },
    main: {
      type: Boolean,
      default: () => !1
    },
    meashure: {
      type: String,
      default: () => "₽"
    },
    prefix: {
      type: String,
      default: () => ""
    },
    reversed: {
      type: Boolean,
      default: () => !1
    },
    boldTitle: {
      type: Boolean,
      default: () => !1
    },
    valueClass: {
      type: String,
      default: () => ""
    }
  },
  data() {
    return {
      displayNumber: 0,
      interval: null,
      isFloat: !1
    };
  },
  computed: {
    inputValue() {
      return this.getInputValue(this.value);
    }
  },
  watch: {
    inputValue: {
      immediate: !0,
      handler(t) {
        this.animateNumbers(t);
      }
    }
  },
  methods: {
    breakNumberToCategories: ei,
    animateNumbers(t) {
      clearInterval(this.interval);
      const n = +parseFloat(t).toFixed();
      n !== this.displayNumber && (this.interval = setInterval(() => {
        if (this.displayNumber !== n) {
          let i = (n - this.displayNumber) / 10;
          i = i >= 0 ? Math.ceil(i) : Math.floor(i), this.displayNumber = this.displayNumber + i;
          return;
        }
        clearInterval(this.interval);
      }, 1));
    },
    getInputValue(t) {
      return t.toString().split(".").length === 1 ? (this.isFloat = !1, t) : (this.isFloat = !0, t * 100);
    },
    getRenderNumber(t) {
      if (this.isFloat) {
        const [n, i] = String(t / 100).split(".");
        return `${ei(n)}${i ? `.${i}` : ""}`;
      }
      return ei(t);
    }
  }
}, Nn = {};
var ma = /* @__PURE__ */ rt(
  ha,
  pa,
  fa,
  !1,
  _a
);
function _a(t) {
  for (let n in Nn)
    this[n] = Nn[n];
}
const va = /* @__PURE__ */ function() {
  return ma.exports;
}(), Yn = {
  MONOCHROME: "monochrome",
  WHITE: "white",
  TRANSPARENT: "transparent"
};
var ga = function() {
  var t = this, n = t.$createElement, i = t._self._c || n;
  return i("div", {
    class: ["ui-expand", {
      "ui-expand--expanded": t.isExpand
    }, `ui-expand--${t.theme}`]
  }, [i("button", {
    staticClass: "ui-expand__button",
    on: {
      click: t.toggleExpand
    }
  }, [i("span", {
    staticClass: "ui-expand__label"
  }, [t._t("icon"), t._v(" " + t._s(t.label) + " ")], 2), i("span", {
    staticClass: "ui-expand__icon"
  }, [i("ChevronSvg")], 1)]), i("transition", {
    attrs: {
      name: "fade"
    }
  }, [i("div", {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: t.isExpand,
      expression: "isExpand"
    }],
    staticClass: "ui-expand__content"
  }, [t._t("default")], 2)])], 1);
}, ya = [];
const ba = {
  name: "UIExpand",
  components: {
    ChevronSvg: as
  },
  props: {
    label: {
      type: String,
      default: () => ""
    },
    expand: {
      type: Boolean,
      default: () => !1
    },
    theme: {
      type: String,
      default: () => Yn.MONOCHROME,
      validator: (t) => Object.values(Yn).includes(t)
    }
  },
  emits: ["expand"],
  data() {
    return {
      isExpand: this.expand || !1
    };
  },
  methods: {
    toggleExpand() {
      this.isExpand = !this.isExpand, this.$emit("expand", this.isExpand);
    }
  }
}, Hn = {};
var Sa = /* @__PURE__ */ rt(
  ba,
  ga,
  ya,
  !1,
  xa
);
function xa(t) {
  for (let n in Hn)
    this[n] = Hn[n];
}
const Rl = /* @__PURE__ */ function() {
  return Sa.exports;
}();
var $a = function() {
  var t = this, n = t.$createElement, i = t._self._c || n;
  return i("svg", t._g({ attrs: { xmlns: "http://www.w3.org/2000/svg", width: "24", height: "24", fill: "none", viewBox: "0 0 24 24" } }, t.$listeners), [i("path", { attrs: { fill: "#50B848", "fill-rule": "evenodd", d: "M20.258 22.056V7.858h-6.072a.785.785 0 0 1-.786-.786V1H3.944A.945.945 0 0 0 3 1.944v20.112c0 .52.423.944.944.944h15.37c.52 0 .944-.423.944-.944M14.97 6.286V2.111l4.175 4.175zm2.275 11.56a.786.786 0 0 1-.785.785H6.796a.786.786 0 0 1 0-1.571h9.665c.434 0 .785.351.785.785m0-5.363a.786.786 0 0 1-.785.785H6.796a.786.786 0 0 1 0-1.571h9.665c.434 0 .785.352.785.786", "clip-rule": "evenodd" } })]);
};
const wa = {
  render: $a
};
var Oa = function() {
  var t = this, n = t.$createElement, i = t._self._c || n;
  return i("div", {
    staticClass: "ui-document"
  }, [i("DocumentSvg"), i("div", {
    staticClass: "ui-document__info"
  }, [i("UILink", {
    attrs: {
      label: t.label,
      href: t.link,
      download: t.download,
      "link-class": "ui-document__label"
    }
  }), t.fileExtension ? i("span", {
    staticClass: "ui-document__extension"
  }, [t._v(" " + t._s(t.fileExtension) + " ")]) : t._e()], 1)], 1);
}, Pa = [];
const Ca = {
  name: "UIDocument",
  components: {
    UILink: us,
    DocumentSvg: wa
  },
  props: {
    label: {
      type: String,
      required: !0
    },
    link: {
      type: String,
      required: !0
    },
    extension: {
      type: String,
      default: () => ""
    },
    download: {
      type: Boolean,
      default: () => !1
    }
  },
  computed: {
    fileExtension() {
      return this.extension.length ? this.extension : this.link.split(".").pop();
    }
  }
}, Un = {};
var Ta = /* @__PURE__ */ rt(
  Ca,
  Oa,
  Pa,
  !1,
  Ia
);
function Ia(t) {
  for (let n in Un)
    this[n] = Un[n];
}
const Vl = /* @__PURE__ */ function() {
  return Ta.exports;
}();
var Da = function() {
  var t = this, n = t.$createElement, i = t._self._c || n;
  return t.id ? i("div", {
    ref: "swiper",
    staticClass: "swiper ui-slider",
    attrs: {
      id: t.id,
      "data-testid": "component:ui:slider"
    }
  }, [t._t("header", null, {
    params: Object.assign({}, t.params)
  }), i("div", {
    class: t.options.wrapperClass || "swiper-wrapper",
    style: t.options.wrapperStyle
  }, [t._t("prepend-slide"), t.slides.length ? t._l(t.slides, function(r, u) {
    return i("div", {
      key: `slide_${t.id}_${u}`,
      class: ["swiper-slide", t.options.slideCustomClasses],
      style: t.options.slideCustomStyles
    }, [t._t("default", null, {
      slide: r,
      params: Object.assign({}, t.params)
    })], 2);
  }) : [t._t("default", null, {
    params: Object.assign({}, t.params)
  })], t._t("append-slide")], 2), t._t("navigation", null, {
    params: Object.assign({}, t.params)
  }), t._t("pagination", null, {
    params: Object.assign({}, t.params)
  })], 2) : t._e();
}, ka = [];
const Ma = {
  name: "UISlider",
  props: {
    id: {
      type: String,
      required: !0
    },
    options: {
      type: Object,
      default: () => ({})
    },
    slides: {
      type: Array,
      default: () => []
    }
  },
  data() {
    return {
      swiperInstance: null
    };
  },
  computed: {
    params() {
      if (!this.swiperInstance)
        return {};
      const {
        slideNext: t,
        slidePrev: n,
        realIndex: i,
        activeIndex: r,
        isBeginning: u,
        isEnd: c,
        isLocked: h,
        slideTo: p,
        slideToLoop: f
      } = this.swiperInstance;
      return {
        slideNext: t.bind(this.swiperInstance),
        slidePrev: n.bind(this.swiperInstance),
        slideTo: p.bind(this.swiperInstance),
        slideToLoop: f.bind(this.swiperInstance),
        realIndex: i,
        activeIndex: r,
        isBeginning: u,
        isEnd: c,
        isLocked: h
      };
    }
  },
  watch: {
    slides() {
      this.$nextTick().then(this.update);
    }
  },
  mounted() {
    this.$nextTick().then(this.init);
  },
  methods: {
    init() {
      return Xi(this, null, function* () {
        if (!this.id) {
          console.error("UISlider: id is not defined");
          return;
        }
        const { Swiper: t } = yield import("./swiper-COQ7W7X1.mjs"), { Navigation: n, Pagination: i, Autoplay: r } = yield import("./index-C60gax12.mjs");
        this.swiperInstance = new t(`#${this.id}`, kt({
          modules: [n, i, r]
        }, this.options)), this.$emit("init", this.swiperInstance);
      });
    },
    update() {
      var t;
      (t = this.swiperInstance) == null || t.update();
    },
    reset(t = 100, n = !0) {
      this.swiperInstance.slideReset(t, n);
    },
    slideTo(t = 1, n = 100, i = !0) {
      this.swiperInstance.slideTo(t, n, i);
    },
    slideToLoop(t = 1, n = 100, i = !0) {
      this.swiperInstance.slideToLoop(t, n, i);
    }
  }
}, zn = {};
var Aa = /* @__PURE__ */ rt(
  Ma,
  Da,
  ka,
  !1,
  La
);
function La(t) {
  for (let n in zn)
    this[n] = zn[n];
}
const cs = /* @__PURE__ */ function() {
  return Aa.exports;
}();
var Ea = function() {
  var t = this, n = t.$createElement, i = t._self._c || n;
  return i("button", {
    staticClass: "ui-button-new",
    class: [t.buttonSize, t.buttonTheme, {
      "icon-left": t.iconPosition === "left",
      disabled: t.disabled,
      flat: t.flat,
      ghost: t.ghost,
      outlined: t.outlined,
      upper: t.uppercase
    }],
    attrs: {
      type: t.type,
      disabled: t.disabled || t.isAsync
    },
    on: {
      click: function(r) {
        return t.$emit("click", r);
      }
    }
  }, [i("div", {
    staticClass: "ui-button-new__label",
    class: [t.labelClass, {
      "fetching-progress": t.isAsync
    }]
  }, [t.label ? [i("span", {
    domProps: {
      innerHTML: t._s(t.label)
    }
  })] : [t._t("default")]], 2), i("div", {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: t.hasIconSlot,
      expression: "hasIconSlot"
    }],
    staticClass: "ui-button-new__icon"
  }, [t._t("icon")], 2), t._t("hint")], 2);
}, ja = [];
const Ra = {
  name: "UIButtonNew",
  props: {
    label: {
      type: String,
      default: () => ""
    },
    size: {
      type: String,
      default: () => ii.XL,
      validator: (t) => Object.values(ii).includes(t)
    },
    disabled: {
      type: Boolean,
      default: () => !1
    },
    outlined: {
      type: Boolean,
      default: () => !1
    },
    flat: {
      type: Boolean,
      default: () => !1
    },
    ghost: {
      type: Boolean,
      default: () => !1
    },
    iconPosition: {
      type: String,
      default: () => "right"
    },
    type: {
      type: String,
      default: () => "button"
    },
    labelClass: {
      type: String,
      default: () => ""
    },
    isAsync: {
      type: Boolean,
      default: () => !1
    },
    theme: {
      type: String,
      default: () => ni.GREEN,
      validator: (t) => Object.values(ni).includes(t)
    },
    uppercase: {
      type: Boolean,
      default: () => !1
    }
  },
  emits: ["click"],
  computed: {
    buttonSize() {
      return this.size !== ii.XL ? `size-${this.size}` : "";
    },
    buttonTheme() {
      return this.theme !== ni.GREEN ? `theme-${this.theme}` : "";
    },
    hasIconSlot() {
      return !!this.$slots.icon;
    }
  }
}, Wn = {};
var Va = /* @__PURE__ */ rt(
  Ra,
  Ea,
  ja,
  !1,
  Ba
);
function Ba(t) {
  for (let n in Wn)
    this[n] = Wn[n];
}
const Bl = /* @__PURE__ */ function() {
  return Va.exports;
}();
var Fa = function() {
  var t = this, n = t.$createElement, i = t._self._c || n;
  return i("div", {
    class: ["ui-input"].concat(t.additionalClasses, [{
      "mt-24": t.externalLabel
    }])
  }, [i("label", {
    class: ["ui-input-label", {
      focused: t.isFocused,
      external: t.externalLabel
    }].concat(t.labelClasses),
    attrs: {
      for: `${t.name}_input`
    }
  }, [t._v(" " + t._s(t.label) + " "), t._t("label"), t.isRequiredField ? i("sup", {
    staticClass: "text-red"
  }, [t._v(" * ")]) : t._e()], 2), t._t("icon", null, {
    state: t.getCurrentFieldState({
      passed: t.validationPassed,
      failed: t.validationFailed
    })
  }), i("input", {
    directives: [{
      name: "model",
      rawName: "v-model.trim",
      value: t.inputValue,
      expression: "inputValue",
      modifiers: {
        trim: !0
      }
    }],
    class: ["ui-input-input", {
      outlined: t.outlined,
      disabled: t.disabled,
      external: t.externalLabel
    }].concat(t.inputClasses, [t.validationClasses]),
    attrs: {
      id: `${t.name}_input`,
      type: "text",
      name: t.name,
      disabled: t.disabled,
      autocomplete: t.autocomplete,
      role: t.autocomplete === "off" ? "presentation" : "",
      maxlength: t.maxlength,
      "data-is-mask-placeholder-disabled": t.disableMaskPlaceholder,
      placeholder: t.maskPlaceholder,
      inputmode: t.inputmode
    },
    domProps: {
      value: t.inputValue
    },
    on: {
      focus: t.focusHandler,
      blur: [t.blurHandler, function(r) {
        return t.$forceUpdate();
      }],
      change: function(r) {
        return t.$emit("change", r);
      },
      input: function(r) {
        r.target.composing || (t.inputValue = r.target.value.trim());
      }
    }
  }), i("span", {
    class: ["ui-input-error"].concat(t.errorClasses)
  }, [t._v(" " + t._s(t.errors[0]) + " ")])], 2);
}, Na = [];
const Ya = {
  name: "UIInput",
  // directives: {
  //     mask: maskDerective,
  // },
  mixins: [yn],
  props: {
    mask: {
      type: String,
      default: () => ""
    },
    regexMask: {
      type: String,
      default: () => ""
    },
    suggessions: {
      type: Array,
      default: () => []
    },
    disableMaskPlaceholder: {
      type: Boolean,
      default: () => !1
    }
  }
}, qn = {};
var Ha = /* @__PURE__ */ rt(
  Ya,
  Fa,
  Na,
  !1,
  Ua
);
function Ua(t) {
  for (let n in qn)
    this[n] = qn[n];
}
const Fl = /* @__PURE__ */ function() {
  return Ha.exports;
}();
var za = function() {
  var t = this, n = t.$createElement, i = t._self._c || n;
  return i("div", {
    class: ["ui-checkbox"].concat(t.additionalClasses, [{
      "ui-checkbox--toggle": t.toggle,
      "ui-checkbox--disabled": t.disabled
    }])
  }, [i("input", {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: t.inputValue,
      expression: "inputValue"
    }],
    class: ["checkbox-input", {
      checked: t.inputValue && t.toggle
    }],
    attrs: {
      id: `${t.name}_checkbox`,
      type: "checkbox",
      name: t.name,
      hidden: ""
    },
    domProps: {
      checked: Array.isArray(t.inputValue) ? t._i(t.inputValue, null) > -1 : t.inputValue
    },
    on: {
      change: [function(r) {
        var u = t.inputValue, c = r.target, h = !!c.checked;
        if (Array.isArray(u)) {
          var p = null, f = t._i(u, p);
          c.checked ? f < 0 && (t.inputValue = u.concat([p])) : f > -1 && (t.inputValue = u.slice(0, f).concat(u.slice(f + 1)));
        } else
          t.inputValue = h;
      }, function(r) {
        return t.$emit("change", r);
      }]
    }
  }), i("label", {
    class: ["ui-checkbox-label", {
      checked: t.inputValue,
      "grey-box": t.greyBox
    }, {
      "is-invalid": t.errors[0]
    }, t.size].concat(t.labelClasses),
    attrs: {
      for: `${t.name}_checkbox`
    }
  }, [t._v(" " + t._s(t.label) + " "), t._t("label")], 2)]);
}, Wa = [];
const qa = {
  name: "UICheckbox",
  mixins: [yn],
  props: {
    value: {
      type: Boolean,
      required: !0
    },
    greyBox: {
      type: Boolean,
      default: () => !1
    },
    size: {
      type: String,
      default: () => "md",
      validator: (t) => ["xs", "sm", "md", "lg"].includes(t)
    },
    toggle: {
      type: Boolean,
      default: () => !1
    }
  }
}, Gn = {};
var Ga = /* @__PURE__ */ rt(
  qa,
  za,
  Wa,
  !1,
  Ka
);
function Ka(t) {
  for (let n in Gn)
    this[n] = Gn[n];
}
const Nl = /* @__PURE__ */ function() {
  return Ga.exports;
}();
var Za = Object.defineProperty, Xa = Object.defineProperties, Qa = Object.getOwnPropertyDescriptors, Kn = Object.getOwnPropertySymbols, Ja = Object.prototype.hasOwnProperty, to = Object.prototype.propertyIsEnumerable, vn = (t, n, i) => n in t ? Za(t, n, { enumerable: !0, configurable: !0, writable: !0, value: i }) : t[n] = i, Sn = (t, n) => {
  for (var i in n || (n = {}))
    Ja.call(n, i) && vn(t, i, n[i]);
  if (Kn)
    for (var i of Kn(n))
      to.call(n, i) && vn(t, i, n[i]);
  return t;
}, xn = (t, n) => Xa(t, Qa(n)), He = (t, n, i) => vn(t, typeof n != "symbol" ? n + "" : n, i), vt = typeof globalThis != "undefined" ? globalThis : typeof window != "undefined" ? window : typeof global != "undefined" ? global : typeof self != "undefined" ? self : {};
function Jt(t) {
  return t && t.__esModule && Object.prototype.hasOwnProperty.call(t, "default") ? t.default : t;
}
var rn = { exports: {} };
rn.exports;
(function(t, n) {
  var i = 200, r = "Expected a function", u = "__lodash_hash_undefined__", c = 1, h = 2, p = 1 / 0, f = 9007199254740991, v = "[object Arguments]", P = "[object Array]", x = "[object Boolean]", O = "[object Date]", k = "[object Error]", T = "[object Function]", b = "[object GeneratorFunction]", C = "[object Map]", A = "[object Number]", y = "[object Object]", V = "[object Promise]", F = "[object RegExp]", U = "[object Set]", R = "[object String]", N = "[object Symbol]", z = "[object WeakMap]", Z = "[object ArrayBuffer]", j = "[object DataView]", E = "[object Float32Array]", J = "[object Float64Array]", nt = "[object Int8Array]", M = "[object Int16Array]", $ = "[object Int32Array]", S = "[object Uint8Array]", I = "[object Uint8ClampedArray]", w = "[object Uint16Array]", L = "[object Uint32Array]", _ = /\.|\[(?:[^[\]]*|(["'])(?:(?!\1)[^\\]|\\.)*?\1)\]/, K = /^\w*$/, Q = /^\./, H = /[^.[\]]+|\[(?:(-?\d+(?:\.\d+)?)|(["'])((?:(?!\2)[^\\]|\\.)*?)\2)\]|(?=(?:\.|\[\])(?:\.|\[\]|$))/g, it = /[\\^$.*+?()[\]{}|]/g, lt = /\\(\\)?/g, Ct = /^\[object .+?Constructor\]$/, gt = /^(?:0|[1-9]\d*)$/, W = {};
  W[E] = W[J] = W[nt] = W[M] = W[$] = W[S] = W[I] = W[w] = W[L] = !0, W[v] = W[P] = W[Z] = W[x] = W[j] = W[O] = W[k] = W[T] = W[C] = W[A] = W[y] = W[F] = W[U] = W[R] = W[z] = !1;
  var ft = typeof vt == "object" && vt && vt.Object === Object && vt, st = typeof self == "object" && self && self.Object === Object && self, tt = ft || st || Function("return this")(), yt = n && !n.nodeType && n, xt = yt && !0 && t && !t.nodeType && t, Nt = xt && xt.exports === yt, Et = Nt && ft.process, Yt = function() {
    try {
      return Et && Et.binding("util");
    } catch (s) {
    }
  }(), fe = Yt && Yt.isTypedArray;
  function si(s, o, d, g) {
    for (var B = -1, D = s ? s.length : 0; ++B < D; ) {
      var Y = s[B];
      o(g, Y, d(Y), s);
    }
    return g;
  }
  function ri(s, o) {
    for (var d = -1, g = s ? s.length : 0; ++d < g; )
      if (o(s[d], d, s))
        return !0;
    return !1;
  }
  function Ht(s) {
    return function(o) {
      return o == null ? void 0 : o[s];
    };
  }
  function te(s, o) {
    for (var d = -1, g = Array(s); ++d < s; )
      g[d] = o(d);
    return g;
  }
  function we(s) {
    return function(o) {
      return s(o);
    };
  }
  function Oe(s, o) {
    return s == null ? void 0 : s[o];
  }
  function dt(s) {
    var o = !1;
    if (s != null && typeof s.toString != "function")
      try {
        o = !!(s + "");
      } catch (d) {
      }
    return o;
  }
  function Ut(s) {
    var o = -1, d = Array(s.size);
    return s.forEach(function(g, B) {
      d[++o] = [B, g];
    }), d;
  }
  function ai(s, o) {
    return function(d) {
      return s(o(d));
    };
  }
  function Pe(s) {
    var o = -1, d = Array(s.size);
    return s.forEach(function(g) {
      d[++o] = g;
    }), d;
  }
  var Ce = Array.prototype, Te = Function.prototype, he = Object.prototype, Ie = tt["__core-js_shared__"], ze = function() {
    var s = /[^.]+$/.exec(Ie && Ie.keys && Ie.keys.IE_PROTO || "");
    return s ? "Symbol(src)_1." + s : "";
  }(), We = Te.toString, bt = he.hasOwnProperty, Zt = he.toString, oi = RegExp(
    "^" + We.call(bt).replace(it, "\\$&").replace(/hasOwnProperty|(function).*?(?=\\\()| for .+?(?=\\\])/g, "$1.*?") + "$"
  ), Xt = tt.Symbol, Tt = tt.Uint8Array, ee = he.propertyIsEnumerable, ie = Ce.splice, ne = ai(Object.keys, Object), $t = jt(tt, "DataView"), se = jt(tt, "Map"), De = jt(tt, "Promise"), ke = jt(tt, "Set"), Me = jt(tt, "WeakMap"), re = jt(Object, "create"), Ae = l($t), Le = l(se), mt = l(De), li = l(ke), ui = l(Me), me = Xt ? Xt.prototype : void 0, Ee = me ? me.valueOf : void 0, qe = me ? me.toString : void 0;
  function et(s) {
    var o = -1, d = s ? s.length : 0;
    for (this.clear(); ++o < d; ) {
      var g = s[o];
      this.set(g[0], g[1]);
    }
  }
  function ci() {
    this.__data__ = re ? re(null) : {};
  }
  function di(s) {
    return this.has(s) && delete this.__data__[s];
  }
  function pi(s) {
    var o = this.__data__;
    if (re) {
      var d = o[s];
      return d === u ? void 0 : d;
    }
    return bt.call(o, s) ? o[s] : void 0;
  }
  function fi(s) {
    var o = this.__data__;
    return re ? o[s] !== void 0 : bt.call(o, s);
  }
  function hi(s, o) {
    var d = this.__data__;
    return d[s] = re && o === void 0 ? u : o, this;
  }
  et.prototype.clear = ci, et.prototype.delete = di, et.prototype.get = pi, et.prototype.has = fi, et.prototype.set = hi;
  function at(s) {
    var o = -1, d = s ? s.length : 0;
    for (this.clear(); ++o < d; ) {
      var g = s[o];
      this.set(g[0], g[1]);
    }
  }
  function mi() {
    this.__data__ = [];
  }
  function _i(s) {
    var o = this.__data__, d = ve(o, s);
    if (d < 0)
      return !1;
    var g = o.length - 1;
    return d == g ? o.pop() : ie.call(o, d, 1), !0;
  }
  function vi(s) {
    var o = this.__data__, d = ve(o, s);
    return d < 0 ? void 0 : o[d][1];
  }
  function gi(s) {
    return ve(this.__data__, s) > -1;
  }
  function yi(s, o) {
    var d = this.__data__, g = ve(d, s);
    return g < 0 ? d.push([s, o]) : d[g][1] = o, this;
  }
  at.prototype.clear = mi, at.prototype.delete = _i, at.prototype.get = vi, at.prototype.has = gi, at.prototype.set = yi;
  function ot(s) {
    var o = -1, d = s ? s.length : 0;
    for (this.clear(); ++o < d; ) {
      var g = s[o];
      this.set(g[0], g[1]);
    }
  }
  function bi() {
    this.__data__ = {
      hash: new et(),
      map: new (se || at)(),
      string: new et()
    };
  }
  function Si(s) {
    return ge(this, s).delete(s);
  }
  function xi(s) {
    return ge(this, s).get(s);
  }
  function $i(s) {
    return ge(this, s).has(s);
  }
  function wi(s, o) {
    return ge(this, s).set(s, o), this;
  }
  ot.prototype.clear = bi, ot.prototype.delete = Si, ot.prototype.get = xi, ot.prototype.has = $i, ot.prototype.set = wi;
  function _e(s) {
    var o = -1, d = s ? s.length : 0;
    for (this.__data__ = new ot(); ++o < d; )
      this.add(s[o]);
  }
  function je(s) {
    return this.__data__.set(s, u), this;
  }
  function zt(s) {
    return this.__data__.has(s);
  }
  _e.prototype.add = _e.prototype.push = je, _e.prototype.has = zt;
  function Mt(s) {
    this.__data__ = new at(s);
  }
  function ae() {
    this.__data__ = new at();
  }
  function Oi(s) {
    return this.__data__.delete(s);
  }
  function Pi(s) {
    return this.__data__.get(s);
  }
  function Ci(s) {
    return this.__data__.has(s);
  }
  function Ti(s, o) {
    var d = this.__data__;
    if (d instanceof at) {
      var g = d.__data__;
      if (!se || g.length < i - 1)
        return g.push([s, o]), this;
      d = this.__data__ = new ot(g);
    }
    return d.set(s, o), this;
  }
  Mt.prototype.clear = ae, Mt.prototype.delete = Oi, Mt.prototype.get = Pi, Mt.prototype.has = Ci, Mt.prototype.set = Ti;
  function Ii(s, o) {
    var d = G(s) || ut(s) ? te(s.length, String) : [], g = d.length, B = !!g;
    for (var D in s)
      bt.call(s, D) && !(B && (D == "length" || ye(D, g))) && d.push(D);
    return d;
  }
  function ve(s, o) {
    for (var d = s.length; d--; )
      if (X(s[d][0], o))
        return d;
    return -1;
  }
  function oe(s, o, d, g) {
    return Di(s, function(B, D, Y) {
      o(g, B, d(B), Y);
    }), g;
  }
  var Di = Ni(Mi), ki = Fe();
  function Mi(s, o) {
    return s && ki(s, o, Gi);
  }
  function Ge(s, o) {
    o = be(o, s) ? [o] : Ke(o);
    for (var d = 0, g = o.length; s != null && d < g; )
      s = s[a(o[d++])];
    return d && d == g ? s : void 0;
  }
  function Ai(s) {
    return Zt.call(s);
  }
  function Li(s, o) {
    return s != null && o in Object(s);
  }
  function Re(s, o, d, g, B) {
    return s === o ? !0 : s == null || o == null || !Qt(s) && !Vt(o) ? s !== s && o !== o : Ve(s, o, Re, d, g, B);
  }
  function Ve(s, o, d, g, B, D) {
    var Y = G(s), pt = G(o), ct = P, St = P;
    Y || (ct = Rt(s), ct = ct == v ? y : ct), pt || (St = Rt(o), St = St == v ? y : St);
    var It = ct == y && !dt(s), Dt = St == y && !dt(o), Pt = ct == St;
    if (Pt && !It)
      return D || (D = new Mt()), Y || xs(s) ? ht(s, o, d, g, B, D) : Yi(s, o, ct, d, g, B, D);
    if (!(B & h)) {
      var Bt = It && bt.call(s, "__wrapped__"), Ft = Dt && bt.call(o, "__wrapped__");
      if (Bt || Ft) {
        var xe = Bt ? s.value() : s, pe = Ft ? o.value() : o;
        return D || (D = new Mt()), d(xe, pe, g, B, D);
      }
    }
    return Pt ? (D || (D = new Mt()), Ne(s, o, d, g, B, D)) : !1;
  }
  function Ei(s, o, d, g) {
    var B = d.length, D = B;
    if (s == null)
      return !D;
    for (s = Object(s); B--; ) {
      var Y = d[B];
      if (Y[2] ? Y[1] !== s[Y[0]] : !(Y[0] in s))
        return !1;
    }
    for (; ++B < D; ) {
      Y = d[B];
      var pt = Y[0], ct = s[pt], St = Y[1];
      if (Y[2]) {
        if (ct === void 0 && !(pt in s))
          return !1;
      } else {
        var It = new Mt(), Dt;
        if (!(Dt === void 0 ? Re(St, ct, g, c | h, It) : Dt))
          return !1;
      }
    }
    return !0;
  }
  function ji(s) {
    if (!Qt(s) || Ui(s))
      return !1;
    var o = Se(s) || dt(s) ? oi : Ct;
    return o.test(l(s));
  }
  function Wt(s) {
    return Vt(s) && de(s.length) && !!W[Zt.call(s)];
  }
  function wt(s) {
    return typeof s == "function" ? s : s == null ? Ps : typeof s == "object" ? G(s) ? Ri(s[0], s[1]) : _t(s) : Cs(s);
  }
  function Be(s) {
    if (!ue(s))
      return ne(s);
    var o = [];
    for (var d in Object(s))
      bt.call(s, d) && d != "constructor" && o.push(d);
    return o;
  }
  function _t(s) {
    var o = le(s);
    return o.length == 1 && o[0][2] ? Xe(o[0][0], o[0][1]) : function(d) {
      return d === s || Ei(d, s, o);
    };
  }
  function Ri(s, o) {
    return be(s) && Ze(o) ? Xe(a(s), o) : function(d) {
      var g = ws(d, s);
      return g === void 0 && g === o ? Os(d, s) : Re(o, g, void 0, c | h);
    };
  }
  function Vi(s) {
    return function(o) {
      return Ge(o, s);
    };
  }
  function Bi(s) {
    if (typeof s == "string")
      return s;
    if (At(s))
      return qe ? qe.call(s) : "";
    var o = s + "";
    return o == "0" && 1 / s == -p ? "-0" : o;
  }
  function Ke(s) {
    return G(s) ? s : e(s);
  }
  function Fi(s, o) {
    return function(d, g) {
      var B = G(d) ? si : oe, D = {};
      return B(d, s, wt(g), D);
    };
  }
  function Ni(s, o) {
    return function(d, g) {
      if (d == null)
        return d;
      if (!ce(d))
        return s(d, g);
      for (var B = d.length, D = -1, Y = Object(d); ++D < B && g(Y[D], D, Y) !== !1; )
        ;
      return d;
    };
  }
  function Fe(s) {
    return function(o, d, g) {
      for (var B = -1, D = Object(o), Y = g(o), pt = Y.length; pt--; ) {
        var ct = Y[++B];
        if (d(D[ct], ct, D) === !1)
          break;
      }
      return o;
    };
  }
  function ht(s, o, d, g, B, D) {
    var Y = B & h, pt = s.length, ct = o.length;
    if (pt != ct && !(Y && ct > pt))
      return !1;
    var St = D.get(s);
    if (St && D.get(o))
      return St == o;
    var It = -1, Dt = !0, Pt = B & c ? new _e() : void 0;
    for (D.set(s, o), D.set(o, s); ++It < pt; ) {
      var Bt = s[It], Ft = o[It];
      if (g)
        var xe = Y ? g(Ft, Bt, It, o, s, D) : g(Bt, Ft, It, s, o, D);
      if (xe !== void 0) {
        if (xe)
          continue;
        Dt = !1;
        break;
      }
      if (Pt) {
        if (!ri(o, function(pe, Ye) {
          if (!Pt.has(Ye) && (Bt === pe || d(Bt, pe, g, B, D)))
            return Pt.add(Ye);
        })) {
          Dt = !1;
          break;
        }
      } else if (!(Bt === Ft || d(Bt, Ft, g, B, D))) {
        Dt = !1;
        break;
      }
    }
    return D.delete(s), D.delete(o), Dt;
  }
  function Yi(s, o, d, g, B, D, Y) {
    switch (d) {
      case j:
        if (s.byteLength != o.byteLength || s.byteOffset != o.byteOffset)
          return !1;
        s = s.buffer, o = o.buffer;
      case Z:
        return !(s.byteLength != o.byteLength || !g(new Tt(s), new Tt(o)));
      case x:
      case O:
      case A:
        return X(+s, +o);
      case k:
        return s.name == o.name && s.message == o.message;
      case F:
      case R:
        return s == o + "";
      case C:
        var pt = Ut;
      case U:
        var ct = D & h;
        if (pt || (pt = Pe), s.size != o.size && !ct)
          return !1;
        var St = Y.get(s);
        if (St)
          return St == o;
        D |= c, Y.set(s, o);
        var It = ht(pt(s), pt(o), g, B, D, Y);
        return Y.delete(s), It;
      case N:
        if (Ee)
          return Ee.call(s) == Ee.call(o);
    }
    return !1;
  }
  function Ne(s, o, d, g, B, D) {
    var Y = B & h, pt = Gi(s), ct = pt.length, St = Gi(o), It = St.length;
    if (ct != It && !Y)
      return !1;
    for (var Dt = ct; Dt--; ) {
      var Pt = pt[Dt];
      if (!(Y ? Pt in o : bt.call(o, Pt)))
        return !1;
    }
    var Bt = D.get(s);
    if (Bt && D.get(o))
      return Bt == o;
    var Ft = !0;
    D.set(s, o), D.set(o, s);
    for (var xe = Y; ++Dt < ct; ) {
      Pt = pt[Dt];
      var pe = s[Pt], Ye = o[Pt];
      if (g)
        var $n = Y ? g(Ye, pe, Pt, o, s, D) : g(pe, Ye, Pt, s, o, D);
      if (!($n === void 0 ? pe === Ye || d(pe, Ye, g, B, D) : $n)) {
        Ft = !1;
        break;
      }
      xe || (xe = Pt == "constructor");
    }
    if (Ft && !xe) {
      var Ki = s.constructor, Zi = o.constructor;
      Ki != Zi && "constructor" in s && "constructor" in o && !(typeof Ki == "function" && Ki instanceof Ki && typeof Zi == "function" && Zi instanceof Zi) && (Ft = !1);
    }
    return D.delete(s), D.delete(o), Ft;
  }
  function ge(s, o) {
    var d = s.__data__;
    return qt(o) ? d[typeof o == "string" ? "string" : "hash"] : d.map;
  }
  function le(s) {
    for (var o = Gi(s), d = o.length; d--; ) {
      var g = o[d], B = s[g];
      o[d] = [g, B, Ze(B)];
    }
    return o;
  }
  function jt(s, o) {
    var d = Oe(s, o);
    return ji(d) ? d : void 0;
  }
  var Rt = Ai;
  ($t && Rt(new $t(new ArrayBuffer(1))) != j || se && Rt(new se()) != C || De && Rt(De.resolve()) != V || ke && Rt(new ke()) != U || Me && Rt(new Me()) != z) && (Rt = function(s) {
    var o = Zt.call(s), d = o == y ? s.constructor : void 0, g = d ? l(d) : void 0;
    if (g)
      switch (g) {
        case Ae:
          return j;
        case Le:
          return C;
        case mt:
          return V;
        case li:
          return U;
        case ui:
          return z;
      }
    return o;
  });
  function Hi(s, o, d) {
    o = be(o, s) ? [o] : Ke(o);
    for (var g, B = -1, Y = o.length; ++B < Y; ) {
      var D = a(o[B]);
      if (!(g = s != null && d(s, D)))
        break;
      s = s[D];
    }
    if (g)
      return g;
    var Y = s ? s.length : 0;
    return !!Y && de(Y) && ye(D, Y) && (G(s) || ut(s));
  }
  function ye(s, o) {
    return o = o == null ? f : o, !!o && (typeof s == "number" || gt.test(s)) && s > -1 && s % 1 == 0 && s < o;
  }
  function be(s, o) {
    if (G(s))
      return !1;
    var d = typeof s;
    return d == "number" || d == "symbol" || d == "boolean" || s == null || At(s) ? !0 : K.test(s) || !_.test(s) || o != null && s in Object(o);
  }
  function qt(s) {
    var o = typeof s;
    return o == "string" || o == "number" || o == "symbol" || o == "boolean" ? s !== "__proto__" : s === null;
  }
  function Ui(s) {
    return !!ze && ze in s;
  }
  function ue(s) {
    var o = s && s.constructor, d = typeof o == "function" && o.prototype || he;
    return s === d;
  }
  function Ze(s) {
    return s === s && !Qt(s);
  }
  function Xe(s, o) {
    return function(d) {
      return d == null ? !1 : d[s] === o && (o !== void 0 || s in Object(d));
    };
  }
  var e = q(function(s) {
    s = $s(s);
    var o = [];
    return Q.test(s) && o.push(""), s.replace(H, function(d, g, B, D) {
      o.push(B ? D.replace(lt, "$1") : g || d);
    }), o;
  });
  function a(s) {
    if (typeof s == "string" || At(s))
      return s;
    var o = s + "";
    return o == "0" && 1 / s == -p ? "-0" : o;
  }
  function l(s) {
    if (s != null) {
      try {
        return We.call(s);
      } catch (o) {
      }
      try {
        return s + "";
      } catch (o) {
      }
    }
    return "";
  }
  var m = Fi(function(s, o, d) {
    bt.call(s, d) ? s[d].push(o) : s[d] = [o];
  });
  function q(s, o) {
    if (typeof s != "function" || o && typeof o != "function")
      throw new TypeError(r);
    var d = function() {
      var g = arguments, B = o ? o.apply(this, g) : g[0], D = d.cache;
      if (D.has(B))
        return D.get(B);
      var Y = s.apply(this, g);
      return d.cache = D.set(B, Y), Y;
    };
    return d.cache = new (q.Cache || ot)(), d;
  }
  q.Cache = ot;
  function X(s, o) {
    return s === o || s !== s && o !== o;
  }
  function ut(s) {
    return Ot(s) && bt.call(s, "callee") && (!ee.call(s, "callee") || Zt.call(s) == v);
  }
  var G = Array.isArray;
  function ce(s) {
    return s != null && de(s.length) && !Se(s);
  }
  function Ot(s) {
    return Vt(s) && ce(s);
  }
  function Se(s) {
    var o = Qt(s) ? Zt.call(s) : "";
    return o == T || o == b;
  }
  function de(s) {
    return typeof s == "number" && s > -1 && s % 1 == 0 && s <= f;
  }
  function Qt(s) {
    var o = typeof s;
    return !!s && (o == "object" || o == "function");
  }
  function Vt(s) {
    return !!s && typeof s == "object";
  }
  function At(s) {
    return typeof s == "symbol" || Vt(s) && Zt.call(s) == N;
  }
  var xs = fe ? we(fe) : Wt;
  function $s(s) {
    return s == null ? "" : Bi(s);
  }
  function ws(s, o, d) {
    var g = s == null ? void 0 : Ge(s, o);
    return g === void 0 ? d : g;
  }
  function Os(s, o) {
    return s != null && Hi(s, o, Li);
  }
  function Gi(s) {
    return ce(s) ? Ii(s) : Be(s);
  }
  function Ps(s) {
    return s;
  }
  function Cs(s) {
    return be(s) ? Ht(a(s)) : Vi(s);
  }
  t.exports = m;
})(rn, rn.exports);
var eo = rn.exports;
const Zn = /* @__PURE__ */ Jt(eo);
var an = { exports: {} };
an.exports;
(function(t, n) {
  var i = 200, r = "__lodash_hash_undefined__", u = 9007199254740991, c = "[object Arguments]", h = "[object Array]", p = "[object Boolean]", f = "[object Date]", v = "[object Error]", P = "[object Function]", x = "[object GeneratorFunction]", O = "[object Map]", k = "[object Number]", T = "[object Object]", b = "[object Promise]", C = "[object RegExp]", A = "[object Set]", y = "[object String]", V = "[object Symbol]", F = "[object WeakMap]", U = "[object ArrayBuffer]", R = "[object DataView]", N = "[object Float32Array]", z = "[object Float64Array]", Z = "[object Int8Array]", j = "[object Int16Array]", E = "[object Int32Array]", J = "[object Uint8Array]", nt = "[object Uint8ClampedArray]", M = "[object Uint16Array]", $ = "[object Uint32Array]", S = /[\\^$.*+?()[\]{}|]/g, I = /\w*$/, w = /^\[object .+?Constructor\]$/, L = /^(?:0|[1-9]\d*)$/, _ = {};
  _[c] = _[h] = _[U] = _[R] = _[p] = _[f] = _[N] = _[z] = _[Z] = _[j] = _[E] = _[O] = _[k] = _[T] = _[C] = _[A] = _[y] = _[V] = _[J] = _[nt] = _[M] = _[$] = !0, _[v] = _[P] = _[F] = !1;
  var K = typeof vt == "object" && vt && vt.Object === Object && vt, Q = typeof self == "object" && self && self.Object === Object && self, H = K || Q || Function("return this")(), it = n && !n.nodeType && n, lt = it && !0 && t && !t.nodeType && t, Ct = lt && lt.exports === it;
  function gt(e, a) {
    return e.set(a[0], a[1]), e;
  }
  function W(e, a) {
    return e.add(a), e;
  }
  function ft(e, a) {
    for (var l = -1, m = e ? e.length : 0; ++l < m && a(e[l], l, e) !== !1; )
      ;
    return e;
  }
  function st(e, a) {
    for (var l = -1, m = a.length, q = e.length; ++l < m; )
      e[q + l] = a[l];
    return e;
  }
  function tt(e, a, l, m) {
    var q = -1, X = e ? e.length : 0;
    for (m; ++q < X; )
      l = a(l, e[q], q, e);
    return l;
  }
  function yt(e, a) {
    for (var l = -1, m = Array(e); ++l < e; )
      m[l] = a(l);
    return m;
  }
  function xt(e, a) {
    return e == null ? void 0 : e[a];
  }
  function Nt(e) {
    var a = !1;
    if (e != null && typeof e.toString != "function")
      try {
        a = !!(e + "");
      } catch (l) {
      }
    return a;
  }
  function Et(e) {
    var a = -1, l = Array(e.size);
    return e.forEach(function(m, q) {
      l[++a] = [q, m];
    }), l;
  }
  function Yt(e, a) {
    return function(l) {
      return e(a(l));
    };
  }
  function fe(e) {
    var a = -1, l = Array(e.size);
    return e.forEach(function(m) {
      l[++a] = m;
    }), l;
  }
  var si = Array.prototype, ri = Function.prototype, Ht = Object.prototype, te = H["__core-js_shared__"], we = function() {
    var e = /[^.]+$/.exec(te && te.keys && te.keys.IE_PROTO || "");
    return e ? "Symbol(src)_1." + e : "";
  }(), Oe = ri.toString, dt = Ht.hasOwnProperty, Ut = Ht.toString, ai = RegExp(
    "^" + Oe.call(dt).replace(S, "\\$&").replace(/hasOwnProperty|(function).*?(?=\\\()| for .+?(?=\\\])/g, "$1.*?") + "$"
  ), Pe = Ct ? H.Buffer : void 0, Ce = H.Symbol, Te = H.Uint8Array, he = Yt(Object.getPrototypeOf, Object), Ie = Object.create, ze = Ht.propertyIsEnumerable, We = si.splice, bt = Object.getOwnPropertySymbols, Zt = Pe ? Pe.isBuffer : void 0, oi = Yt(Object.keys, Object), Xt = wt(H, "DataView"), Tt = wt(H, "Map"), ee = wt(H, "Promise"), ie = wt(H, "Set"), ne = wt(H, "WeakMap"), $t = wt(Object, "create"), se = ht(Xt), De = ht(Tt), ke = ht(ee), Me = ht(ie), re = ht(ne), Ae = Ce ? Ce.prototype : void 0, Le = Ae ? Ae.valueOf : void 0;
  function mt(e) {
    var a = -1, l = e ? e.length : 0;
    for (this.clear(); ++a < l; ) {
      var m = e[a];
      this.set(m[0], m[1]);
    }
  }
  function li() {
    this.__data__ = $t ? $t(null) : {};
  }
  function ui(e) {
    return this.has(e) && delete this.__data__[e];
  }
  function me(e) {
    var a = this.__data__;
    if ($t) {
      var l = a[e];
      return l === r ? void 0 : l;
    }
    return dt.call(a, e) ? a[e] : void 0;
  }
  function Ee(e) {
    var a = this.__data__;
    return $t ? a[e] !== void 0 : dt.call(a, e);
  }
  function qe(e, a) {
    var l = this.__data__;
    return l[e] = $t && a === void 0 ? r : a, this;
  }
  mt.prototype.clear = li, mt.prototype.delete = ui, mt.prototype.get = me, mt.prototype.has = Ee, mt.prototype.set = qe;
  function et(e) {
    var a = -1, l = e ? e.length : 0;
    for (this.clear(); ++a < l; ) {
      var m = e[a];
      this.set(m[0], m[1]);
    }
  }
  function ci() {
    this.__data__ = [];
  }
  function di(e) {
    var a = this.__data__, l = zt(a, e);
    if (l < 0)
      return !1;
    var m = a.length - 1;
    return l == m ? a.pop() : We.call(a, l, 1), !0;
  }
  function pi(e) {
    var a = this.__data__, l = zt(a, e);
    return l < 0 ? void 0 : a[l][1];
  }
  function fi(e) {
    return zt(this.__data__, e) > -1;
  }
  function hi(e, a) {
    var l = this.__data__, m = zt(l, e);
    return m < 0 ? l.push([e, a]) : l[m][1] = a, this;
  }
  et.prototype.clear = ci, et.prototype.delete = di, et.prototype.get = pi, et.prototype.has = fi, et.prototype.set = hi;
  function at(e) {
    var a = -1, l = e ? e.length : 0;
    for (this.clear(); ++a < l; ) {
      var m = e[a];
      this.set(m[0], m[1]);
    }
  }
  function mi() {
    this.__data__ = {
      hash: new mt(),
      map: new (Tt || et)(),
      string: new mt()
    };
  }
  function _i(e) {
    return Wt(this, e).delete(e);
  }
  function vi(e) {
    return Wt(this, e).get(e);
  }
  function gi(e) {
    return Wt(this, e).has(e);
  }
  function yi(e, a) {
    return Wt(this, e).set(e, a), this;
  }
  at.prototype.clear = mi, at.prototype.delete = _i, at.prototype.get = vi, at.prototype.has = gi, at.prototype.set = yi;
  function ot(e) {
    this.__data__ = new et(e);
  }
  function bi() {
    this.__data__ = new et();
  }
  function Si(e) {
    return this.__data__.delete(e);
  }
  function xi(e) {
    return this.__data__.get(e);
  }
  function $i(e) {
    return this.__data__.has(e);
  }
  function wi(e, a) {
    var l = this.__data__;
    if (l instanceof et) {
      var m = l.__data__;
      if (!Tt || m.length < i - 1)
        return m.push([e, a]), this;
      l = this.__data__ = new at(m);
    }
    return l.set(e, a), this;
  }
  ot.prototype.clear = bi, ot.prototype.delete = Si, ot.prototype.get = xi, ot.prototype.has = $i, ot.prototype.set = wi;
  function _e(e, a) {
    var l = le(e) || ge(e) ? yt(e.length, String) : [], m = l.length, q = !!m;
    for (var X in e)
      dt.call(e, X) && !(q && (X == "length" || Ke(X, m))) && l.push(X);
    return l;
  }
  function je(e, a, l) {
    var m = e[a];
    (!(dt.call(e, a) && Ne(m, l)) || l === void 0 && !(a in e)) && (e[a] = l);
  }
  function zt(e, a) {
    for (var l = e.length; l--; )
      if (Ne(e[l][0], a))
        return l;
    return -1;
  }
  function Mt(e, a) {
    return e && Ve(a, ue(a), e);
  }
  function ae(e, a, l, m, q, X, ut) {
    var G;
    if (m && (G = X ? m(e, q, X, ut) : m(e)), G !== void 0)
      return G;
    if (!qt(e))
      return e;
    var ce = le(e);
    if (ce) {
      if (G = Ri(e), !a)
        return Re(e, G);
    } else {
      var Ot = _t(e), Se = Ot == P || Ot == x;
      if (Hi(e))
        return ve(e, a);
      if (Ot == T || Ot == c || Se && !X) {
        if (Nt(e))
          return X ? e : {};
        if (G = Vi(Se ? {} : e), !a)
          return Ei(e, Mt(G, e));
      } else {
        if (!_[Ot])
          return X ? e : {};
        G = Bi(e, Ot, ae, a);
      }
    }
    ut || (ut = new ot());
    var de = ut.get(e);
    if (de)
      return de;
    if (ut.set(e, G), !ce)
      var Qt = l ? ji(e) : ue(e);
    return ft(Qt || e, function(Vt, At) {
      Qt && (At = Vt, Vt = e[At]), je(G, At, ae(Vt, a, l, m, At, e, ut));
    }), G;
  }
  function Oi(e) {
    return qt(e) ? Ie(e) : {};
  }
  function Pi(e, a, l) {
    var m = a(e);
    return le(e) ? m : st(m, l(e));
  }
  function Ci(e) {
    return Ut.call(e);
  }
  function Ti(e) {
    if (!qt(e) || Ni(e))
      return !1;
    var a = ye(e) || Nt(e) ? ai : w;
    return a.test(ht(e));
  }
  function Ii(e) {
    if (!Fe(e))
      return oi(e);
    var a = [];
    for (var l in Object(e))
      dt.call(e, l) && l != "constructor" && a.push(l);
    return a;
  }
  function ve(e, a) {
    if (a)
      return e.slice();
    var l = new e.constructor(e.length);
    return e.copy(l), l;
  }
  function oe(e) {
    var a = new e.constructor(e.byteLength);
    return new Te(a).set(new Te(e)), a;
  }
  function Di(e, a) {
    var l = a ? oe(e.buffer) : e.buffer;
    return new e.constructor(l, e.byteOffset, e.byteLength);
  }
  function ki(e, a, l) {
    var m = a ? l(Et(e), !0) : Et(e);
    return tt(m, gt, new e.constructor());
  }
  function Mi(e) {
    var a = new e.constructor(e.source, I.exec(e));
    return a.lastIndex = e.lastIndex, a;
  }
  function Ge(e, a, l) {
    var m = a ? l(fe(e), !0) : fe(e);
    return tt(m, W, new e.constructor());
  }
  function Ai(e) {
    return Le ? Object(Le.call(e)) : {};
  }
  function Li(e, a) {
    var l = a ? oe(e.buffer) : e.buffer;
    return new e.constructor(l, e.byteOffset, e.length);
  }
  function Re(e, a) {
    var l = -1, m = e.length;
    for (a || (a = Array(m)); ++l < m; )
      a[l] = e[l];
    return a;
  }
  function Ve(e, a, l, m) {
    l || (l = {});
    for (var q = -1, X = a.length; ++q < X; ) {
      var ut = a[q], G = void 0;
      je(l, ut, G === void 0 ? e[ut] : G);
    }
    return l;
  }
  function Ei(e, a) {
    return Ve(e, Be(e), a);
  }
  function ji(e) {
    return Pi(e, ue, Be);
  }
  function Wt(e, a) {
    var l = e.__data__;
    return Fi(a) ? l[typeof a == "string" ? "string" : "hash"] : l.map;
  }
  function wt(e, a) {
    var l = xt(e, a);
    return Ti(l) ? l : void 0;
  }
  var Be = bt ? Yt(bt, Object) : Ze, _t = Ci;
  (Xt && _t(new Xt(new ArrayBuffer(1))) != R || Tt && _t(new Tt()) != O || ee && _t(ee.resolve()) != b || ie && _t(new ie()) != A || ne && _t(new ne()) != F) && (_t = function(e) {
    var a = Ut.call(e), l = a == T ? e.constructor : void 0, m = l ? ht(l) : void 0;
    if (m)
      switch (m) {
        case se:
          return R;
        case De:
          return O;
        case ke:
          return b;
        case Me:
          return A;
        case re:
          return F;
      }
    return a;
  });
  function Ri(e) {
    var a = e.length, l = e.constructor(a);
    return a && typeof e[0] == "string" && dt.call(e, "index") && (l.index = e.index, l.input = e.input), l;
  }
  function Vi(e) {
    return typeof e.constructor == "function" && !Fe(e) ? Oi(he(e)) : {};
  }
  function Bi(e, a, l, m) {
    var q = e.constructor;
    switch (a) {
      case U:
        return oe(e);
      case p:
      case f:
        return new q(+e);
      case R:
        return Di(e, m);
      case N:
      case z:
      case Z:
      case j:
      case E:
      case J:
      case nt:
      case M:
      case $:
        return Li(e, m);
      case O:
        return ki(e, m, l);
      case k:
      case y:
        return new q(e);
      case C:
        return Mi(e);
      case A:
        return Ge(e, m, l);
      case V:
        return Ai(e);
    }
  }
  function Ke(e, a) {
    return a = a == null ? u : a, !!a && (typeof e == "number" || L.test(e)) && e > -1 && e % 1 == 0 && e < a;
  }
  function Fi(e) {
    var a = typeof e;
    return a == "string" || a == "number" || a == "symbol" || a == "boolean" ? e !== "__proto__" : e === null;
  }
  function Ni(e) {
    return !!we && we in e;
  }
  function Fe(e) {
    var a = e && e.constructor, l = typeof a == "function" && a.prototype || Ht;
    return e === l;
  }
  function ht(e) {
    if (e != null) {
      try {
        return Oe.call(e);
      } catch (a) {
      }
      try {
        return e + "";
      } catch (a) {
      }
    }
    return "";
  }
  function Yi(e) {
    return ae(e, !0, !0);
  }
  function Ne(e, a) {
    return e === a || e !== e && a !== a;
  }
  function ge(e) {
    return Rt(e) && dt.call(e, "callee") && (!ze.call(e, "callee") || Ut.call(e) == c);
  }
  var le = Array.isArray;
  function jt(e) {
    return e != null && be(e.length) && !ye(e);
  }
  function Rt(e) {
    return Ui(e) && jt(e);
  }
  var Hi = Zt || Xe;
  function ye(e) {
    var a = qt(e) ? Ut.call(e) : "";
    return a == P || a == x;
  }
  function be(e) {
    return typeof e == "number" && e > -1 && e % 1 == 0 && e <= u;
  }
  function qt(e) {
    var a = typeof e;
    return !!e && (a == "object" || a == "function");
  }
  function Ui(e) {
    return !!e && typeof e == "object";
  }
  function ue(e) {
    return jt(e) ? _e(e) : Ii(e);
  }
  function Ze() {
    return [];
  }
  function Xe() {
    return !1;
  }
  t.exports = Yi;
})(an, an.exports);
var io = an.exports;
const ti = /* @__PURE__ */ Jt(io);
var ds = { exports: {} };
(function(t, n) {
  (function(i, r) {
    t.exports = r();
  })(vt, function() {
    var i = 1e3, r = 6e4, u = 36e5, c = "millisecond", h = "second", p = "minute", f = "hour", v = "day", P = "week", x = "month", O = "quarter", k = "year", T = "date", b = "Invalid Date", C = /^(\d{4})[-/]?(\d{1,2})?[-/]?(\d{0,2})[Tt\s]*(\d{1,2})?:?(\d{1,2})?:?(\d{1,2})?[.:]?(\d+)?$/, A = /\[([^\]]+)]|Y{1,4}|M{1,4}|D{1,2}|d{1,4}|H{1,2}|h{1,2}|a|A|m{1,2}|s{1,2}|Z{1,2}|SSS/g, y = { name: "en", weekdays: "Sunday_Monday_Tuesday_Wednesday_Thursday_Friday_Saturday".split("_"), months: "January_February_March_April_May_June_July_August_September_October_November_December".split("_"), ordinal: function(M) {
      var $ = ["th", "st", "nd", "rd"], S = M % 100;
      return "[" + M + ($[(S - 20) % 10] || $[S] || $[0]) + "]";
    } }, V = function(M, $, S) {
      var I = String(M);
      return !I || I.length >= $ ? M : "" + Array($ + 1 - I.length).join(S) + M;
    }, F = { s: V, z: function(M) {
      var $ = -M.utcOffset(), S = Math.abs($), I = Math.floor(S / 60), w = S % 60;
      return ($ <= 0 ? "+" : "-") + V(I, 2, "0") + ":" + V(w, 2, "0");
    }, m: function M($, S) {
      if ($.date() < S.date()) return -M(S, $);
      var I = 12 * (S.year() - $.year()) + (S.month() - $.month()), w = $.clone().add(I, x), L = S - w < 0, _ = $.clone().add(I + (L ? -1 : 1), x);
      return +(-(I + (S - w) / (L ? w - _ : _ - w)) || 0);
    }, a: function(M) {
      return M < 0 ? Math.ceil(M) || 0 : Math.floor(M);
    }, p: function(M) {
      return { M: x, y: k, w: P, d: v, D: T, h: f, m: p, s: h, ms: c, Q: O }[M] || String(M || "").toLowerCase().replace(/s$/, "");
    }, u: function(M) {
      return M === void 0;
    } }, U = "en", R = {};
    R[U] = y;
    var N = "$isDayjsObject", z = function(M) {
      return M instanceof J || !(!M || !M[N]);
    }, Z = function M($, S, I) {
      var w;
      if (!$) return U;
      if (typeof $ == "string") {
        var L = $.toLowerCase();
        R[L] && (w = L), S && (R[L] = S, w = L);
        var _ = $.split("-");
        if (!w && _.length > 1) return M(_[0]);
      } else {
        var K = $.name;
        R[K] = $, w = K;
      }
      return !I && w && (U = w), w || !I && U;
    }, j = function(M, $) {
      if (z(M)) return M.clone();
      var S = typeof $ == "object" ? $ : {};
      return S.date = M, S.args = arguments, new J(S);
    }, E = F;
    E.l = Z, E.i = z, E.w = function(M, $) {
      return j(M, { locale: $.$L, utc: $.$u, x: $.$x, $offset: $.$offset });
    };
    var J = function() {
      function M(S) {
        this.$L = Z(S.locale, null, !0), this.parse(S), this.$x = this.$x || S.x || {}, this[N] = !0;
      }
      var $ = M.prototype;
      return $.parse = function(S) {
        this.$d = function(I) {
          var w = I.date, L = I.utc;
          if (w === null) return /* @__PURE__ */ new Date(NaN);
          if (E.u(w)) return /* @__PURE__ */ new Date();
          if (w instanceof Date) return new Date(w);
          if (typeof w == "string" && !/Z$/i.test(w)) {
            var _ = w.match(C);
            if (_) {
              var K = _[2] - 1 || 0, Q = (_[7] || "0").substring(0, 3);
              return L ? new Date(Date.UTC(_[1], K, _[3] || 1, _[4] || 0, _[5] || 0, _[6] || 0, Q)) : new Date(_[1], K, _[3] || 1, _[4] || 0, _[5] || 0, _[6] || 0, Q);
            }
          }
          return new Date(w);
        }(S), this.init();
      }, $.init = function() {
        var S = this.$d;
        this.$y = S.getFullYear(), this.$M = S.getMonth(), this.$D = S.getDate(), this.$W = S.getDay(), this.$H = S.getHours(), this.$m = S.getMinutes(), this.$s = S.getSeconds(), this.$ms = S.getMilliseconds();
      }, $.$utils = function() {
        return E;
      }, $.isValid = function() {
        return this.$d.toString() !== b;
      }, $.isSame = function(S, I) {
        var w = j(S);
        return this.startOf(I) <= w && w <= this.endOf(I);
      }, $.isAfter = function(S, I) {
        return j(S) < this.startOf(I);
      }, $.isBefore = function(S, I) {
        return this.endOf(I) < j(S);
      }, $.$g = function(S, I, w) {
        return E.u(S) ? this[I] : this.set(w, S);
      }, $.unix = function() {
        return Math.floor(this.valueOf() / 1e3);
      }, $.valueOf = function() {
        return this.$d.getTime();
      }, $.startOf = function(S, I) {
        var w = this, L = !!E.u(I) || I, _ = E.p(S), K = function(ft, st) {
          var tt = E.w(w.$u ? Date.UTC(w.$y, st, ft) : new Date(w.$y, st, ft), w);
          return L ? tt : tt.endOf(v);
        }, Q = function(ft, st) {
          return E.w(w.toDate()[ft].apply(w.toDate("s"), (L ? [0, 0, 0, 0] : [23, 59, 59, 999]).slice(st)), w);
        }, H = this.$W, it = this.$M, lt = this.$D, Ct = "set" + (this.$u ? "UTC" : "");
        switch (_) {
          case k:
            return L ? K(1, 0) : K(31, 11);
          case x:
            return L ? K(1, it) : K(0, it + 1);
          case P:
            var gt = this.$locale().weekStart || 0, W = (H < gt ? H + 7 : H) - gt;
            return K(L ? lt - W : lt + (6 - W), it);
          case v:
          case T:
            return Q(Ct + "Hours", 0);
          case f:
            return Q(Ct + "Minutes", 1);
          case p:
            return Q(Ct + "Seconds", 2);
          case h:
            return Q(Ct + "Milliseconds", 3);
          default:
            return this.clone();
        }
      }, $.endOf = function(S) {
        return this.startOf(S, !1);
      }, $.$set = function(S, I) {
        var w, L = E.p(S), _ = "set" + (this.$u ? "UTC" : ""), K = (w = {}, w[v] = _ + "Date", w[T] = _ + "Date", w[x] = _ + "Month", w[k] = _ + "FullYear", w[f] = _ + "Hours", w[p] = _ + "Minutes", w[h] = _ + "Seconds", w[c] = _ + "Milliseconds", w)[L], Q = L === v ? this.$D + (I - this.$W) : I;
        if (L === x || L === k) {
          var H = this.clone().set(T, 1);
          H.$d[K](Q), H.init(), this.$d = H.set(T, Math.min(this.$D, H.daysInMonth())).$d;
        } else K && this.$d[K](Q);
        return this.init(), this;
      }, $.set = function(S, I) {
        return this.clone().$set(S, I);
      }, $.get = function(S) {
        return this[E.p(S)]();
      }, $.add = function(S, I) {
        var w, L = this;
        S = Number(S);
        var _ = E.p(I), K = function(it) {
          var lt = j(L);
          return E.w(lt.date(lt.date() + Math.round(it * S)), L);
        };
        if (_ === x) return this.set(x, this.$M + S);
        if (_ === k) return this.set(k, this.$y + S);
        if (_ === v) return K(1);
        if (_ === P) return K(7);
        var Q = (w = {}, w[p] = r, w[f] = u, w[h] = i, w)[_] || 1, H = this.$d.getTime() + S * Q;
        return E.w(H, this);
      }, $.subtract = function(S, I) {
        return this.add(-1 * S, I);
      }, $.format = function(S) {
        var I = this, w = this.$locale();
        if (!this.isValid()) return w.invalidDate || b;
        var L = S || "YYYY-MM-DDTHH:mm:ssZ", _ = E.z(this), K = this.$H, Q = this.$m, H = this.$M, it = w.weekdays, lt = w.months, Ct = w.meridiem, gt = function(st, tt, yt, xt) {
          return st && (st[tt] || st(I, L)) || yt[tt].slice(0, xt);
        }, W = function(st) {
          return E.s(K % 12 || 12, st, "0");
        }, ft = Ct || function(st, tt, yt) {
          var xt = st < 12 ? "AM" : "PM";
          return yt ? xt.toLowerCase() : xt;
        };
        return L.replace(A, function(st, tt) {
          return tt || function(yt) {
            switch (yt) {
              case "YY":
                return String(I.$y).slice(-2);
              case "YYYY":
                return E.s(I.$y, 4, "0");
              case "M":
                return H + 1;
              case "MM":
                return E.s(H + 1, 2, "0");
              case "MMM":
                return gt(w.monthsShort, H, lt, 3);
              case "MMMM":
                return gt(lt, H);
              case "D":
                return I.$D;
              case "DD":
                return E.s(I.$D, 2, "0");
              case "d":
                return String(I.$W);
              case "dd":
                return gt(w.weekdaysMin, I.$W, it, 2);
              case "ddd":
                return gt(w.weekdaysShort, I.$W, it, 3);
              case "dddd":
                return it[I.$W];
              case "H":
                return String(K);
              case "HH":
                return E.s(K, 2, "0");
              case "h":
                return W(1);
              case "hh":
                return W(2);
              case "a":
                return ft(K, Q, !0);
              case "A":
                return ft(K, Q, !1);
              case "m":
                return String(Q);
              case "mm":
                return E.s(Q, 2, "0");
              case "s":
                return String(I.$s);
              case "ss":
                return E.s(I.$s, 2, "0");
              case "SSS":
                return E.s(I.$ms, 3, "0");
              case "Z":
                return _;
            }
            return null;
          }(st) || _.replace(":", "");
        });
      }, $.utcOffset = function() {
        return 15 * -Math.round(this.$d.getTimezoneOffset() / 15);
      }, $.diff = function(S, I, w) {
        var L, _ = this, K = E.p(I), Q = j(S), H = (Q.utcOffset() - this.utcOffset()) * r, it = this - Q, lt = function() {
          return E.m(_, Q);
        };
        switch (K) {
          case k:
            L = lt() / 12;
            break;
          case x:
            L = lt();
            break;
          case O:
            L = lt() / 3;
            break;
          case P:
            L = (it - H) / 6048e5;
            break;
          case v:
            L = (it - H) / 864e5;
            break;
          case f:
            L = it / u;
            break;
          case p:
            L = it / r;
            break;
          case h:
            L = it / i;
            break;
          default:
            L = it;
        }
        return w ? L : E.a(L);
      }, $.daysInMonth = function() {
        return this.endOf(x).$D;
      }, $.$locale = function() {
        return R[this.$L];
      }, $.locale = function(S, I) {
        if (!S) return this.$L;
        var w = this.clone(), L = Z(S, I, !0);
        return L && (w.$L = L), w;
      }, $.clone = function() {
        return E.w(this.$d, this);
      }, $.toDate = function() {
        return new Date(this.valueOf());
      }, $.toJSON = function() {
        return this.isValid() ? this.toISOString() : null;
      }, $.toISOString = function() {
        return this.$d.toISOString();
      }, $.toString = function() {
        return this.$d.toUTCString();
      }, M;
    }(), nt = J.prototype;
    return j.prototype = nt, [["$ms", c], ["$s", h], ["$m", p], ["$H", f], ["$W", v], ["$M", x], ["$y", k], ["$D", T]].forEach(function(M) {
      nt[M[1]] = function($) {
        return this.$g($, M[0], M[1]);
      };
    }), j.extend = function(M, $) {
      return M.$i || (M($, J, j), M.$i = !0), j;
    }, j.locale = Z, j.isDayjs = z, j.unix = function(M) {
      return j(1e3 * M);
    }, j.en = R[U], j.Ls = R, j.p = {}, j;
  });
})(ds);
var ps = ds.exports;
const no = /* @__PURE__ */ Jt(ps);
var fs = { exports: {} };
(function(t, n) {
  (function(i, r) {
    t.exports = r();
  })(vt, function() {
    var i = { LTS: "h:mm:ss A", LT: "h:mm A", L: "MM/DD/YYYY", LL: "MMMM D, YYYY", LLL: "MMMM D, YYYY h:mm A", LLLL: "dddd, MMMM D, YYYY h:mm A" }, r = /(\[[^[]*\])|([-_:/.,()\s]+)|(A|a|YYYY|YY?|MM?M?M?|Do|DD?|hh?|HH?|mm?|ss?|S{1,3}|z|ZZ?)/g, u = /\d\d/, c = /\d\d?/, h = /\d*[^-_:/,()\s\d]+/, p = {}, f = function(b) {
      return (b = +b) + (b > 68 ? 1900 : 2e3);
    }, v = function(b) {
      return function(C) {
        this[b] = +C;
      };
    }, P = [/[+-]\d\d:?(\d\d)?|Z/, function(b) {
      (this.zone || (this.zone = {})).offset = function(C) {
        if (!C || C === "Z") return 0;
        var A = C.match(/([+-]|\d\d)/g), y = 60 * A[1] + (+A[2] || 0);
        return y === 0 ? 0 : A[0] === "+" ? -y : y;
      }(b);
    }], x = function(b) {
      var C = p[b];
      return C && (C.indexOf ? C : C.s.concat(C.f));
    }, O = function(b, C) {
      var A, y = p.meridiem;
      if (y) {
        for (var V = 1; V <= 24; V += 1) if (b.indexOf(y(V, 0, C)) > -1) {
          A = V > 12;
          break;
        }
      } else A = b === (C ? "pm" : "PM");
      return A;
    }, k = { A: [h, function(b) {
      this.afternoon = O(b, !1);
    }], a: [h, function(b) {
      this.afternoon = O(b, !0);
    }], S: [/\d/, function(b) {
      this.milliseconds = 100 * +b;
    }], SS: [u, function(b) {
      this.milliseconds = 10 * +b;
    }], SSS: [/\d{3}/, function(b) {
      this.milliseconds = +b;
    }], s: [c, v("seconds")], ss: [c, v("seconds")], m: [c, v("minutes")], mm: [c, v("minutes")], H: [c, v("hours")], h: [c, v("hours")], HH: [c, v("hours")], hh: [c, v("hours")], D: [c, v("day")], DD: [u, v("day")], Do: [h, function(b) {
      var C = p.ordinal, A = b.match(/\d+/);
      if (this.day = A[0], C) for (var y = 1; y <= 31; y += 1) C(y).replace(/\[|\]/g, "") === b && (this.day = y);
    }], M: [c, v("month")], MM: [u, v("month")], MMM: [h, function(b) {
      var C = x("months"), A = (x("monthsShort") || C.map(function(y) {
        return y.slice(0, 3);
      })).indexOf(b) + 1;
      if (A < 1) throw new Error();
      this.month = A % 12 || A;
    }], MMMM: [h, function(b) {
      var C = x("months").indexOf(b) + 1;
      if (C < 1) throw new Error();
      this.month = C % 12 || C;
    }], Y: [/[+-]?\d+/, v("year")], YY: [u, function(b) {
      this.year = f(b);
    }], YYYY: [/\d{4}/, v("year")], Z: P, ZZ: P };
    function T(b) {
      var C, A;
      C = b, A = p && p.formats;
      for (var y = (b = C.replace(/(\[[^\]]+])|(LTS?|l{1,4}|L{1,4})/g, function(Z, j, E) {
        var J = E && E.toUpperCase();
        return j || A[E] || i[E] || A[J].replace(/(\[[^\]]+])|(MMMM|MM|DD|dddd)/g, function(nt, M, $) {
          return M || $.slice(1);
        });
      })).match(r), V = y.length, F = 0; F < V; F += 1) {
        var U = y[F], R = k[U], N = R && R[0], z = R && R[1];
        y[F] = z ? { regex: N, parser: z } : U.replace(/^\[|\]$/g, "");
      }
      return function(Z) {
        for (var j = {}, E = 0, J = 0; E < V; E += 1) {
          var nt = y[E];
          if (typeof nt == "string") J += nt.length;
          else {
            var M = nt.regex, $ = nt.parser, S = Z.slice(J), I = M.exec(S)[0];
            $.call(j, I), Z = Z.replace(I, "");
          }
        }
        return function(w) {
          var L = w.afternoon;
          if (L !== void 0) {
            var _ = w.hours;
            L ? _ < 12 && (w.hours += 12) : _ === 12 && (w.hours = 0), delete w.afternoon;
          }
        }(j), j;
      };
    }
    return function(b, C, A) {
      A.p.customParseFormat = !0, b && b.parseTwoDigitYear && (f = b.parseTwoDigitYear);
      var y = C.prototype, V = y.parse;
      y.parse = function(F) {
        var U = F.date, R = F.utc, N = F.args;
        this.$u = R;
        var z = N[1];
        if (typeof z == "string") {
          var Z = N[2] === !0, j = N[3] === !0, E = Z || j, J = N[2];
          j && (J = N[2]), p = this.$locale(), !Z && J && (p = A.Ls[J]), this.$d = function(S, I, w) {
            try {
              if (["x", "X"].indexOf(I) > -1) return new Date((I === "X" ? 1e3 : 1) * S);
              var L = T(I)(S), _ = L.year, K = L.month, Q = L.day, H = L.hours, it = L.minutes, lt = L.seconds, Ct = L.milliseconds, gt = L.zone, W = /* @__PURE__ */ new Date(), ft = Q || (_ || K ? 1 : W.getDate()), st = _ || W.getFullYear(), tt = 0;
              _ && !K || (tt = K > 0 ? K - 1 : W.getMonth());
              var yt = H || 0, xt = it || 0, Nt = lt || 0, Et = Ct || 0;
              return gt ? new Date(Date.UTC(st, tt, ft, yt, xt, Nt, Et + 60 * gt.offset * 1e3)) : w ? new Date(Date.UTC(st, tt, ft, yt, xt, Nt, Et)) : new Date(st, tt, ft, yt, xt, Nt, Et);
            } catch (Yt) {
              return /* @__PURE__ */ new Date("");
            }
          }(U, z, R), this.init(), J && J !== !0 && (this.$L = this.locale(J).$L), E && U != this.format(z) && (this.$d = /* @__PURE__ */ new Date("")), p = {};
        } else if (z instanceof Array) for (var nt = z.length, M = 1; M <= nt; M += 1) {
          N[1] = z[M - 1];
          var $ = A.apply(this, N);
          if ($.isValid()) {
            this.$d = $.$d, this.$L = $.$L, this.init();
            break;
          }
          M === nt && (this.$d = /* @__PURE__ */ new Date(""));
        }
        else V.call(this, F);
      };
    };
  });
})(fs);
var so = fs.exports;
const ro = /* @__PURE__ */ Jt(so);
var hs = { exports: {} };
(function(t, n) {
  (function(i, r) {
    t.exports = r();
  })(vt, function() {
    return function(i, r) {
      r.prototype.isSameOrBefore = function(u, c) {
        return this.isSame(u, c) || this.isBefore(u, c);
      };
    };
  });
})(hs);
var ao = hs.exports;
const oo = /* @__PURE__ */ Jt(ao);
var ms = { exports: {} };
(function(t, n) {
  (function(i, r) {
    t.exports = r();
  })(vt, function() {
    return function(i, r) {
      r.prototype.isSameOrAfter = function(u, c) {
        return this.isSame(u, c) || this.isAfter(u, c);
      };
    };
  });
})(ms);
var lo = ms.exports;
const uo = /* @__PURE__ */ Jt(lo);
var _s = { exports: {} };
(function(t, n) {
  (function(i, r) {
    t.exports = r();
  })(vt, function() {
    return function(i, r, u) {
      r.prototype.isBetween = function(c, h, p, f) {
        var v = u(c), P = u(h), x = (f = f || "()")[0] === "(", O = f[1] === ")";
        return (x ? this.isAfter(v, p) : !this.isBefore(v, p)) && (O ? this.isBefore(P, p) : !this.isAfter(P, p)) || (x ? this.isBefore(v, p) : !this.isAfter(v, p)) && (O ? this.isAfter(P, p) : !this.isBefore(P, p));
      };
    };
  });
})(_s);
var co = _s.exports;
const po = /* @__PURE__ */ Jt(co);
var vs = { exports: {} };
(function(t, n) {
  (function(i, r) {
    t.exports = r();
  })(vt, function() {
    var i = { LTS: "h:mm:ss A", LT: "h:mm A", L: "MM/DD/YYYY", LL: "MMMM D, YYYY", LLL: "MMMM D, YYYY h:mm A", LLLL: "dddd, MMMM D, YYYY h:mm A" };
    return function(r, u, c) {
      var h = u.prototype, p = h.format;
      c.en.formats = i, h.format = function(f) {
        f === void 0 && (f = "YYYY-MM-DDTHH:mm:ssZ");
        var v = this.$locale().formats, P = function(x, O) {
          return x.replace(/(\[[^\]]+])|(LTS?|l{1,4}|L{1,4})/g, function(k, T, b) {
            var C = b && b.toUpperCase();
            return T || O[b] || i[b] || O[C].replace(/(\[[^\]]+])|(MMMM|MM|DD|dddd)/g, function(A, y, V) {
              return y || V.slice(1);
            });
          });
        }(f, v === void 0 ? {} : v);
        return p.call(this, P);
      };
    };
  });
})(vs);
var fo = vs.exports;
const ho = /* @__PURE__ */ Jt(fo);
var gs = { exports: {} };
(function(t, n) {
  (function(i, r) {
    t.exports = r();
  })(vt, function() {
    return function(i, r, u) {
      var c = r.prototype, h = function(O) {
        var k, T = O.date, b = O.utc, C = {};
        if (!((k = T) === null || k instanceof Date || k instanceof Array || c.$utils().u(k) || k.constructor.name !== "Object")) {
          if (!Object.keys(T).length) return /* @__PURE__ */ new Date();
          var A = b ? u.utc() : u();
          Object.keys(T).forEach(function(Z) {
            var j, E;
            C[j = Z, E = c.$utils().p(j), E === "date" ? "day" : E] = T[Z];
          });
          var y = C.day || (C.year || C.month >= 0 ? 1 : A.date()), V = C.year || A.year(), F = C.month >= 0 ? C.month : C.year || C.day ? 0 : A.month(), U = C.hour || 0, R = C.minute || 0, N = C.second || 0, z = C.millisecond || 0;
          return b ? new Date(Date.UTC(V, F, y, U, R, N, z)) : new Date(V, F, y, U, R, N, z);
        }
        return T;
      }, p = c.parse;
      c.parse = function(O) {
        O.date = h.bind(this)(O), p.bind(this)(O);
      };
      var f = c.set, v = c.add, P = c.subtract, x = function(O, k, T, b) {
        b === void 0 && (b = 1);
        var C = Object.keys(k), A = this;
        return C.forEach(function(y) {
          A = O.bind(A)(k[y] * b, y);
        }), A;
      };
      c.set = function(O, k) {
        return k = k === void 0 ? O : k, O.constructor.name === "Object" ? x.bind(this)(function(T, b) {
          return f.bind(this)(b, T);
        }, k, O) : f.bind(this)(O, k);
      }, c.add = function(O, k) {
        return O.constructor.name === "Object" ? x.bind(this)(v, O, k) : v.bind(this)(O, k);
      }, c.subtract = function(O, k) {
        return O.constructor.name === "Object" ? x.bind(this)(v, O, k, -1) : P.bind(this)(O, k);
      };
    };
  });
})(gs);
var mo = gs.exports;
const _o = /* @__PURE__ */ Jt(mo);
var ys = { exports: {} };
(function(t, n) {
  (function(i, r) {
    t.exports = r();
  })(vt, function() {
    return function(i, r) {
      r.prototype.isLeapYear = function() {
        return this.$y % 4 == 0 && this.$y % 100 != 0 || this.$y % 400 == 0;
      };
    };
  });
})(ys);
var vo = ys.exports;
const go = /* @__PURE__ */ Jt(vo);
var yo = { exports: {} };
(function(t, n) {
  (function(i, r) {
    t.exports = r(ps);
  })(vt, function(i) {
    function r(T) {
      return T && typeof T == "object" && "default" in T ? T : { default: T };
    }
    var u = r(i), c = "января_февраля_марта_апреля_мая_июня_июля_августа_сентября_октября_ноября_декабря".split("_"), h = "январь_февраль_март_апрель_май_июнь_июль_август_сентябрь_октябрь_ноябрь_декабрь".split("_"), p = "янв._февр._мар._апр._мая_июня_июля_авг._сент._окт._нояб._дек.".split("_"), f = "янв._февр._март_апр._май_июнь_июль_авг._сент._окт._нояб._дек.".split("_"), v = /D[oD]?(\[[^[\]]*\]|\s)+MMMM?/;
    function P(T, b, C) {
      var A, y;
      return C === "m" ? b ? "минута" : "минуту" : T + " " + (A = +T, y = { mm: b ? "минута_минуты_минут" : "минуту_минуты_минут", hh: "час_часа_часов", dd: "день_дня_дней", MM: "месяц_месяца_месяцев", yy: "год_года_лет" }[C].split("_"), A % 10 == 1 && A % 100 != 11 ? y[0] : A % 10 >= 2 && A % 10 <= 4 && (A % 100 < 10 || A % 100 >= 20) ? y[1] : y[2]);
    }
    var x = function(T, b) {
      return v.test(b) ? c[T.month()] : h[T.month()];
    };
    x.s = h, x.f = c;
    var O = function(T, b) {
      return v.test(b) ? p[T.month()] : f[T.month()];
    };
    O.s = f, O.f = p;
    var k = { name: "ru", weekdays: "воскресенье_понедельник_вторник_среда_четверг_пятница_суббота".split("_"), weekdaysShort: "вск_пнд_втр_срд_чтв_птн_сбт".split("_"), weekdaysMin: "вс_пн_вт_ср_чт_пт_сб".split("_"), months: x, monthsShort: O, weekStart: 1, yearStart: 4, formats: { LT: "H:mm", LTS: "H:mm:ss", L: "DD.MM.YYYY", LL: "D MMMM YYYY г.", LLL: "D MMMM YYYY г., H:mm", LLLL: "dddd, D MMMM YYYY г., H:mm" }, relativeTime: { future: "через %s", past: "%s назад", s: "несколько секунд", m: P, mm: P, h: "час", hh: P, d: "день", dd: P, M: "месяц", MM: P, y: "год", yy: P }, ordinal: function(T) {
      return T;
    }, meridiem: function(T) {
      return T < 4 ? "ночи" : T < 12 ? "утра" : T < 17 ? "дня" : "вечера";
    } };
    return u.default.locale(k, null, !0), k;
  });
})(yo);
class bo {
  constructor(n = no) {
    this.dateLibrary = n, this.dateLibrary.locale("ru"), this.dateLibrary.extend(ro), this.dateLibrary.extend(oo), this.dateLibrary.extend(uo), this.dateLibrary.extend(po), this.dateLibrary.extend(ho), this.dateLibrary.extend(_o), this.dateLibrary.extend(go);
  }
  get instance() {
    return this.dateLibrary;
  }
}
const Je = new bo().instance, Qi = {
  inNormalYear: 0,
  inLeapYear: 0,
  common: 0
}, Xn = {
  AMOUNT: "depositAmount",
  PERIOD: "depositPeriod"
}, Ji = 365, tn = 366, en = 28, So = {
  END: "end",
  QUARTAL: "quartal",
  MONTH: "month",
  YEAR: "year",
  HALF_YEAR: "half_year"
};
class xo {
  constructor(n) {
    He(this, "depositRates", []), He(this, "depositOptions", {}), He(this, "depositAmount", 0), He(this, "depositIncome", 0), He(this, "startRateDate"), He(this, "intermediatePercents", ti(Qi)), He(this, "intermediateDaysCount", ti(Qi)), this.startRateDate = n ? Je(n, "DD.MM.YYYY") : Je();
  }
  init(n) {
    return n.flatMap((i) => {
      this.depositRates = i.rates, this.depositAmount = i.options.minDepositAmount, this.depositIncome = i.options.minDepositAmount, this.depositOptions = i.options;
      const r = this.calculate();
      return this.resetGlobalProps(), {
        depositId: i.id,
        calculationResult: r
      };
    });
  }
  resetGlobalProps() {
    this.depositRates = [], this.depositOptions = {}, this.depositAmount = 0, this.depositIncome = 0, this.startRateDate = Je(), this.intermediatePercents = ti(Qi), this.intermediateDaysCount = ti(Qi);
  }
  calculate() {
    const n = [];
    if (this.depositRates.forEach((u) => {
      const c = this.calculateInterestsByDepositRate(u);
      n.push(c);
    }), !n.length)
      return [];
    const i = this.calculateMgs(), r = parseFloat((n.at(-1).depositIncome - this.depositAmount).toFixed(2));
    return n.map((u) => xn(Sn({}, u), { mgs: i, totalDepositPercents: r }));
  }
  getPeriodsByRateValidity(n) {
    const i = Je(this.startRateDate).add(n, "month"), r = [], { periods: u } = this.generatePeriods({
      startRateDate: this.startRateDate,
      finishRateDate: i
    });
    if (r.push(...u), this.startRateDate = i, u.at(-1).daysUntilEndBillingPeriod < en) {
      const { periods: c } = this.generatePeriods({
        startRateDate: i,
        finishRateDate: i
      });
      r.push(...c), this.startRateDate = this.startRateDate.add(1, "month");
    }
    return r;
  }
  calculateInterestsByDepositRate({
    rate: n,
    rateValidityPeriod: i,
    transitionalRate: r,
    options: u
  }) {
    const c = this.getPeriodsByRateValidity(i), h = this.depositOptions.interestPayment === So.END || !(u != null && u.withPercents);
    let p;
    h ? p = this.calculateBillingPeriodPercents(c, n) : u.quartalPercents ? p = this.calculateBillingPeriodPercentsQuartally({ periods: c, rate: n, transitionalRate: r }) : u.halfyearPercents ? p = this.calculateBillingPeriodPercentsHalfYearly({ periods: c, rate: n, transitionalRate: r }) : p = this.calculateBillingPeriodPercentsMonthly({ periods: c, rate: n, transitionalRate: r });
    const {
      billingPeriodPercentsInLeapYear: f,
      billingPeriodPercentsInNormalYear: v,
      depositPercentAmount: P
    } = this.agregateBillingPeriodPercentsByYearType(p);
    h && (this.depositIncome += P), this.updateIntermediateProps({
      propName: "intermediatePercents",
      inNormalYear: v,
      inLeapYear: f,
      common: P
    });
    const {
      depositDaysInLeapYear: x,
      depositDaysInNormalYear: O,
      totalDaysUntilEndDepositPeriod: k
    } = this.agregateDepositDaysByYearType(c);
    this.updateIntermediateProps({
      propName: "intermediateDaysCount",
      inNormalYear: O,
      inLeapYear: x,
      common: k
    });
    const T = this.calculateActualDepositYield({
      billingPeriodPercentsInNormalYear: this.intermediatePercents.inNormalYear,
      billingPeriodPercentsInLeapYear: this.intermediatePercents.inLeapYear,
      totalDaysUntilEndDepositPeriod: this.intermediateDaysCount.common
    }), b = this.calculateFullDepositCost({
      billingPeriodPercentsInNormalYear: this.intermediatePercents.inNormalYear,
      billingPeriodPercentsInLeapYear: this.intermediatePercents.inLeapYear,
      totalDaysUntilEndDepositPeriod: this.intermediateDaysCount.common
    });
    return {
      depositIncome: parseFloat(this.depositIncome.toFixed(2)),
      depositPercentAmount: parseFloat(P.toFixed(2)),
      actualDepositYield: T,
      fullDepositCost: b
    };
  }
  calculateMgs() {
    const n = this.intermediatePercents.common / this.depositAmount * 100 / this.intermediateDaysCount.common, i = Ji * this.intermediateDaysCount.inNormalYear, r = tn * this.intermediateDaysCount.inLeapYear, u = i + r, c = n * (u / this.intermediateDaysCount.common);
    return parseFloat(c.toFixed(3));
  }
  calculateFullDepositCost({
    billingPeriodPercentsInNormalYear: n,
    billingPeriodPercentsInLeapYear: i,
    totalDaysUntilEndDepositPeriod: r
  }) {
    const u = (f, v) => f / this.depositAmount * 100 / r * v, c = u(n, Ji), h = u(i, tn), p = c + h;
    return parseFloat(p.toFixed(2));
  }
  calculateActualDepositYield({
    billingPeriodPercentsInNormalYear: n,
    billingPeriodPercentsInLeapYear: i,
    totalDaysUntilEndDepositPeriod: r
  }) {
    const u = (f, v) => f / this.depositAmount / r * v, c = u(n, Ji), h = u(i, tn), p = (c + h) * 100;
    return parseFloat(p.toFixed(2));
  }
  updateIntermediateProps({ propName: n, inNormalYear: i, inLeapYear: r, common: u }) {
    this[n].inNormalYear += i, this[n].inLeapYear += r, this[n].common += u;
  }
  agregateBillingPeriodPercentsByYearType(n) {
    const {
      false: i = [],
      true: r = []
    } = Zn(n, "period.isLeapYear"), u = (f) => f.reduce((v, { billingPeriodPercent: P }) => v += P, 0), c = u(i), h = u(r), p = c + h;
    return {
      billingPeriodPercentsInNormalYear: c,
      billingPeriodPercentsInLeapYear: h,
      depositPercentAmount: p
    };
  }
  getPeriodPredicates({ periods: n, index: i }) {
    var r, u;
    const c = n[i].daysUntilEndBillingPeriod < en, h = c && ((r = n[i + 1]) == null ? void 0 : r.daysUntilEndBillingPeriod) < en, p = c && ((u = n[i - 1]) == null ? void 0 : u.daysUntilEndBillingPeriod) < en;
    return {
      isLastPeriod: i === n.length - 1,
      isTransitionPeriod: c,
      isTransitionPeriodStartDate: h,
      isTransitionPeriodLastDate: p
    };
  }
  calculateBillingPeriodPercentsMonthly({
    periods: n,
    rate: i,
    transitionalRate: r
  }) {
    let u = 0, c = i;
    return n.map((h, p) => {
      const {
        isLastPeriod: f,
        isTransitionPeriodStartDate: v,
        isTransitionPeriodLastDate: P
      } = this.getPeriodPredicates({ periods: n, index: p });
      P && r && (c = r);
      const x = this.calculateBillingPeriodPercent({
        period: h,
        depositRate: c
      }), O = {
        billingPeriodPercent: x,
        period: h
      };
      return v || r && !f ? (u += x, O) : P || r && f ? (this.depositIncome += x + u, O) : (this.depositIncome += x, O);
    });
  }
  calculateBillingPeriodPercentsQuartally({
    periods: n,
    rate: i,
    transitionalRate: r
  }) {
    let u = i, c = 0;
    return n.map((h, p) => {
      var f;
      h.periodQuartal !== ((f = n[p - 1]) == null ? void 0 : f.periodQuartal) && (this.depositIncome += c, c = 0);
      const {
        isLastPeriod: v,
        isTransitionPeriodLastDate: P
      } = this.getPeriodPredicates({ periods: n, index: p });
      P && r && (u = r);
      const x = this.calculateBillingPeriodPercent({
        period: h,
        depositRate: u
      });
      return c += x, v && (this.depositIncome += c), {
        billingPeriodPercent: x,
        period: h
      };
    });
  }
  calculateBillingPeriodPercentsHalfYearly({
    periods: n,
    rate: i,
    transitionalRate: r
  }) {
    let u = i, c = 0;
    return n.map((h, p) => {
      var f;
      h.halfYear !== ((f = n[p - 1]) == null ? void 0 : f.halfYear) && (this.depositIncome += c, c = 0);
      const {
        isLastPeriod: v,
        isTransitionPeriodLastDate: P
      } = this.getPeriodPredicates({ periods: n, index: p });
      P && r && (u = r);
      const x = this.calculateBillingPeriodPercent({
        period: h,
        depositRate: u
      });
      return c += x, v && (this.depositIncome += c), {
        billingPeriodPercent: x,
        period: h
      };
    });
  }
  calculateBillingPeriodPercents(n, i) {
    return n.map((r) => ({
      billingPeriodPercent: this.calculateBillingPeriodPercent({
        period: r,
        depositRate: i
      }),
      period: r
    }));
  }
  calculateBillingPeriodPercent({
    period: n,
    depositRate: i
  }) {
    const r = n.isLeapYear ? tn : Ji;
    return this.depositIncome * i / 100 * n.daysUntilEndBillingPeriod / r;
  }
  agregateDepositDaysByYearType(n) {
    const {
      false: i = [],
      true: r = []
    } = Zn(n, "isLeapYear"), u = (f) => f.reduce((v, { daysUntilEndBillingPeriod: P }) => v += P, 0), c = u(i), h = u(r), p = c + h;
    return {
      depositDaysInNormalYear: c,
      depositDaysInLeapYear: h,
      totalDaysUntilEndDepositPeriod: p
    };
  }
  generatePeriods({ startRateDate: n, finishRateDate: i }) {
    const r = [];
    for (let u = n; u.isBefore(i, "month"); ) {
      const c = this.generateBillingPeriodDate(u, n), h = this.generateBillingPeriod({
        currendDate: u,
        nextDate: c,
        startRateDate: n
      });
      r.push(h), u = c;
    }
    return { periods: r };
  }
  generateBillingPeriod({ currendDate: n, nextDate: i, startRateDate: r }) {
    const u = i.diff(n, "day"), c = Math.ceil(i.diff(r, "month") / 3), h = Math.ceil(i.diff(r, "month") / 6);
    return {
      isLeapYear: i.isLeapYear(),
      date: n,
      daysUntilEndBillingPeriod: u,
      periodQuartal: Math.max(1, c),
      halfYear: h
    };
  }
  periodPredicates(n, i) {
    const r = n.isLeapYear(), u = i.isLeapYear();
    return {
      isLastDayInYear: n.diff(n.endOf("year"), "day") === 0,
      isNextYearIsLeap: !r && u,
      isNextYearIsNormal: r && !u
    };
  }
  generateEndYearDate(n) {
    return Je(n).endOf("year");
  }
  generateStartYearDate(n, i) {
    return Je(n).add(i.date(), "day");
  }
  generateBillingPeriodDate(n, i) {
    const r = n.add(1, "month"), {
      isLastDayInYear: u,
      isNextYearIsLeap: c,
      isNextYearIsNormal: h
    } = this.periodPredicates(n, r);
    return (c || h) && !u ? this.generateEndYearDate(n) : (c || h) && u ? this.generateStartYearDate(n, i) : r;
  }
}
function $o({ filterOptions: t, deposits: n, startRateDate: i }) {
  const r = ti(n).reduce((h, p) => (Oo(t, p) && h.push(To(t, p)), h), []), u = new xo(i).init(r);
  if (!u.length)
    return [];
  const c = u.map(({ depositId: h, calculationResult: p }) => {
    const f = r.find(({ id: v }) => h === v);
    return xn(Sn({}, f), {
      calculationResult: p
    });
  });
  return bs(c);
}
function wo(t) {
  if (!t || !t.length)
    throw new Error("Невозможно рассчитать лучший депозит (список депозитов пуст)!");
  if (t.length === 1)
    return Qn(t[0]);
  const [n] = bs(ti(t));
  return Qn(n);
}
function bs(t) {
  return t.sort((n, i) => {
    var r, u;
    const c = (r = n.calculationResult) == null ? void 0 : r.at(-1), h = (u = i.calculationResult) == null ? void 0 : u.at(-1), { depositIncome: p } = c != null ? c : {}, { depositIncome: f } = h != null ? h : {};
    return p && f ? p < f ? 1 : -1 : 1;
  });
}
function Qn(t) {
  return xn(Sn({}, t), {
    bestBid: t.rates.at(-1).rate,
    bestYield: t.calculationResult.at(-1).actualDepositYield
  });
}
function Oo(t, n) {
  return Object.entries(t).every(([i, r]) => i === Xn.PERIOD ? Po(n, r) : i === Xn.AMOUNT ? Co(n, r) : Object.prototype.hasOwnProperty.call(n.options, i) ? n.options[i] === r : !0);
}
function Po(t, n) {
  const i = n <= t.options.maxDepositPeriod && t.options.maxDepositPeriod * 2 % n === 0;
  return (t.options.minDepositPeriod ? n >= t.options.minDepositPeriod : !0) && i;
}
function Co(t, n) {
  var i;
  const r = n >= t.options.minDepositAmount, u = (i = t.options) != null && i.maxDepositAmount ? n <= t.options.maxDepositAmount : !0;
  return r && u;
}
function To(t, n) {
  let i = 0;
  return n.options.minDepositAmount = t.depositAmount, n.rates = n.rates.reduce((r, u) => (i += u.rateValidityPeriod, (t.depositPeriod >= i || t.minPeriod === n.options.minDepositPeriod && t.maxPeriod === n.options.maxDepositPeriod) && r.push(u), r), []), n;
}
function Io({ deposits: t, filterOptions: n, startRateDate: i }) {
  return $o({ deposits: t, filterOptions: n, startRateDate: i });
}
function Do(t) {
  return wo(t);
}
var on = { exports: {} };
on.exports;
(function(t, n) {
  var i = 200, r = "__lodash_hash_undefined__", u = 9007199254740991, c = "[object Arguments]", h = "[object Array]", p = "[object Boolean]", f = "[object Date]", v = "[object Error]", P = "[object Function]", x = "[object GeneratorFunction]", O = "[object Map]", k = "[object Number]", T = "[object Object]", b = "[object Promise]", C = "[object RegExp]", A = "[object Set]", y = "[object String]", V = "[object Symbol]", F = "[object WeakMap]", U = "[object ArrayBuffer]", R = "[object DataView]", N = "[object Float32Array]", z = "[object Float64Array]", Z = "[object Int8Array]", j = "[object Int16Array]", E = "[object Int32Array]", J = "[object Uint8Array]", nt = "[object Uint8ClampedArray]", M = "[object Uint16Array]", $ = "[object Uint32Array]", S = /[\\^$.*+?()[\]{}|]/g, I = /\w*$/, w = /^\[object .+?Constructor\]$/, L = /^(?:0|[1-9]\d*)$/, _ = {};
  _[c] = _[h] = _[U] = _[R] = _[p] = _[f] = _[N] = _[z] = _[Z] = _[j] = _[E] = _[O] = _[k] = _[T] = _[C] = _[A] = _[y] = _[V] = _[J] = _[nt] = _[M] = _[$] = !0, _[v] = _[P] = _[F] = !1;
  var K = typeof $e == "object" && $e && $e.Object === Object && $e, Q = typeof self == "object" && self && self.Object === Object && self, H = K || Q || Function("return this")(), it = n && !n.nodeType && n, lt = it && !0 && t && !t.nodeType && t, Ct = lt && lt.exports === it;
  function gt(e, a) {
    return e.set(a[0], a[1]), e;
  }
  function W(e, a) {
    return e.add(a), e;
  }
  function ft(e, a) {
    for (var l = -1, m = e ? e.length : 0; ++l < m && a(e[l], l, e) !== !1; )
      ;
    return e;
  }
  function st(e, a) {
    for (var l = -1, m = a.length, q = e.length; ++l < m; )
      e[q + l] = a[l];
    return e;
  }
  function tt(e, a, l, m) {
    for (var q = -1, X = e ? e.length : 0; ++q < X; )
      l = a(l, e[q], q, e);
    return l;
  }
  function yt(e, a) {
    for (var l = -1, m = Array(e); ++l < e; )
      m[l] = a(l);
    return m;
  }
  function xt(e, a) {
    return e == null ? void 0 : e[a];
  }
  function Nt(e) {
    var a = !1;
    if (e != null && typeof e.toString != "function")
      try {
        a = !!(e + "");
      } catch (l) {
      }
    return a;
  }
  function Et(e) {
    var a = -1, l = Array(e.size);
    return e.forEach(function(m, q) {
      l[++a] = [q, m];
    }), l;
  }
  function Yt(e, a) {
    return function(l) {
      return e(a(l));
    };
  }
  function fe(e) {
    var a = -1, l = Array(e.size);
    return e.forEach(function(m) {
      l[++a] = m;
    }), l;
  }
  var si = Array.prototype, ri = Function.prototype, Ht = Object.prototype, te = H["__core-js_shared__"], we = function() {
    var e = /[^.]+$/.exec(te && te.keys && te.keys.IE_PROTO || "");
    return e ? "Symbol(src)_1." + e : "";
  }(), Oe = ri.toString, dt = Ht.hasOwnProperty, Ut = Ht.toString, ai = RegExp(
    "^" + Oe.call(dt).replace(S, "\\$&").replace(/hasOwnProperty|(function).*?(?=\\\()| for .+?(?=\\\])/g, "$1.*?") + "$"
  ), Pe = Ct ? H.Buffer : void 0, Ce = H.Symbol, Te = H.Uint8Array, he = Yt(Object.getPrototypeOf, Object), Ie = Object.create, ze = Ht.propertyIsEnumerable, We = si.splice, bt = Object.getOwnPropertySymbols, Zt = Pe ? Pe.isBuffer : void 0, oi = Yt(Object.keys, Object), Xt = wt(H, "DataView"), Tt = wt(H, "Map"), ee = wt(H, "Promise"), ie = wt(H, "Set"), ne = wt(H, "WeakMap"), $t = wt(Object, "create"), se = ht(Xt), De = ht(Tt), ke = ht(ee), Me = ht(ie), re = ht(ne), Ae = Ce ? Ce.prototype : void 0, Le = Ae ? Ae.valueOf : void 0;
  function mt(e) {
    var a = -1, l = e ? e.length : 0;
    for (this.clear(); ++a < l; ) {
      var m = e[a];
      this.set(m[0], m[1]);
    }
  }
  function li() {
    this.__data__ = $t ? $t(null) : {};
  }
  function ui(e) {
    return this.has(e) && delete this.__data__[e];
  }
  function me(e) {
    var a = this.__data__;
    if ($t) {
      var l = a[e];
      return l === r ? void 0 : l;
    }
    return dt.call(a, e) ? a[e] : void 0;
  }
  function Ee(e) {
    var a = this.__data__;
    return $t ? a[e] !== void 0 : dt.call(a, e);
  }
  function qe(e, a) {
    var l = this.__data__;
    return l[e] = $t && a === void 0 ? r : a, this;
  }
  mt.prototype.clear = li, mt.prototype.delete = ui, mt.prototype.get = me, mt.prototype.has = Ee, mt.prototype.set = qe;
  function et(e) {
    var a = -1, l = e ? e.length : 0;
    for (this.clear(); ++a < l; ) {
      var m = e[a];
      this.set(m[0], m[1]);
    }
  }
  function ci() {
    this.__data__ = [];
  }
  function di(e) {
    var a = this.__data__, l = zt(a, e);
    if (l < 0)
      return !1;
    var m = a.length - 1;
    return l == m ? a.pop() : We.call(a, l, 1), !0;
  }
  function pi(e) {
    var a = this.__data__, l = zt(a, e);
    return l < 0 ? void 0 : a[l][1];
  }
  function fi(e) {
    return zt(this.__data__, e) > -1;
  }
  function hi(e, a) {
    var l = this.__data__, m = zt(l, e);
    return m < 0 ? l.push([e, a]) : l[m][1] = a, this;
  }
  et.prototype.clear = ci, et.prototype.delete = di, et.prototype.get = pi, et.prototype.has = fi, et.prototype.set = hi;
  function at(e) {
    var a = -1, l = e ? e.length : 0;
    for (this.clear(); ++a < l; ) {
      var m = e[a];
      this.set(m[0], m[1]);
    }
  }
  function mi() {
    this.__data__ = {
      hash: new mt(),
      map: new (Tt || et)(),
      string: new mt()
    };
  }
  function _i(e) {
    return Wt(this, e).delete(e);
  }
  function vi(e) {
    return Wt(this, e).get(e);
  }
  function gi(e) {
    return Wt(this, e).has(e);
  }
  function yi(e, a) {
    return Wt(this, e).set(e, a), this;
  }
  at.prototype.clear = mi, at.prototype.delete = _i, at.prototype.get = vi, at.prototype.has = gi, at.prototype.set = yi;
  function ot(e) {
    this.__data__ = new et(e);
  }
  function bi() {
    this.__data__ = new et();
  }
  function Si(e) {
    return this.__data__.delete(e);
  }
  function xi(e) {
    return this.__data__.get(e);
  }
  function $i(e) {
    return this.__data__.has(e);
  }
  function wi(e, a) {
    var l = this.__data__;
    if (l instanceof et) {
      var m = l.__data__;
      if (!Tt || m.length < i - 1)
        return m.push([e, a]), this;
      l = this.__data__ = new at(m);
    }
    return l.set(e, a), this;
  }
  ot.prototype.clear = bi, ot.prototype.delete = Si, ot.prototype.get = xi, ot.prototype.has = $i, ot.prototype.set = wi;
  function _e(e, a) {
    var l = le(e) || ge(e) ? yt(e.length, String) : [], m = l.length, q = !!m;
    for (var X in e)
      dt.call(e, X) && !(q && (X == "length" || Ke(X, m))) && l.push(X);
    return l;
  }
  function je(e, a, l) {
    var m = e[a];
    (!(dt.call(e, a) && Ne(m, l)) || l === void 0 && !(a in e)) && (e[a] = l);
  }
  function zt(e, a) {
    for (var l = e.length; l--; )
      if (Ne(e[l][0], a))
        return l;
    return -1;
  }
  function Mt(e, a) {
    return e && Ve(a, ue(a), e);
  }
  function ae(e, a, l, m, q, X, ut) {
    var G;
    if (m && (G = X ? m(e, q, X, ut) : m(e)), G !== void 0)
      return G;
    if (!qt(e))
      return e;
    var ce = le(e);
    if (ce) {
      if (G = Ri(e), !a)
        return Re(e, G);
    } else {
      var Ot = _t(e), Se = Ot == P || Ot == x;
      if (Hi(e))
        return ve(e, a);
      if (Ot == T || Ot == c || Se && !X) {
        if (Nt(e))
          return X ? e : {};
        if (G = Vi(Se ? {} : e), !a)
          return Ei(e, Mt(G, e));
      } else {
        if (!_[Ot])
          return X ? e : {};
        G = Bi(e, Ot, ae, a);
      }
    }
    ut || (ut = new ot());
    var de = ut.get(e);
    if (de)
      return de;
    if (ut.set(e, G), !ce)
      var Qt = l ? ji(e) : ue(e);
    return ft(Qt || e, function(Vt, At) {
      Qt && (At = Vt, Vt = e[At]), je(G, At, ae(Vt, a, l, m, At, e, ut));
    }), G;
  }
  function Oi(e) {
    return qt(e) ? Ie(e) : {};
  }
  function Pi(e, a, l) {
    var m = a(e);
    return le(e) ? m : st(m, l(e));
  }
  function Ci(e) {
    return Ut.call(e);
  }
  function Ti(e) {
    if (!qt(e) || Ni(e))
      return !1;
    var a = ye(e) || Nt(e) ? ai : w;
    return a.test(ht(e));
  }
  function Ii(e) {
    if (!Fe(e))
      return oi(e);
    var a = [];
    for (var l in Object(e))
      dt.call(e, l) && l != "constructor" && a.push(l);
    return a;
  }
  function ve(e, a) {
    if (a)
      return e.slice();
    var l = new e.constructor(e.length);
    return e.copy(l), l;
  }
  function oe(e) {
    var a = new e.constructor(e.byteLength);
    return new Te(a).set(new Te(e)), a;
  }
  function Di(e, a) {
    var l = a ? oe(e.buffer) : e.buffer;
    return new e.constructor(l, e.byteOffset, e.byteLength);
  }
  function ki(e, a, l) {
    var m = a ? l(Et(e), !0) : Et(e);
    return tt(m, gt, new e.constructor());
  }
  function Mi(e) {
    var a = new e.constructor(e.source, I.exec(e));
    return a.lastIndex = e.lastIndex, a;
  }
  function Ge(e, a, l) {
    var m = a ? l(fe(e), !0) : fe(e);
    return tt(m, W, new e.constructor());
  }
  function Ai(e) {
    return Le ? Object(Le.call(e)) : {};
  }
  function Li(e, a) {
    var l = a ? oe(e.buffer) : e.buffer;
    return new e.constructor(l, e.byteOffset, e.length);
  }
  function Re(e, a) {
    var l = -1, m = e.length;
    for (a || (a = Array(m)); ++l < m; )
      a[l] = e[l];
    return a;
  }
  function Ve(e, a, l, m) {
    l || (l = {});
    for (var q = -1, X = a.length; ++q < X; ) {
      var ut = a[q], G = void 0;
      je(l, ut, G === void 0 ? e[ut] : G);
    }
    return l;
  }
  function Ei(e, a) {
    return Ve(e, Be(e), a);
  }
  function ji(e) {
    return Pi(e, ue, Be);
  }
  function Wt(e, a) {
    var l = e.__data__;
    return Fi(a) ? l[typeof a == "string" ? "string" : "hash"] : l.map;
  }
  function wt(e, a) {
    var l = xt(e, a);
    return Ti(l) ? l : void 0;
  }
  var Be = bt ? Yt(bt, Object) : Ze, _t = Ci;
  (Xt && _t(new Xt(new ArrayBuffer(1))) != R || Tt && _t(new Tt()) != O || ee && _t(ee.resolve()) != b || ie && _t(new ie()) != A || ne && _t(new ne()) != F) && (_t = function(e) {
    var a = Ut.call(e), l = a == T ? e.constructor : void 0, m = l ? ht(l) : void 0;
    if (m)
      switch (m) {
        case se:
          return R;
        case De:
          return O;
        case ke:
          return b;
        case Me:
          return A;
        case re:
          return F;
      }
    return a;
  });
  function Ri(e) {
    var a = e.length, l = e.constructor(a);
    return a && typeof e[0] == "string" && dt.call(e, "index") && (l.index = e.index, l.input = e.input), l;
  }
  function Vi(e) {
    return typeof e.constructor == "function" && !Fe(e) ? Oi(he(e)) : {};
  }
  function Bi(e, a, l, m) {
    var q = e.constructor;
    switch (a) {
      case U:
        return oe(e);
      case p:
      case f:
        return new q(+e);
      case R:
        return Di(e, m);
      case N:
      case z:
      case Z:
      case j:
      case E:
      case J:
      case nt:
      case M:
      case $:
        return Li(e, m);
      case O:
        return ki(e, m, l);
      case k:
      case y:
        return new q(e);
      case C:
        return Mi(e);
      case A:
        return Ge(e, m, l);
      case V:
        return Ai(e);
    }
  }
  function Ke(e, a) {
    return a = a == null ? u : a, !!a && (typeof e == "number" || L.test(e)) && e > -1 && e % 1 == 0 && e < a;
  }
  function Fi(e) {
    var a = typeof e;
    return a == "string" || a == "number" || a == "symbol" || a == "boolean" ? e !== "__proto__" : e === null;
  }
  function Ni(e) {
    return !!we && we in e;
  }
  function Fe(e) {
    var a = e && e.constructor, l = typeof a == "function" && a.prototype || Ht;
    return e === l;
  }
  function ht(e) {
    if (e != null) {
      try {
        return Oe.call(e);
      } catch (a) {
      }
      try {
        return e + "";
      } catch (a) {
      }
    }
    return "";
  }
  function Yi(e) {
    return ae(e, !0, !0);
  }
  function Ne(e, a) {
    return e === a || e !== e && a !== a;
  }
  function ge(e) {
    return Rt(e) && dt.call(e, "callee") && (!ze.call(e, "callee") || Ut.call(e) == c);
  }
  var le = Array.isArray;
  function jt(e) {
    return e != null && be(e.length) && !ye(e);
  }
  function Rt(e) {
    return Ui(e) && jt(e);
  }
  var Hi = Zt || Xe;
  function ye(e) {
    var a = qt(e) ? Ut.call(e) : "";
    return a == P || a == x;
  }
  function be(e) {
    return typeof e == "number" && e > -1 && e % 1 == 0 && e <= u;
  }
  function qt(e) {
    var a = typeof e;
    return !!e && (a == "object" || a == "function");
  }
  function Ui(e) {
    return !!e && typeof e == "object";
  }
  function ue(e) {
    return jt(e) ? _e(e) : Ii(e);
  }
  function Ze() {
    return [];
  }
  function Xe() {
    return !1;
  }
  t.exports = Yi;
})(on, on.exports);
var ko = on.exports;
const Kt = /* @__PURE__ */ os(ko), ln = {
  DEFAULT_RATE: "rate",
  CLIENT_RATE: "clientRate"
}, Lt = {
  ONLINE: "online",
  OFFLINE: "offline",
  ONLINE_FOR_CLIENTS: "online-clients"
}, Mo = {
  PREMIUM: "premium",
  M4: "m4",
  CUMULATIVE_M4: "cumulative-m4",
  GREEN: "green",
  UNIVERSAL: "universal",
  MORTGAGE_DEPOSIT: "mortgage-deposit",
  DEMAND: "demand",
  EXCLUSIVE: "exclusive",
  CUMULATIVE: "cumulative",
  WINTER: "winter",
  SEASON: "season"
}, Yl = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  DEPOSITS_RATES_TYPES: ln,
  DEPOSITS_TYPES: Mo,
  DEPOSITS_TYPES_BY_OPENING_PLACE: Lt
}, Symbol.toStringTag, { value: "Module" })), Ao = ({
  deposit: t,
  openingType: n = Lt.OFFLINE,
  rateType: i = ln.DEFAULT_RATE
}) => Gt(kt({}, t), {
  rates: t.rates.map((r) => Gt(kt({}, r), {
    rate: r[i][n]
  }))
});
var Lo = function() {
  var t = this, n = t.$createElement, i = t._self._c || n;
  return i("svg", t._g({ attrs: { xmlns: "http://www.w3.org/2000/svg", width: "24", height: "24", fill: "#8d8d8d", viewBox: "0 -960 960 960" } }, t.$listeners), [i("path", { attrs: { d: "M478-240q21 0 35.5-14.5T528-290t-14.5-35.5T478-340t-35.5 14.5T428-290t14.5 35.5T478-240m-36-154h74q0-33 7.5-52t42.5-52q26-26 41-49.5t15-56.5q0-56-41-86t-97-30q-57 0-92.5 30T342-618l66 26q5-18 22.5-39t53.5-21q32 0 48 17.5t16 38.5q0 20-12 37.5T506-526q-44 39-54 59t-10 73m38 314q-83 0-156-31.5T197-197t-85.5-127T80-480t31.5-156T197-763t127-85.5T480-880t156 31.5T763-763t85.5 127T880-480t-31.5 156T763-197t-127 85.5T480-80m0-80q134 0 227-93t93-227-93-227-227-93-227 93-93 227 93 227 227 93m0-320" } })]);
};
const Eo = {
  render: Lo
};
var jo = function() {
  var t = this, n = t.$createElement, i = t._self._c || n;
  return i("div", [i("CalculationOutput", {
    attrs: {
      value: t.outputValues.bestYield,
      title: "Доходность*",
      meashure: "%",
      main: ""
    },
    scopedSlots: t._u([{
      key: "appendix",
      fn: function() {
        return [i("div", {
          staticClass: "deposit-calculator-hint deposit-calculator-hint--small"
        }, [i("UIPopper", {
          attrs: {
            message: t.appendixText,
            "is-html": ""
          }
        }, [i("QuestionSvg", {
          staticClass: "deposit-calculator-hint__icon"
        })], 1)], 1)];
      },
      proxy: !0
    }])
  }), i("CalculationOutput", {
    attrs: {
      value: t.fixedNumber(t.outputValues.calculationResult[0].totalDepositPercents),
      title: "Общая сумма процентов",
      meashure: " ₽",
      main: ""
    }
  })], 1);
}, Ro = [];
const Vo = gn({
  name: "DepositCalculatorSchema",
  components: {
    CalculationOutput: va,
    UIPopper: bn,
    QuestionSvg: Eo
  },
  props: {
    outputValues: {
      type: Object,
      required: !0
    }
  },
  setup() {
    return {
      fixedNumber: mn,
      appendixText: `
                <strong>*Фактическая доходность</strong>&nbsp;&mdash; ставка с&nbsp;учетом капитализации
                (в&nbsp;процентах годовых),
                рассчитывается от&nbsp;начала срока действия договора вклада до&nbsp;конца каждого
                периода, указывается справочно.
            `
    };
  }
}), Jn = {};
var Bo = /* @__PURE__ */ rt(
  Vo,
  jo,
  Ro,
  !1,
  Fo
);
function Fo(t) {
  for (let n in Jn)
    this[n] = Jn[n];
}
const No = /* @__PURE__ */ function() {
  return Bo.exports;
}(), zi = {
  name: "amount",
  label: "Сумма вклада",
  meashure: "₽",
  min: 25e3,
  max: 1e8,
  tags: [25e3, 5e4, 1e5, 5e5, 1e6, 3e6, 5e6, 3e7]
}, Wi = {
  name: "term",
  label: "Срок размещения",
  meashure: "месяц|месяца|месяцев",
  isTerm: !0,
  readonly: !0,
  min: 3,
  max: 36,
  tags: [3, 6, 9, 12, 24, 36]
}, nn = {
  all: "Любая",
  month: "Ежемесячно",
  quartal: "Ежеквартально",
  half_year: "Раз в полгода",
  year: "Ежегодно",
  end: "В конце срока"
}, Yo = [
  {
    title: "Пополнение",
    key: "replenishment"
  },
  {
    title: "Частичное снятие",
    key: "partialWithdrawal"
  },
  {
    title: "Капитализация процентов",
    key: "capitalization",
    hint: `
            <b>Капитализация процентов</b>&nbsp;&mdash; причисление процентов к&nbsp;сумме вклада,
            позволяет в&nbsp;дальнейшем осуществлять начисление процентов на&nbsp;проценты.
        `
  },
  {
    title: "Получаю зарплату/пенсию на карту Центр-инвест",
    key: "forPayroll"
  },
  {
    title: "Ставка для вкладчиков",
    key: "allowance",
    hint: `
            Ставка с премией за лояльность при заключении договора в офисе предоставляется клиентам банка,
            переоформляющим договоры вкладов или имеющим действующие вклады.
        `
  }
], Ho = {
  END: "end",
  QUARTAL: "quartal",
  MONTH: "month",
  YEAR: "year",
  HALF_YEAR: "half_year"
}, sn = {
  capitalization: !1,
  replenishment: !1,
  pensionary: !1,
  partialWithdrawal: !1,
  forPayroll: !1,
  allowance: !1,
  expenseTransactions: !1,
  depositAmount: 25e3,
  depositPeriod: 3,
  onlineOpening: !1,
  offlineOpening: !0
}, Uo = [
  {
    label: "Онлайн",
    value: Lt.ONLINE
  },
  {
    label: "Офис",
    value: Lt.OFFLINE
  }
], zo = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  INITIAL_FILTERS: sn,
  INTEREST_PAYMENT_TYPES: Ho,
  OPENING_DEPOSIT_PLACES_OPTIONS: Uo,
  capitalizationOptions: nn,
  depositAmountOptions: zi,
  depositOptions: Yo,
  depositTermOptions: Wi
}, Symbol.toStringTag, { value: "Module" }));
var Wo = function() {
  var t = this, n = t.$createElement, i = t._self._c || n;
  return i("div", {
    staticClass: "deposit-calculator"
  }, [i("div", {
    staticClass: "deposit-calculator-inputs"
  }, [i("UIInputWithProgress", {
    staticClass: "deposit-calculator-input",
    attrs: {
      options: t.depositAmountOptions
    },
    on: {
      input: t.filtrateDeposits
    },
    model: {
      value: t.filterOptions.depositAmount,
      callback: function(r) {
        t.$set(t.filterOptions, "depositAmount", r);
      },
      expression: "filterOptions.depositAmount"
    }
  }), i("UIInputWithProgress", {
    staticClass: "deposit-calculator-input",
    attrs: {
      readonly: "",
      options: t.depositTermOptions
    },
    on: {
      input: t.filtrateDeposits
    },
    model: {
      value: t.filterOptions.depositPeriod,
      callback: function(r) {
        t.$set(t.filterOptions, "depositPeriod", r);
      },
      expression: "filterOptions.depositPeriod"
    }
  }), i("UIRadio", {
    attrs: {
      options: t.depositCalculatorModel.OPENING_DEPOSIT_PLACES_OPTIONS,
      title: "Место открытия",
      horizontal: ""
    },
    on: {
      input: t.onInputDepositPlace,
      change: t.modifyAndFilterDeposits
    },
    model: {
      value: t.openingDepositPlace,
      callback: function(r) {
        t.openingDepositPlace = r;
      },
      expression: "openingDepositPlace"
    }
  }), t._m(0), i("transition", {
    attrs: {
      name: "fade"
    }
  }, [i("UISelect", {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: t.filterOptions.capitalization,
      expression: "filterOptions.capitalization"
    }],
    staticClass: "deposit-calculator-select",
    attrs: {
      name: "capitalization",
      options: Object.values(t.depositCalculatorModel.capitalizationOptions),
      placeholder: "Периодичность выплаты/начисления %"
    },
    on: {
      selected: t.onSelectInterestPaymentHandler
    },
    model: {
      value: t.interestPayment,
      callback: function(r) {
        t.interestPayment = r;
      },
      expression: "interestPayment"
    }
  })], 1), i("div", {
    staticClass: "deposit-calculator-checkboxes"
  }, t._l(t.depositCalculatorModel.depositOptions, function(r) {
    var u = r.title, c = r.hint, h = r.key;
    return i("div", {
      key: u + h,
      staticClass: "deposit-calculator-checkbox"
    }, [i("div", {
      staticClass: "deposit-calculator-checkbox__discription"
    }, [i("label", {
      staticClass: "deposit-calculator-checkbox__label"
    }, [t._v(t._s(u))]), c ? i("div", {
      staticClass: "deposit-calculator-checkbox__hint"
    }, [i("span", [t._v("?")]), i("p", {
      staticClass: "deposit-calculator-checkbox__hint-text",
      domProps: {
        innerHTML: t._s(c)
      }
    })]) : t._e()]), i("UIToggle", {
      staticClass: "deposit-calculator-checkbox__toggle",
      attrs: {
        label: u,
        hint: c
      },
      on: {
        input: t.filtrateDeposits
      },
      model: {
        value: t.filterOptions[h],
        callback: function(p) {
          t.$set(t.filterOptions, h, p);
        },
        expression: "filterOptions[key]"
      }
    })], 1);
  }), 0)], 1), i("CalculationResult", {
    attrs: {
      "button-label": "Подобрать"
    },
    on: {
      "result-click": function(r) {
        return t.$emit("pickup-deposit", t.filtredDeposits, !0);
      }
    },
    scopedSlots: t._u([{
      key: "schema",
      fn: function() {
        return [t.bestDeposit ? i("DepositCalculatorSchema", {
          attrs: {
            "output-values": t.bestDeposit
          }
        }) : i("p", {
          staticClass: "deposit-calculator__empty"
        }, [t._v(" Не найдено вкладов, соответствующих указанным параметрам ")])];
      },
      proxy: !0
    }])
  })], 1);
}, qo = [function() {
  var t = this, n = t.$createElement, i = t._self._c || n;
  return i("div", {
    staticClass: "deposit-calculator-info"
  }, [i("span", {
    staticClass: "deposit-calculator-info-icon"
  }, [t._v(" i ")]), i("p", [t._v(" Онлайн выгоднее ")])]);
}];
const Go = gn({
  name: "DepositCalculator",
  components: {
    CalculationResult: da,
    DepositCalculatorSchema: No,
    UIToggle: Fs,
    UIInputWithProgress: Rr,
    UISelect: qs,
    UIRadio: Js
  },
  props: {
    deposits: {
      type: Array,
      required: !0
    },
    defaultDeposit: {
      type: String,
      default: ""
    }
  },
  emits: ["pickup-deposit"],
  setup(t, n) {
    const i = Ue(Kt(Lt.ONLINE)), r = Ue(Kt(nn.all)), u = Ue([]), c = Ue([]), h = Ue(null), p = Ue(Gt(kt({}, Kt(sn)), {
      onlineOpening: !0,
      offlineOpening: !1
    })), f = cn(() => x(t.defaultDeposit, t.deposits)), v = cn(() => {
      var y, V, F, U;
      return t.defaultDeposit ? Gt(kt({}, Kt(zi)), {
        min: (V = (y = f.value) == null ? void 0 : y.minDepositAmount) != null ? V : zi.min,
        max: (U = (F = f.value) == null ? void 0 : F.maxDepositAmount) != null ? U : zi.max
      }) : Kt(zi);
    }), P = cn(() => {
      var y, V, F, U;
      return t.defaultDeposit ? Gt(kt({}, Kt(Wi)), {
        min: (V = (y = f.value) == null ? void 0 : y.minDepositPeriod) != null ? V : Wi.min,
        max: (U = (F = f.value) == null ? void 0 : F.maxDepositPeriod) != null ? U : Wi.max
      }) : Kt(Wi);
    });
    function x(y, V) {
      if (!y || !(V != null && V.length))
        return null;
      const F = V.filter((N) => N.slug === y), U = F != null && F.length ? F.reduce((N, { options: z }) => {
        var Z;
        return (Z = Object.keys(N)) != null && Z.length ? (N = Object.fromEntries(
          Object.entries(N).map(([j, E]) => {
            const J = [...E, z[j]].filter((nt) => nt !== null);
            return (j.startsWith("min") || j.startsWith("max")) && J.length > 1 && J.sort((nt, M) => j.startsWith("min") ? nt - M : M - nt), [j, [...new Set(J)]];
          })
        ), N) : (N = Object.fromEntries(
          Object.entries(z).map(([j, E]) => [j, [E]])
        ), N);
      }, {}) : null;
      return U ? Object.entries(U).reduce((N, [z, Z]) => {
        const [j] = Z;
        return N[z] = j, z === "offlineOpening" && j ? N.openingType = Lt.OFFLINE : z === "onlineOpening" && j && (N.openingType = Lt.ONLINE), N;
      }, {}) : null;
    }
    const O = hn(function() {
      var V;
      const y = {};
      for (const F in p.value)
        p.value[F] && (y[F] = p.value[F]);
      y.onlineOpening && !p.value.forPayroll && (y.forPayroll = !1), r.value !== nn.all && (y.interestPayment = Or({
        object: Kt(nn),
        value: r.value
      })), u.value = Io({ deposits: c.value, filterOptions: y }), n.emit("pickup-deposit", u.value), h.value = (V = u.value) != null && V.length ? Do(u.value) : null;
    }, 200), k = hn(function() {
      const y = Kt(t.deposits);
      if (i.value === Lt.OFFLINE) {
        c.value = b({ deposits: y });
        return;
      }
      if (p.value.forPayroll) {
        c.value = b({
          deposits: y,
          openingType: Lt.ONLINE,
          rateType: ln.CLIENT_RATE
        });
        return;
      }
      c.value = b({
        deposits: y,
        openingType: Lt.ONLINE
      });
    }, 150);
    function T() {
      k(), O();
    }
    function b({
      deposits: y,
      openingType: V = Lt.OFFLINE,
      rateType: F = ln.DEFAULT_RATE
    }) {
      return y.map((U) => Ao({
        deposit: U,
        openingType: V,
        rateType: F
      }));
    }
    function C(y) {
      p.value.offlineOpening = y === Lt.OFFLINE, p.value.onlineOpening = y === Lt.ONLINE, T();
    }
    function A(y) {
      r.value = y, O();
    }
    return qi(() => t.deposits, T, { immediate: !0 }), qi(() => p.value.forPayroll, T), qi(f, (y) => {
      var V;
      y && ((V = Object.keys(y)) != null && V.length) && (p.value.depositAmount = y.minDepositAmount || sn.depositAmount, p.value.depositPeriod = y.minDepositPeriod || sn.depositPeriod, i.value = y.openingType, C(y.openingType));
    }, { deep: !0, immediate: !0, flush: "post" }), {
      depositCalculatorModel: zo,
      interestPayment: r,
      filtredDeposits: u,
      bestDeposit: h,
      openingDepositPlace: i,
      modifiedDeposits: c,
      filterOptions: p,
      depositAmountOptions: v,
      depositTermOptions: P,
      defaultDepositOptions: f,
      onInputDepositPlace: C,
      onSelectInterestPaymentHandler: A,
      filtrateDeposits: O,
      modifyAndFilterDeposits: T
    };
  }
}), ts = {};
var Ko = /* @__PURE__ */ rt(
  Go,
  Wo,
  qo,
  !1,
  Zo
);
function Zo(t) {
  for (let n in ts)
    this[n] = ts[n];
}
const Hl = /* @__PURE__ */ function() {
  return Ko.exports;
}();
var Xo = function() {
  var t = this, n = t.$createElement, i = t._self._c || n;
  return i("svg", t._g({ attrs: { xmlns: "http://www.w3.org/2000/svg", width: "24", height: "24", fill: "none", viewBox: "0 0 24 24" } }, t.$listeners), [i("path", { attrs: { fill: "#8B8B8F", d: "M18.778 6.444V3.111c0-.611-.5-1.111-1.111-1.111H6.556c-.612 0-1.112.5-1.112 1.111v3.333zM19.889 7.556H4.333A3.33 3.33 0 0 0 1 10.889v5.556c0 .61.5 1.11 1.111 1.11h3.333v2.223C5.444 21 6.444 22 7.667 22h8.889c1.222 0 2.222-1 2.222-2.222v-2.222h3.333c.611 0 1.111-.5 1.111-1.111v-5.556a3.33 3.33 0 0 0-3.333-3.333m-3.333 12.222h-8.89v-4.445h8.89zm2.222-7.222c-.611 0-1.111-.5-1.111-1.111 0-.612.5-1.112 1.11-1.112.612 0 1.112.5 1.112 1.112 0 .61-.5 1.11-1.111 1.11" } })]);
};
const Qo = {
  render: Xo
}, Jo = ["m4", "cumulative-m4"], tl = {
  1: 31,
  2: 62,
  3: 92,
  4: 122,
  5: 155,
  6: 182,
  12: 367
};
function el(t, n) {
  let i = 1, r = 1;
  return {
    generateLabel(u, c) {
      const { rateValidityPeriod: h } = u[c], p = tl[h];
      return Jo.includes(n.slug) && p ? `${p} ${_n({ word: "день|дня|дней", number: p })}` : h === 3 ? `${c + 1}${t.quartal}` : h === 6 ? `${c < 2 ? i++ : ++i}${t.halfYear}` : `${c < 1 || u.length <= 3 ? r++ : ++r}${t.year}`;
    }
  };
}
const il = 4, nl = 3, sl = (t) => t.rates.length <= il ? !1 : t.rates.filter(({ rateValidityPeriod: n }) => n === nl).every(({ rate: n }, i, r) => n === r[0].rate), pn = 3, rl = 12, al = (t) => {
  let n = Kt(t.calculationResult);
  const i = Kt(t.rates), r = {
    depositIncome: n[0].depositIncome,
    depositPercentAmount: n[0].depositPercentAmount,
    actualDepositYield: n[0].actualDepositYield,
    fullDepositCost: n[0].fullDepositCost,
    mgs: n[0].mgs,
    totalDepositPercents: n[0].totalDepositPercents
  };
  return n.forEach(({ depositPercentAmount: u }, c) => {
    c !== 0 && c <= pn && (r.depositIncome += u, r.depositPercentAmount += u);
  }), n = [r, ...n.slice(pn + 1)], i.splice(0, pn), i[0].rateValidityPeriod = rl, Gt(kt({}, t), {
    calculationResult: n,
    rates: i
  });
};
var ol = function() {
  var t = this, n = t.$createElement, i = t._self._c || n;
  return t.depositsTableData.tbody && t.depositsTableData.tbody.length ? i("div", {
    ref: "depositsResultRef",
    staticClass: "deposits-table"
  }, [i("div", {
    attrs: {
      id: "section-to-print"
    }
  }, [i("h3", {
    staticClass: "deposits-table__title"
  }, [t._v("Подходящие программы")]), i("UITable", {
    staticClass: "deposits-table-content",
    attrs: {
      "table-data": t.depositsTableData
    }
  })], 1), i("div", {
    staticClass: "deposits-table__info"
  }, [t._m(0), i("UIButton", {
    staticClass: "deposits-table__print",
    attrs: {
      flat: "",
      "icon-position": "left"
    },
    nativeOn: {
      click: function(r) {
        return t.onPrintHandler.apply(null, arguments);
      }
    },
    scopedSlots: t._u([{
      key: "icon",
      fn: function() {
        return [i("PrintSvg")];
      },
      proxy: !0
    }], null, !1, 2894479024)
  })], 1)]) : t._e();
}, ll = [function() {
  var t = this, n = t.$createElement, i = t._self._c || n;
  return i("div", {
    staticClass: "deposits-table__info-notes"
  }, [i("p", {
    staticClass: "deposits-table__note"
  }, [t._v(" *Фактическая доходность — ставка с учетом капитализации (в процентах годовых), рассчитывается от начала срока действия договора вклада до конца каждого периода, указывается справочно. ")]), i("p", {
    staticClass: "deposits-table__note"
  }, [t._v(" **Калькулятор позволяет рассчитать примерную сумму процентов. ")])]);
}];
const ul = {
  quartal: "&nbsp;кв.",
  halfYear: "&#8209;е&nbsp;6&nbsp;мес.&nbsp;",
  year: "&nbsp;год&nbsp;"
}, cl = gn({
  name: "DepositResult",
  components: {
    PrintSvg: Qo,
    UITable: Jr,
    UIButton: ls
  },
  props: {
    deposits: {
      type: Array,
      required: !0
    },
    isScrollAllow: {
      type: Boolean,
      default: () => !1
    }
  },
  emits: ["scroll-end"],
  setup(t, n) {
    const i = As(null), r = Ue({
      thead: [
        "Вклад",
        "Годовая ставка",
        "Фактическая доходность*",
        "Сумма процентов**",
        "Общая сумма процентов"
      ],
      tbody: []
    });
    function u() {
      r.value.tbody = [];
      const f = t.deposits.flatMap((v) => p(
        sl(v) ? al(v) : v
      ));
      r.value.tbody.push(...f);
    }
    function c() {
      return Xi(this, null, function* () {
        var f;
        yield Ls(), (f = i.value) == null || f.scrollIntoView({ block: "start", behavior: "smooth" }), n.emit("scroll-end");
      });
    }
    function h() {
      window.print();
    }
    function p(f) {
      const { name: v, calculationResult: P, url: x, rates: O } = f, { generateLabel: k } = el(ul, f);
      return O.map(({ rate: T }, b) => {
        const { actualDepositYield: C, depositPercentAmount: A, totalDepositPercents: y } = P[b], V = b === 0, F = b === O.length - 1;
        return {
          row: [
            {
              td: V ? v : "",
              bold: !0,
              rowspan: V && O.length,
              link: {
                href: x,
                black: !0
              }
            },
            {
              // eslint-disable-next-line max-len
              td: `${k(O, b)}&nbsp;&#8211;&nbsp;${Mn(T.toFixed(2))}&#37;`,
              normal: !0
            },
            {
              td: `${Mn(C.toFixed(2))}&#37;`,
              normal: !0,
              rightAlign: !0
            },
            {
              td: `${ei(mn(A))}&nbsp;&#8381;`,
              normal: !0,
              rightAlign: !0
            },
            {
              td: F ? `${ei(mn(y))}&nbsp;&#8381;` : "",
              normal: !0,
              rightAlign: !0
            }
          ],
          borderBottom: F
        };
      });
    }
    return qi(() => t.deposits, u, { immediate: !0 }), qi(() => t.isScrollAllow, (f) => {
      f && c();
    }), {
      depositsResultRef: i,
      depositsTableData: r,
      onPrintHandler: h
    };
  }
}), es = {};
var dl = /* @__PURE__ */ rt(
  cl,
  ol,
  ll,
  !1,
  pl
);
function pl(t) {
  for (let n in es)
    this[n] = es[n];
}
const Ul = /* @__PURE__ */ function() {
  return dl.exports;
}();
function Ss(t) {
  t.forEach(({ variable: n, variableProp: i }) => {
    typeof document != "undefined" && document.documentElement.style.setProperty(n, i);
  });
}
const un = (t) => t && typeof t == "function" ? t() : !!t;
var fl = function() {
  var t = this, n = t.$createElement, i = t._self._c || n;
  return i("div", {
    staticClass: "main-slider__info"
  }, [t.isMainSlide ? i("link", {
    attrs: {
      rel: "preload",
      href: t.getSrc(t.slideImg),
      as: "image"
    }
  }) : t._e(), i("div", {
    staticClass: "main-slider__relative"
  }), i("div", {
    staticClass: "main-slider__img-wr"
  }, [t.slideVideos && !t.disableVideoInBanners && !t.isMobile ? [i("video", t._b({
    staticClass: "main-slider__video main-slider__video--desktop",
    attrs: {
      poster: t.getSrc(t.slideImg),
      src: t.slideVideos.desktop
    }
  }, "video", t.videoOptions, !1)), i("video", t._b({
    staticClass: "main-slider__video main-slider__video--mobile",
    attrs: {
      poster: t.getSrc(t.slideImgMobileVertical),
      src: t.slideVideos.mobile
    }
  }, "video", t.videoOptions, !1))] : i("picture", [t.slideImgMobileVertical ? i("source", {
    attrs: {
      media: "(max-width: 420px)",
      srcset: t.getSrc(t.slideImgMobileVertical),
      alt: t.imageAlt
    }
  }) : t._e(), t.slideImgMobile ? i("source", {
    attrs: {
      media: "(max-width: 540px)",
      srcset: t.getSrc(t.slideImgMobile),
      alt: t.imageAlt
    }
  }) : t._e(), t.slideImgTablet ? i("source", {
    attrs: {
      media: "(max-width: 780px)",
      srcset: t.getSrc(t.slideImgTablet),
      alt: t.imageAlt
    }
  }) : t._e(), i("img", {
    class: ["main-slider__img", {
      "relative-img": t.slideOptions.isRelative
    }],
    attrs: {
      src: t.getSrc(t.slideImg),
      alt: t.imageAlt,
      loading: t.isMainSlide ? "eager" : "lazy"
    }
  })])], 2), i("div", {
    class: ["main-slider__wrapper"].concat(t.containerClasses, [{
      "justify-center": !t.slideLinks.length
    }])
  }, [i("div", {
    class: ["main-slider__content", {
      "main-slider__content--center": !t.slideLinks.length,
      "main-slider__content--empty-value": !t.slideValue.length,
      "main-slider__content--big": t.slideOptions.bigContent,
      "main-slider__content--small": t.slideOptions.smallContent
    }]
  }, [t.slideOptions.isMainSlide || t.isMainSlide ? i("h1", {
    class: ["main-slider__title", {
      "main-slider__title--light": t.isLightText
    }],
    domProps: {
      innerHTML: t._s(t.slideTitle)
    }
  }) : i("h2", {
    class: ["main-slider__title", {
      "main-slider__title--light": t.isLightText
    }],
    domProps: {
      innerHTML: t._s(t.slideTitle)
    }
  }), t.slideLogo.src ? i("img", {
    staticClass: "main-slider__logo",
    attrs: {
      src: t.getSrc(t.slideLogo.src),
      alt: "logo"
    }
  }) : t._e(), t.slideDescription ? i("p", {
    class: ["main-slider__slide-description", {
      "main-slider__slide-description--light": t.isLightText
    }],
    domProps: {
      innerHTML: t._s(t.slideDescription)
    }
  }) : t._e(), t.slideValue.length ? i("div", {
    class: ["main-slider__cols-wr", {
      "empty-value": !t.slideValue[0].value,
      "main-slider__cols-wr--big": t.slideOptions.bigContent
    }]
  }, [t._l(t.slideValue, function(r) {
    var u = r.value, c = r.name, h = r.description, p = r.disclamer, f = r.additionalClasses;
    return [u || c ? i("div", {
      key: `${u}__${c}`,
      class: ["main-slider__col", {
        "main-slider__col--fixed": u
      }]
    }, [u ? i("p", {
      class: ["main-slider__value", {
        "main-slider__value--light": t.isLightText
      }],
      domProps: {
        innerHTML: t._s(u)
      }
    }) : t._e(), t.slideOptions.iconValue ? i("span", {
      staticClass: "main-slider__icon"
    }) : t._e(), c ? i("h4", {
      class: ["main-slider__value-name", {
        "empty-value": !u,
        "main-slider__value-name--light": t.isLightText,
        "empty-value_thin": t.slideOptions.emptyValueThin
      }]
    }, [i("span", {
      class: [{
        "main-slider__value-name--light": t.isLightText,
        "main-slider__value-name--small": t.slideOptions.isSmallText
      }],
      domProps: {
        innerHTML: t._s(c)
      }
    }), p ? [i("UIPopper", {
      staticClass: "ml-4",
      staticStyle: {
        display: "inline-flex",
        transform: "translateY(2px)"
      },
      attrs: {
        message: p,
        "is-html": ""
      }
    }, [i("div", {
      staticClass: "flex"
    }, [i("nuxt-img", {
      attrs: {
        src: "icons/info.svg",
        alt: "info",
        loading: "lazy"
      }
    })], 1)])] : t._e()], 2) : t._e()]) : t._e(), h ? i("div", {
      key: h,
      staticClass: "main-slider__col"
    }, [i("p", {
      class: ["main-slider__description"].concat(f),
      domProps: {
        innerHTML: t._s(h)
      }
    })]) : t._e()];
  }), t.slideOptions.footnote ? i("p", {
    staticClass: "main-slider__footnote main-slider__footnote--mobile",
    domProps: {
      innerHTML: t._s(t.slideOptions.footnote)
    }
  }) : t._e()], 2) : t._e()]), i("div", {
    staticClass: "main-slider-footer"
  }, [i("div", {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: t.slideLinks.length,
      expression: "slideLinks.length"
    }],
    class: ["main-slider__buttons", {
      "main-slider__buttons--light": t.isLightText,
      "main-slider__buttons--narrow": t.slideOptions.footnote
    }]
  }, t._l(t.slideLinks, function(r) {
    var u = r.id, c = r.link, h = r.linkFn, p = r.title, f = r.titleFn, v = r.additionalClasses, P = r.imageSrc, x = r.target;
    return i("a", {
      key: u,
      class: ["main-slider__btn", "cibButton"].concat(v),
      attrs: {
        href: c || h(t.route),
        target: x || t.slideOptions.target || "_blank",
        rel: t.slideOptions.rel || "noopener noreferrer"
      }
    }, [t._v(" " + t._s(p || f(t.route)) + " "), P ? i("nuxt-img", {
      class: ["main-slider__buttons-image"].concat(v),
      attrs: {
        src: P,
        alt: ""
      }
    }) : t._e()], 1);
  }), 0), t.slideOptions.footnote ? i("p", {
    class: ["main-slider__footnote main-slider__footnote--desktop", {
      "main-slider__footnote--narrow": t.slideOptions.narrowFootnote
    }],
    domProps: {
      innerHTML: t._s(t.slideOptions.footnote)
    }
  }) : t._e()])])]);
}, hl = [];
const ml = {
  name: "SlideItem",
  components: {
    UIPopper: bn
  },
  props: {
    slideImg: {
      type: String,
      default: () => ""
    },
    slideImgTablet: {
      type: String,
      default: () => ""
    },
    slideImgMobile: {
      type: String,
      default: () => ""
    },
    slideImgMobileVertical: {
      type: String,
      default: () => ""
    },
    imageAlt: {
      type: String,
      default: () => ""
    },
    slideTitle: {
      type: String,
      default: () => ""
    },
    slideValue: {
      type: Array,
      default: () => []
    },
    slideLinks: {
      type: Array,
      default: () => []
    },
    slideOptions: {
      type: Object,
      default: () => ({})
    },
    slideLogo: {
      type: Object,
      default: () => ({})
    },
    containerClasses: {
      type: Array,
      default: () => []
    },
    isMainSlide: {
      type: Boolean,
      default: () => !0
    },
    slideVideos: {
      type: Object,
      default: () => null
    },
    disableVideoInBanners: {
      type: Boolean,
      default: () => !1
    },
    isMobile: {
      type: Boolean,
      default: () => !1
    },
    slideDescription: {
      type: String,
      default: () => ""
    }
  },
  computed: {
    isLightText() {
      return un(this.slideOptions.light);
    },
    videoOptions() {
      const t = {
        muted: !0,
        autoplay: !0
      };
      return this.slideOptions.loop && (t.loop = !0), t;
    },
    imageOptions() {
      const t = { format: "webp", quality: "100" };
      return this.isMainSlide ? t : Gt(kt({}, t), {
        loading: "lazy"
      });
    },
    route() {
      return typeof this.$route != "undefined" ? this.$route : typeof window != "undefined" ? Gt(kt({}, window.location), {
        path: window.location.pathname
      }) : null;
    }
  },
  methods: {
    getSrc(t) {
      return typeof this.$img == "function" ? this.$img(t, this.imageOptions) : t;
    }
  }
}, is = {};
var _l = /* @__PURE__ */ rt(
  ml,
  fl,
  hl,
  !1,
  vl
);
function vl(t) {
  for (let n in is)
    this[n] = is[n];
}
const gl = /* @__PURE__ */ function() {
  return _l.exports;
}();
var yl = function() {
  var t = this, n = t.$createElement, i = t._self._c || n;
  return i("section", {
    staticClass: "main-slider slider-wrapper"
  }, [i("UISlider", {
    attrs: {
      id: `main-slider_${t._uid}`,
      options: t.swiperOption,
      slides: t.filteredSlidesData
    },
    scopedSlots: t._u([{
      key: "default",
      fn: function(r) {
        var u = r.slide;
        return [i("Slide", t._b({
          attrs: {
            "is-mobile": t.isMobile,
            "disable-video-in-banners": t.disableVideoInBanners
          }
        }, "Slide", u, !1))];
      }
    }, t.isSingleSlide ? null : {
      key: "navigation",
      fn: function() {
        return [i("div", {
          staticClass: "slider-wrapper"
        }, [i("div", {
          staticClass: "swiper-navigation"
        }, [i("div", {
          staticClass: "swiper-button-background swiper-button-background-prev"
        }, [i("div", {
          class: ["swiper-button-prev", `main-slider-button-prev_${t._uid}`],
          attrs: {
            slot: "button-prev"
          },
          slot: "button-prev"
        })]), i("div", {
          staticClass: "swiper-button-background swiper-button-background-next"
        }, [i("div", {
          class: ["swiper-button-next", `main-slider-button-next_${t._uid}`],
          attrs: {
            slot: "button-next"
          },
          slot: "button-next"
        })])])])];
      },
      proxy: !0
    }], null, !0)
  })], 1);
}, bl = [];
const Sl = {
  name: "MainSectionSlider",
  components: {
    Slide: gl,
    UISlider: cs
  },
  props: {
    slidesData: {
      type: Array,
      required: !0
    },
    additionalSettings: {
      type: Object,
      default: () => ({})
    },
    userRegion: {
      type: Object,
      default: () => ({})
    },
    disableVideoInBanners: {
      type: Boolean,
      default: () => !1
    },
    isMobile: {
      type: Boolean,
      default: () => !1
    }
  },
  computed: {
    isSingleSlide() {
      return this.slidesData.length === 1;
    },
    filteredSlidesData() {
      return this.slidesData.filter((t) => {
        var n, i, r;
        return (i = (n = t.slideOptions) == null ? void 0 : n.regions) != null && i.length ? this.userRegion ? (r = t.slideOptions) == null ? void 0 : r.regions.includes(this.userRegion.id) : !1 : t;
      });
    },
    swiperOption() {
      return kt({
        slidesPerView: 1,
        autoplay: {
          delay: 4e3
        },
        speed: 500,
        centeredSlides: !0,
        navigation: {
          nextEl: `.main-slider-button-next_${this._uid}`,
          prevEl: `.main-slider-button-prev_${this._uid}`
        },
        breakpoints: {
          0: {
            spaceBetween: 8,
            loop: !1
          },
          781: {
            spaceBetween: 0,
            loop: !this.isSingleSlide
          }
        }
      }, this.additionalSettings);
    }
  },
  methods: {
    slideChange() {
      var i, r;
      const t = un((r = (i = this.slidesData[this.mainSlider.realIndex]) == null ? void 0 : i.slideOptions) == null ? void 0 : r.light);
      Ss([
        {
          variable: "--crumbs-color",
          variableProp: t ? "#ffffff" : "#8D8D8D"
        },
        {
          variable: "--hovered-crumbs-color",
          variableProp: t ? "#ffffff" : "#01000C"
        }
      ]);
    }
  }
}, ns = {};
var xl = /* @__PURE__ */ rt(
  Sl,
  yl,
  bl,
  !1,
  $l
);
function $l(t) {
  for (let n in ns)
    this[n] = ns[n];
}
const zl = /* @__PURE__ */ function() {
  return xl.exports;
}();
var wl = function() {
  var t = this, n = t.$createElement, i = t._self._c || n;
  return i("div", {
    staticClass: "main-slider__info"
  }, [t.isMainSlide ? i("link", {
    attrs: {
      rel: "preload",
      href: t.getSrc(t.slideImg),
      as: "image"
    }
  }) : t._e(), i("div", {
    staticClass: "main-slider__relative"
  }), i("div", {
    staticClass: "main-slider__img-wr"
  }, [t.slideVideos && !t.disableVideoInBanners && !t.isMobile ? [i("video", t._b({
    staticClass: "main-slider__video main-slider__video--desktop",
    attrs: {
      poster: t.getSrc(t.slideImg),
      src: t.slideVideos.desktop
    }
  }, "video", t.videoOptions, !1)), i("video", t._b({
    staticClass: "main-slider__video main-slider__video--mobile",
    attrs: {
      poster: t.getSrc(t.slideImgMobileVertical),
      src: t.slideVideos.mobile
    }
  }, "video", t.videoOptions, !1))] : i("picture", [t.slideImgMobileVertical ? i("source", {
    attrs: {
      media: "(max-width: 420px)",
      srcset: t.getSrc(t.slideImgMobileVertical),
      alt: t.imageAlt
    }
  }) : t._e(), t.slideImgMobile ? i("source", {
    attrs: {
      media: "(max-width: 540px)",
      srcset: t.getSrc(t.slideImgMobile),
      alt: t.imageAlt
    }
  }) : t._e(), t.slideImgTablet ? i("source", {
    attrs: {
      media: "(max-width: 780px)",
      srcset: t.getSrc(t.slideImgTablet),
      alt: t.imageAlt
    }
  }) : t._e(), i("img", {
    class: ["main-slider__img", {
      "relative-img": t.slideOptions.isRelative
    }],
    attrs: {
      src: t.getSrc(t.slideImg),
      alt: t.imageAlt,
      loading: t.isMainSlide ? "eager" : "lazy"
    }
  })])], 2), i("div", {
    class: ["main-slider__wrapper"].concat(t.containerClasses, [{
      "justify-center": !t.slideLinks.length
    }])
  }, [i("div", {
    class: ["main-slider__content", {
      "main-slider__content--center": !t.slideLinks.length,
      "main-slider__content--empty-value": !t.slideValue.length,
      "main-slider__content--big": t.slideOptions.bigContent,
      "main-slider__content--small": t.slideOptions.smallContent
    }]
  }, [t.slideOptions.isMainSlide || t.isMainSlide ? i("h1", {
    class: ["main-slider__title", {
      "main-slider__title--light": t.isLightText
    }],
    domProps: {
      innerHTML: t._s(t.slideTitle)
    }
  }) : i("h2", {
    class: ["main-slider__title", {
      "main-slider__title--light": t.isLightText
    }],
    domProps: {
      innerHTML: t._s(t.slideTitle)
    }
  }), t.slideLogo.src ? i("img", {
    staticClass: "main-slider__logo",
    attrs: {
      src: t.getSrc(t.slideLogo.src),
      alt: "logo"
    }
  }) : t._e(), t.slideDescription ? i("p", {
    class: ["main-slider__slide-description", {
      "main-slider__slide-description--light": t.isLightText
    }],
    domProps: {
      innerHTML: t._s(t.slideDescription)
    }
  }) : t._e(), t.slideValue.length ? i("div", {
    class: ["main-slider__cols-wr", {
      "empty-value": !t.slideValue[0].value,
      "main-slider__cols-wr--big": t.slideOptions.bigContent
    }]
  }, [t._l(t.slideValue, function(r) {
    var u = r.value, c = r.name, h = r.description, p = r.disclamer, f = r.additionalClasses;
    return [u || c ? i("div", {
      key: `${u}__${c}`,
      class: ["main-slider__col", {
        "main-slider__col--fixed": u
      }]
    }, [u ? i("p", {
      class: ["main-slider__value", {
        "main-slider__value--light": t.isLightText
      }],
      domProps: {
        innerHTML: t._s(u)
      }
    }) : t._e(), t.slideOptions.iconValue ? i("span", {
      staticClass: "main-slider__icon"
    }) : t._e(), c ? i("h4", {
      class: ["main-slider__value-name", {
        "empty-value": !u,
        "main-slider__value-name--light": t.isLightText,
        "empty-value_thin": t.slideOptions.emptyValueThin
      }]
    }, [i("span", {
      class: [{
        "main-slider__value-name--light": t.isLightText,
        "main-slider__value-name--small": t.slideOptions.isSmallText
      }],
      domProps: {
        innerHTML: t._s(c)
      }
    }), p ? [i("UIPopper", {
      staticClass: "ml-4",
      staticStyle: {
        display: "inline-flex",
        transform: "translateY(2px)"
      },
      attrs: {
        message: p,
        "is-html": ""
      }
    }, [i("div", {
      staticClass: "flex"
    }, [i("nuxt-img", {
      attrs: {
        src: "icons/info.svg",
        alt: "info",
        loading: "lazy"
      }
    })], 1)])] : t._e()], 2) : t._e()]) : t._e(), h ? i("div", {
      key: h,
      staticClass: "main-slider__col"
    }, [i("p", {
      class: ["main-slider__description"].concat(f),
      domProps: {
        innerHTML: t._s(h)
      }
    })]) : t._e()];
  }), t.slideOptions.footnote ? i("p", {
    staticClass: "main-slider__footnote main-slider__footnote--mobile",
    domProps: {
      innerHTML: t._s(t.slideOptions.footnote)
    }
  }) : t._e()], 2) : t._e()]), i("div", {
    staticClass: "main-slider-footer"
  }, [i("div", {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: t.slideLinks.length,
      expression: "slideLinks.length"
    }],
    class: ["main-slider__buttons", {
      "main-slider__buttons--light": t.isLightText,
      "main-slider__buttons--narrow": t.slideOptions.footnote
    }]
  }, t._l(t.slideLinks, function(r) {
    var u = r.id, c = r.link, h = r.linkFn, p = r.title, f = r.titleFn, v = r.additionalClasses, P = r.imageSrc, x = r.target;
    return i("a", {
      key: u,
      class: ["main-slider__btn", "ui-button-new"].concat(v),
      attrs: {
        href: c || h(t.route),
        target: x || t.slideOptions.target || "_blank",
        rel: t.slideOptions.rel || "noopener noreferrer"
      }
    }, [t._v(" " + t._s(p || f(t.route)) + " "), P ? i("nuxt-img", {
      class: ["main-slider__buttons-image"].concat(v),
      attrs: {
        src: P,
        alt: ""
      }
    }) : t._e()], 1);
  }), 0), t.slideOptions.footnote ? i("p", {
    class: ["main-slider__footnote main-slider__footnote--desktop", {
      "main-slider__footnote--narrow": t.slideOptions.narrowFootnote
    }],
    domProps: {
      innerHTML: t._s(t.slideOptions.footnote)
    }
  }) : t._e()])])]);
}, Ol = [];
const Pl = {
  name: "SlideItem",
  components: {
    UIPopper: bn
  },
  props: {
    slideImg: {
      type: String,
      default: () => ""
    },
    slideImgTablet: {
      type: String,
      default: () => ""
    },
    slideImgMobile: {
      type: String,
      default: () => ""
    },
    slideImgMobileVertical: {
      type: String,
      default: () => ""
    },
    imageAlt: {
      type: String,
      default: () => ""
    },
    slideTitle: {
      type: String,
      default: () => ""
    },
    slideValue: {
      type: Array,
      default: () => []
    },
    slideLinks: {
      type: Array,
      default: () => []
    },
    slideOptions: {
      type: Object,
      default: () => ({})
    },
    slideLogo: {
      type: Object,
      default: () => ({})
    },
    containerClasses: {
      type: Array,
      default: () => []
    },
    isMainSlide: {
      type: Boolean,
      default: () => !0
    },
    slideVideos: {
      type: Object,
      default: () => null
    },
    disableVideoInBanners: {
      type: Boolean,
      default: () => !1
    },
    isMobile: {
      type: Boolean,
      default: () => !1
    },
    slideDescription: {
      type: String,
      default: () => ""
    }
  },
  computed: {
    isLightText() {
      return un(this.slideOptions.light);
    },
    videoOptions() {
      const t = {
        muted: !0,
        autoplay: !0
      };
      return this.slideOptions.loop && (t.loop = !0), t;
    },
    imageOptions() {
      const t = { format: "webp", quality: "100" };
      return this.isMainSlide ? t : Gt(kt({}, t), {
        loading: "lazy"
      });
    },
    route() {
      return typeof this.$route != "undefined" ? this.$route : typeof window != "undefined" ? Gt(kt({}, window.location), {
        path: window.location.pathname
      }) : null;
    }
  },
  methods: {
    getSrc(t) {
      return typeof this.$img == "function" ? this.$img(t, this.imageOptions) : t;
    }
  }
}, ss = {};
var Cl = /* @__PURE__ */ rt(
  Pl,
  wl,
  Ol,
  !1,
  Tl
);
function Tl(t) {
  for (let n in ss)
    this[n] = ss[n];
}
const Il = /* @__PURE__ */ function() {
  return Cl.exports;
}();
var Dl = function() {
  var t = this, n = t.$createElement, i = t._self._c || n;
  return i("section", {
    staticClass: "main-slider slider-wrapper"
  }, [i("UISlider", {
    attrs: {
      id: `main-slider_${t._uid}`,
      options: t.swiperOption,
      slides: t.filteredSlidesData
    },
    scopedSlots: t._u([{
      key: "default",
      fn: function(r) {
        var u = r.slide;
        return [i("Slide", t._b({
          attrs: {
            "is-mobile": t.isMobile,
            "disable-video-in-banners": t.disableVideoInBanners
          }
        }, "Slide", u, !1))];
      }
    }, t.isSingleSlide ? null : {
      key: "navigation",
      fn: function() {
        return [i("div", {
          staticClass: "slider-wrapper"
        }, [i("div", {
          staticClass: "swiper-navigation"
        }, [i("div", {
          staticClass: "swiper-button-background swiper-button-background-prev"
        }, [i("div", {
          class: ["swiper-button-prev", `main-slider-button-prev_${t._uid}`],
          attrs: {
            slot: "button-prev"
          },
          slot: "button-prev"
        })]), i("div", {
          staticClass: "swiper-button-background swiper-button-background-next"
        }, [i("div", {
          class: ["swiper-button-next", `main-slider-button-next_${t._uid}`],
          attrs: {
            slot: "button-next"
          },
          slot: "button-next"
        })])])])];
      },
      proxy: !0
    }], null, !0)
  })], 1);
}, kl = [];
const Ml = {
  name: "MainSectionSlider",
  components: {
    Slide: Il,
    UISlider: cs
  },
  props: {
    slidesData: {
      type: Array,
      required: !0
    },
    additionalSettings: {
      type: Object,
      default: () => ({})
    },
    userRegion: {
      type: Object,
      default: () => ({})
    },
    disableVideoInBanners: {
      type: Boolean,
      default: () => !1
    },
    isMobile: {
      type: Boolean,
      default: () => !1
    }
  },
  computed: {
    isSingleSlide() {
      return this.slidesData.length === 1;
    },
    filteredSlidesData() {
      return this.slidesData.filter((t) => {
        var n, i, r;
        return (i = (n = t.slideOptions) == null ? void 0 : n.regions) != null && i.length ? this.userRegion ? (r = t.slideOptions) == null ? void 0 : r.regions.includes(this.userRegion.id) : !1 : t;
      });
    },
    swiperOption() {
      return kt({
        slidesPerView: 1,
        autoplay: {
          delay: 4e3
        },
        speed: 500,
        centeredSlides: !0,
        navigation: {
          nextEl: `.main-slider-button-next_${this._uid}`,
          prevEl: `.main-slider-button-prev_${this._uid}`
        },
        breakpoints: {
          0: {
            spaceBetween: 8,
            loop: !1
          },
          781: {
            spaceBetween: 0,
            loop: !this.isSingleSlide
          }
        }
      }, this.additionalSettings);
    }
  },
  methods: {
    slideChange() {
      var i, r;
      const t = un((r = (i = this.slidesData[this.mainSlider.realIndex]) == null ? void 0 : i.slideOptions) == null ? void 0 : r.light);
      Ss([
        {
          variable: "--crumbs-color",
          variableProp: t ? "#ffffff" : "#8D8D8D"
        },
        {
          variable: "--hovered-crumbs-color",
          variableProp: t ? "#ffffff" : "#01000C"
        }
      ]);
    }
  }
}, rs = {};
var Al = /* @__PURE__ */ rt(
  Ml,
  Dl,
  kl,
  !1,
  Ll
);
function Ll(t) {
  for (let n in rs)
    this[n] = rs[n];
}
const Wl = /* @__PURE__ */ function() {
  return Al.exports;
}();
export {
  va as CalculationOutput,
  da as CalculationResult,
  Hl as DepositCalculator,
  Ul as DepositResults,
  gl as MainSectionSlide,
  Il as MainSectionSlideNew,
  zl as MainSectionSlider,
  Wl as MainSectionSliderNew,
  ls as UIButton,
  Bl as UIButtonNew,
  Nl as UICheckbox,
  Vl as UIDocument,
  Rl as UIExpand,
  Fl as UIInput,
  Rr as UIInputWithProgress,
  us as UILink,
  bn as UIPopper,
  Js as UIRadio,
  ar as UIRangeSlider,
  qs as UISelect,
  cs as UISlider,
  Jr as UITable,
  Fs as UIToggle,
  Cr as createExponentialInterval,
  Yl as depositConstants,
  el as generateDepositRatePeriodLabel,
  Ss as setCssVariablesProperty,
  Ao as setDepositRatesByOpeningType
};
